/// all the store logic and listeneres are here. The rest are just dumb Components. Makis was here. 2019
import { missionChangeEntries } from "./utils/missionChange"
import { useEffect, useState, useRef, useMemo } from "react"
import { getOrgRoleRate, getOrgRoleRateTime, getOrgBillRate, getOrgBillUnit } from "./utils/roleRates"
import { decompress, decrypt, compress, encrypt } from "./utils/cache-utils"
import { addDbItem, getDbItem, deleteEntireDb } from "./utils/idb-util"
import { touchProjectTasks } from "./utils/tt-task-groups"
import "./scss/font.scss"
import "./scss/base.scss"
import React from "react"
import { paginateAll } from "./services/api/utils"

import cx from "classnames"
import Loadable from "./comp/Loadable"
import { emailDomainToSamlProviderMap, getDomainFromEmail, isActiveDirectoryEmail } from "./comp/Utils"
import { getEncryptionKey } from "./utils/key-utils"
import { getOrgList } from "./services/api/v2/org"
import { getOrgPeopleLite, getOrgPeople, getOrgArchivedLite } from "./services/api/v2/orgPerson"
import { getActions } from "./services/api/v2/action"
import { getActionItems } from "./services/api/v2/actionItem"
import { getMissions } from "./services/api/v2/mission"
import { getMissionPeople } from "./services/api/v2/missionPerson"
import { toast, ToastContainer } from "react-toastify"
import IconLeave from "./comp/icons/IconLeave"
import { BsCalendar4Week } from "react-icons/bs"

import ReactGA from "react-ga4"
import Bubble from "./comp/Bubble"
import HeroDots from "./comp/HeroDots"


import uniqBy from "lodash/uniqBy"
import get from "lodash/get"
import pick from "lodash/pick"
import isEmpty from "lodash/isEmpty"
import uniq from "lodash/uniq"
import {
    CATCH_ALL_ID,
    isCatchAllAction,
    getBoardAction,
    getBoardPhase,
    getSectionActions,
    getSections,
    getSectionTaskAction,
    toActionChange,
    toSection,
} from "./utils/sections"


import upperFirst from "lodash/upperFirst"

import BarLoader from "react-spinners/BarLoader"
import update from "immutability-helper"
import {
    startOfWeek,
    endOfMonth,

    differenceInDays,
    subSeconds,
} from "date-fns"

import apiFile from "./services/file/file.api"
import api from "./services/api.service"
import { setFreeEmailList } from "./utils/freeEmail"
import { logError } from "./services/logging.service"
import IconSpeed from "./comp/icons/IconSpeed"
import Home from "./section/Home"
import Board from "./section/Board"

import { BsReceipt } from "react-icons/bs"
import FullScreen from "./comp/FullScreen"

import { motion, AnimatePresence } from "framer-motion"

import history, {
    addParam,
    addParams,
    removeParams,
    removeParam,
    getQ,
    getHash,
    removeQueryParam,
} from "./comp/History"
import { dateValidationPass, fitDateRange, getDatesRetry, getTimeUtc, isDateValid } from "./utils/dates"
import { announceEmailVerified, getSafeVerifyReturn, onEmailVerifiedElsewhere } from "./utils/emailVerify"
import {
    ensureNumber,
    darkThemes,
    makeHash,
    useDebouncedEffect,
    getErrorMsg,
    delay,
    isArchived,
    uniqPeople,
    formatError,
    isGtGr,
} from "./utils/utils"

import { updateBudgetOnRaciTasks } from "./utils/financials"
import { getLinePins, isEquipmentLine } from "./utils/equipment-demand"
import { getMovedMonthly } from "./utils/monthlyAmounts"
import {
    getCostLineDates,
    getHandEditPinnedTo,
    getMovedDates,
    getPinnedDates,
    getProjectMove,
    hasScheduleChange,
    isPinnedChange,
} from "./utils/pinned-dates"
import { getDateChangeBlock, isTaskDone } from "./utils/started-work"
import { getTaskMoves } from "./utils/task-budget-dates"
import EquipmentRefitNotice from "./comp/equipment/EquipmentRefitNotice"

import Tip from "./comp/Tip"
import Confirm from "./comp/Confirm"
import NewVersionPill from "./comp/NewVersionPill"
import DemoTourPill from "./comp/DemoTourPill"

import Card from "./comp/Card"

import isEmail from "validator/lib/isEmail"
import isMobilePhone from "validator/lib/isMobilePhone"
import {
    nextTuesday,
    nextMonday,
    addDays,
    addMonths,
    startOfDay,
    isAfter,
    isSameWeek,
    isThisWeek,
    endOfWeek,
    endOfDay,
    isBefore,
    isSaturday,
    isSunday,
    format,
} from "date-fns"

import { toZonedTime } from "date-fns-tz"

import { canAccessOrgSpace, assignPersonToRole } from "./comp/OrgUtils"

import { getRole } from "./comp/OrgGetRole"

import { getUserRequestId } from "./services/auth/auth.service"

//IMPORT APIS

import apiAuth, { samlSignInWithPopup } from "./services/auth/auth.api"
import apiAction from "./services/action/action.api"
import apiActionItem from "./services/actionItem/actionItem.api"
import { emitActionItemChanges, emitMissionDeleted } from "./services/actionItem/actionItemFeed"

import apiOrg from "./services/org/org.api"
import apiMission from "./services/mission/mission.api"
import apiPlanItems from "./services/planItems/planItems.api"
import notificationStore from "./services/notification/notificationStore"
import chatStore from "./services/chat/chatStore"
import SignOffView from "./comp/signOff/SignOffView"

import apiTemplate from "./services/template/template.api"

import "react-toastify/dist/ReactToastify.css"
import { IoClose } from "react-icons/io5"

import {
    PiLightningDuotone,
    PiHouseLight,
    PiMagnifyingGlassDuotone,
    PiLockDuotone,
    PiUsersThreeDuotone,
} from "react-icons/pi"

import { getMissionPerson, getAllActions, getAllActionItems } from "./comp/MissionUtils"
import {
    duplicateCostPlanItem,
    duplicateRaciRoles,
    reconcileCostItems,
    missionUpdateState as missionUpdateStateFor,
} from "./utils/mission"
import { commitState as commitComponentState, applySocketMessage as applySocketMessageTo } from "./utils/commitState"
import { buildDuplicateTask, getTaskCodePrefix, nextTaskCode } from "./utils/duplicateTask"
import { nextChecklistSortIndex } from "./utils/checklist"

import firebase from "./services/firebase.service"

import mojs from "@mojs/core"
import Drive from "./drive/Drive"
import { getObjectId, getRefId } from "./utils/utils"
import {
    applyActionItemChange,
    applyActionItemSocketChanges,
    getDanglingDependencyChanges,
    removeActionItemsFrom,
} from "./utils/actionItemTreeState"
import {
    applyActionSocketChanges,
    applyMissionSocketUpdates,
    applyPlanItemSocketChanges,
    withoutTaskIdLists,
} from "./utils/missionTreeSocketState"

import { getFullName } from "./comp/PeopleUtils"
import PanelNotification, { checkForClientPrograms } from "./comp/PanelNotification"
import ErrorBoundary from "./ErrorBoundary"
import { hasAppReconnected, unmountAppReconnect } from "./services/app-reconnect.service"

import { v4 as uniqid } from "uuid"

import { delAllExpiredCache } from "./utils/cache"
import { setCsrf, setSessionCookie } from "./services/session/session.api"

import { getMitsiMode } from "./services/admin/admin.api"

import axios from "axios"
import { syncProcessFlow } from "./utils/process"
import { getAiCode } from "./utils/actionItem"
import SpaceRocket from "./comp/SpaceRocket"

//CODE-SPLIT SOME MODULES

const MxAdmin = Loadable({
    loader: () => import("./comp/MxAdmin"),
    loading: () => <span />,
})

const MxCrm = Loadable({
    loader: () => import("./comp/MxCrm"),
    loading: () => <span />,
})

const SearchWidget = Loadable({
    loader: () => import("./comp/SearchWidget"),
    loading: () => <span />,
})

const ActionItem = Loadable({
    loader: () => import("./comp/ActionItem"),
    loading: () => <span />,
})

const GeneralAdmin = Loadable({
    loader: () => import("./comp/GeneralAdmin"),
    loading: () => <span />,
})

const CreateLeaveForOther = Loadable({
    loader: () => import("./comp/CreateLeaveForOther"),
    loading: () => <span />,
})
const CreateTimeForOther = Loadable({
    loader: () => import("./module/OrgTimeExports").then((module) => module.CreateTimeForOther),
    loading: () => <span />,
})

const CrudMission = Loadable({
    loader: () => import("./module/CrudMission"),
    loading: () => <span />,
})
const CreateMission = Loadable({
    loader: () => import("./comp/CreateMission"),
    loading: () => <span />,
})
const CreateBid = Loadable({
    loader: () => import("./comp/CreateBid"),
    loading: () => <span />,
})
const Power = Loadable({
    loader: () => import("./section/Power"),
    loading: () => <span />,
})

const SimplyX = Loadable({
    loader: () => import("./section/SimplyX"),
    loading: () => <span />,
})

const MxGanttMission = Loadable({
    loader: () => import("./section/MxGanttMission"),
    loading: () => <span />,
})

const BudgetPro = Loadable({
    loader: () => import("./comp/BudgetPro"),
    loading: () => <span />,
})

const MaxLauncher = Loadable({
    loader: () => import("./comp/maxAssistant/MaxLauncher"),
    loading: () => <span />,
})

const Chat = Loadable({
    loader: () => import("./comp/chat/Chat"),
    loading: () => <span />,
})

const Calendar = Loadable({ loader: () => import("./comp/Calendar"), loading: () => <span /> })

const MySpace = Loadable({
    loader: () => import("./section/MySpace"),
    loading: () => <span />,
})

const Org = Loadable({
    loader: () => import("./module/Org"),
    loading: () => <span />,
})
const CrudOrg = Loadable({
    loader: () => import("./module/CrudOrg"),
    loading: () => <span />,
})

const Login = Loadable({
    loader: () => import("./section/Login"),
    loading: () => <span />,
})

const VendorSetup = Loadable({
    loader: () => import("./comp/VendorSetup"),
    loading: () => <span />,
})

const CrApproval = Loadable({
    loader: () => import("./comp/CrApproval"),
    loading: () => <span />,
})

const InvoiceApproval = Loadable({
    loader: () => import("./comp/InvoiceApproval"),
    loading: () => <span />,
})

const Unsubscribe = Loadable({
    loader: () => import("./comp/Unsubscribe"),
    loading: () => <span />,
})

const Navigator = Loadable({
    loader: () => import("./comp/Navigator"),
    loading: () => <span />,
})

const TimeTracking = Loadable({ loader: () => import("./section/TimeTracking"), loading: () => <span /> })

const CreateTemplate = Loadable({
    loader: () => import("./comp/CreateTemplate"),
    loading: () => <span />,
})

const LeaveTracker = Loadable({ loader: () => import("./section/LeaveTracker"), loading: () => <span /> })

const ExpenseTrackerMe = Loadable({ loader: () => import("./comp/ExpenseTrackerMe"), loading: () => <span /> })

const PacmanLoader = Loadable({
    loader: () => import("react-spinners/PacmanLoader"),
    loading: () => <span />,
})

const RingLoader = Loadable({
    loader: () => import("react-spinners/RingLoader"),
    loading: () => <span />,
})

const RiseLoader = Loadable({
    loader: () => import("react-spinners/RiseLoader"),
    loading: () => <span />,
})

const Wfh = Loadable({
    loader: () => import("./comp/Wfh"),
    loading: () => <span />,
})

const MyReminders = Loadable({
    loader: () => import("./comp/reminder/MyReminders"),
    loading: () => <span />,
})

const OverdueFollowUp = Loadable({
    loader: () => import("./comp/virtualPm/OverdueFollowUp"),
    loading: () => <span />,
})

const FollowUpLanding = Loadable({
    loader: () => import("./comp/virtualPm/FollowUpLanding"),
    loading: () => <span />,
})
const CIRCLE_OPTS = {
    fill: "none",
    className: "mo-js-shape",
    radius: 25,
    strokeWidth: { 50: 0 },
    scale: { 0: 1 },
    duration: 500,
    left: 0,
    top: 0,
    easing: "cubic.out",
}

// The dependency fetch returns bare ids for linkFrom/linkTo, so we hydrate them from the mission
// tree for display. Cloning (rather than reusing the live tree object) keeps ai.dependencies from
// pointing at another actionItem that itself points back - a real reference cycle, not just a
// logical one, that crashes any later JSON.stringify of the tree.
const hydrateDepEnd = (aiMap, link) => {
    const hydrated = aiMap[getObjectId(link)]
    return hydrated ? { ...hydrated } : link
}

class App extends React.Component {
    constructor(props) {
        super(props)
        const me = this

        this.msgBeep = React.createRef()

        const qHash = getHash()
        const q = {
            ...getQ(),
            ...qHash,
        }

        this.taskMasterRef = React.createRef()
        this.taskMasterRefTasks = React.createRef()

        this.fetchedOrgs = {}
        this.isLaunched = true

        // Hygiene

        delAllExpiredCache().catch(() => {
            // Nothing
        })

        removeParams(
            "_v,hq,mc-org,diagnostic,mc-org-goal,make-template,create-proposal,myspace,mc,change-date,change-domains,hq-creating,mc-prop,org-cfg,oc-domains,oc-expenses,oc-offices,oc-departments,create-mission,leave-notice,invite-notice,"
        )

        // END Hygiene

        this.hasUnmounted = false
        this.hasAppReconnectedSocket = null

        this.state = {
            avKey: uniqid(),
            orgsFetchedData: [],
            person: {},
            orgs: [],
            missions: [],
            showLeaveTracker: false,
            showExpenseTracker: false,
            phases: [],
            actions: [],
            missionChange: {},
            orgChange: {},
            fileSelected: null,
            fileSelectedList: null,
            // ?sign-off=<id>&org=<orgId>: a sign-off opened on its own (an email, a notification)
            showSignOff: null,
            // My reminders (comp/reminder/MyReminders): mAX's my_reminders, or ?reminders=open
            showReminders: false,
            // ?follow-up=<id>&follow-up-org=<orgId>: the Virtual PM's question about an overdue task
            showFollowUp: null,
            notificationOpen: false,
            mfaDisabledMissions: [],
            mfaDisabledOrgs: [],
            mfaRequiredMsg: false,
            activityList: [],
            helpIndex: 1,
            loadingBlockerLoader: "bar",
            // mAX's panel. Here rather than inside MaxLauncher so anything can
            // open the assistant (a screen's own mAX button does).
            maxOpen: false,
            // Whether this person has mAX at all. MaxLauncher owns the gate and
            // publishes it here, so nothing else has to ask a second time.
            maxAvailable: false,
            // A line for mAX to open a fresh chat on, from a screen's own button
            // ({text, at}). MaxChat shows it and clears it; it is never sent.
            maxGreeting: null,
            // The organisation picked in the new project wizard (CreateMission), so
            // mAX's credits and context follow it there.
            createMissionOrg: null,
        }

        switch (q["mode"]) {
            // Firebase
            case "resetPassword":
                return me.flowResetPassword()
            case "recoverEmail":
                return me.flowRecoverEmail()
            // Vendor magic-link onboarding - no Firebase account exists for the
            // vendor, so this skips the auth listeners below entirely, same as
            // the two cases above.
            case "vendorOnboarding":
                return me.flowVendorOnboarding()
            // Invoice-approver magic-link - same no-Firebase-account rationale as
            // vendorOnboarding above (a PM/approver clicking an emailed link doesn't
            // necessarily have a missionX login session active).
            case "invoiceApproval":
                return me.flowInvoiceApproval()
            // Change request sign-off magic link - the approver may be a client
            // with no missionX account, same as invoiceApproval above.
            case "crApproval":
                return me.flowCrApproval()
            // Email unsubscribe links: the page opens over the app, which loads as
            // usual underneath (these people have accounts, unlike vendors). Signed
            // out, the login redirect waits until the page is closed.
            case "unsubscribe":
                me.flowUnsubscribe()
                break
            // The Virtual PM's emailed "Done!" / "Approve" links: the same page over
            // the app, signed in or not; the page posts the answer.
            case "followUp":
                me.flowFollowUpLink()
                break
        }

        this.actionItemTO = 0

        this.unsubscribeFromIdTokenChanges = firebase.auth().onIdTokenChanged(async (user) => {
            // User is signed in, signed out or token was refreshed.
            try {
                if (user) {
                    await setCsrf()
                    await setSessionCookie()
                } else {
                    // Cannot revoke, user already logged out
                }
            } catch (err) {}
        })

        // Firebase reads the signed-in user from IndexedDB. If that database can't open (a tab
        // still running an older build can hold it), onAuthStateChanged never fires at all and
        // nothing else would ever tell the user. Say so instead of spinning forever.
        this.authWatchdog = setTimeout(() => {
            this.authWatchdogToast = toast.warning(
                "Still loading... If missionX is open in other tabs, close them and click here to reload.",
                { autoClose: false, onClick: () => window.location.reload() }
            )
        }, 15000)

        this.unsubscribeFromAuthStateChanged = firebase.auth().onAuthStateChanged(async (authorized) => {
            clearTimeout(this.authWatchdog)
            // Answered late (slow connection): take the warning back down.
            if (this.authWatchdogToast) {
                toast.dismiss(this.authWatchdogToast)
                this.authWatchdogToast = null
            }

            if (authorized) {
                if (this.pendingLogoutRedirect) {
                    clearTimeout(this.pendingLogoutRedirect)
                    this.pendingLogoutRedirect = null
                }

                // 1. FIX: Pause instead of returning if the tab is hidden.
                // This stops background tabs from executing, but ensures they resume when brought to the front.
                if (document.hidden && q["mode"]) {
                    await new Promise((resolve) => {
                        const onVisible = () => {
                            if (!document.hidden) {
                                document.removeEventListener("visibilitychange", onVisible)
                                resolve()
                            }
                        }
                        document.addEventListener("visibilitychange", onVisible)
                    })
                }

                // The profile doubles as the auth check: /people/profile sits behind the same
                // auth middleware as /auth/verify/ping, so it answers with the same codes and
                // saves the app a round trip before it can show anything.
                let profile
                try {
                    // A blip (network, cold start, a 5xx) gets a few more goes before we
                    // treat it as an answer; the explicit auth codes below are answers already.
                    for (let attempt = 0; ; attempt++) {
                        try {
                            profile = await apiAuth.getProfile()
                            break
                        } catch (err) {
                            const isAnswer = [
                                "auth/invalid-provider",
                                "auth/sso-not-authorized",
                                "auth/sso-required",
                                "auth/failed",
                                "auth/gt-inactive",
                            ].includes(err?.code)
                            if (isAnswer || attempt >= 2) throw err
                            await new Promise((resolve) => setTimeout(resolve, 1000 * 2 ** attempt))
                        }
                    }
                } catch (err) {

                    if (["auth/invalid-provider", "auth/sso-not-authorized", "auth/sso-required"].includes(err?.code)) {
                        const errorMessages = {
                            "auth/invalid-provider":
                                "The provider you selected to login with does not match an authorized organization.",
                            "auth/sso-not-authorized":
                                "The provider you selected to login with does not have an authorized organization.",
                            "auth/sso-required": "A single sign on provider is required to access your organization.",
                        }

                        const message = errorMessages[err?.code]

                        if (message) {
                            toast.warning(
                                <>
                                    <p>Ooops! {message}</p>
                                    <p>Please contact your organization admin or help@missionx.ai</p>
                                    <p className="dna-smaller-text dna-light-text">
                                        Error code: {err?.code || err?.message || "Not found"}
                                    </p>
                                </>,
                                {
                                    autoClose: false,
                                    onClose: () => {
                                        try {
                                            this.personSignOut(true)
                                        } catch (e) {
                                            window.location.reload(true)
                                        }
                                    },
                                }
                            )
                        }
                        setTimeout(() => {
                            try {
                                this.personSignOut()
                            } catch (err) {}
                        }, 7000)
                    } else if (["auth/failed", "auth/gt-inactive"].includes(err?.code)) {
                        // No usable token (revoked, disabled, signed out elsewhere): this
                        // session is over. Anything else may be the server's own trouble, and
                        // signing out wipes local data - so those only get the retry toast.
                        this.personSignOut()
                    } else {
                        // Never leave "Preparing workspace" spinning with no way out.
                        toast.error(
                            "Oops. We couldn't reach missionX. Click here to try again, or contact help@missionx.ai if it keeps happening.",
                            { autoClose: false, onClick: () => window.location.reload() }
                        )
                        this.silentFail("dkrjjwjjwjw" + (err?.code || err?.message))
                    }
                    return
                }

                setCookie("mission-x-active-login", "true", 60)
                if (me.preAuthHistoryListener) me.preAuthHistoryListener()

                if (!this.hasAppReconnectedSocket) {
                    // Listen only once
                    this.hasAppReconnectedSocket = hasAppReconnected((offlineMs) => {
                        // Don't run the callback if component has been unmounted
                        if (!this.hasUnmounted) {
                            try {
                                if (offlineMs >= 300000) {
                                    console.log("Sockets were disconnected for about " + offlineMs / 1000 + "s.")
                                    me.loadDataOrgs()
                                }
                            } catch (err) {
                                console.error("Failed to update state", err)
                            }
                        }
                    })
                }

                if (process.env.REACT_APP_ENV === "prod") {
                    ReactGA.initialize("G-GNWFCEYWW1")
                }

                this.setState({
                    multiFactor: authorized.multiFactor?.enrolledFactors[0],
                })

                if (["mike@missionx.ai", "makis@missionx.ai"].includes(authorized.email)) {
                    this.setState({
                        isUserMxAdmin: true,
                    })
                    getMitsiMode()
                        .then((mitsi) => {
                            if (mitsi?.on === true) {
                                setTimeout(() => {
                                    toast.warn(`You are currently on mitsi mode.`, { autoClose: 100 })
                                }, 3000)
                            }
                        })
                        .catch((err) => {
                            // Safety
                        })
                }

                // 2. Await verification flows before triggering page init/loads
                if (q["mode"]) {
                    switch (q["mode"]) {
                        case "verifyEmail":
                            await me.flowVerifyEmail()
                            break
                        case "verifyAndChangeEmail":
                            await me.flowVerifyAndChangeEmail()
                            break
                        case "verifyEmailSecondary":
                            await me.flowVerifyEmailSecondary()
                            break
                    }
                }

                // The verify flows change the person on the server, so the profile fetched
                // before them is stale: those fetch it again.
                const verified = ["verifyEmail", "verifyAndChangeEmail", "verifyEmailSecondary"].includes(q["mode"])
                me.personAuthInit(verified ? undefined : profile)

                if (q["from"] === "mentionEmail" && !!q["room"] && !!q["roomName"]) {
                    const params = []
                    if (q["roomName"] === "ActionItem") {
                        params.push({ param: "action-item", value: q["room"] })
                    }
                    removeParams(["from", "room", "roomName"].join(","))
                    addParams(params)
                }

                me.loadAll()
                me.authHistoryListener = history.listen((location, action) => me.routing())
            } else {
                // 3. Unauthenticated branch
                // FIX: Firebase's cross-tab persistence sync can lag a beat when a second
                // tab opens right after another tab signs in/up (e.g. clicking a verify-email
                // link right after account creation). A bare `null` here isn't always a real
                // logout - it can be this tab momentarily not having caught up yet. Debounce
                // briefly so a follow-up "authorized" callback can cancel the redirect.
                if (this.pendingLogoutRedirect) {
                    clearTimeout(this.pendingLogoutRedirect)
                }

                this.pendingLogoutRedirect = setTimeout(() => {
                    this.pendingLogoutRedirect = null

                    // The unsubscribe and follow-up link pages work signed out; login comes when they close.
                    if (this.state.unsubscribe || this.state.followUpLink) return

                    if (this.hasUnmounted) return

                    this.setState({
                        login: true,
                    })

                    if (!window.location.pathname.includes("/login")) {
                        // Leave clearSiteData REMOVED so Firebase can read the auth token across tabs
                        window.location = "/login" + window.location.search
                    }

                    if (q["mode"] && (q.mode === "verifyEmail" || q.mode === "verifyEmailSecondary")) {
                        setTimeout(() => {
                            toast("Awesome! Let's login and get you verified. 🦋", {
                                autoClose: 8000,
                            })
                        }, 600)
                    }
                }, 700)
            }
        })
    }

    setLocal = (ignoreToast) => {
        const me = this

        axios
            .get("https://api.bigdatacloud.net/data/ip-geolocation?key=759b615e643048409fc401ffc9a67b46")
            .then((res) => {
                const d = res.data
                const p = me.state.person
                // Approximate (IP) coordinates - maps open on them, no geocoding needed.
                const geo =
                    Number.isFinite(d.location?.latitude) && Number.isFinite(d.location?.longitude)
                        ? { lat: d.location.latitude, lng: d.location.longitude }
                        : undefined

                if (
                    d.country.isoAlpha2 === p.country &&
                    d.location.principalSubdivision === p.state &&
                    (p.geo?.lat !== undefined || !geo)
                ) {
                    if (!ignoreToast) {
                        toast("Your location appears the same. Please make sure you are not using a VPN.")
                    }

                    return
                }

                me.personUpdate({
                    country: d.country.isoAlpha2,
                    city: null,
                    state: d.location.principalSubdivision,
                    timezone: d.location.timeZone.ianaTimeId,
                    ...(geo ? { geo } : {}),
                }).then((r) => {})
            })
    }
    silentFail(error, data = {}) {
        clearTimeout(this.silentFailTo)
        this.silentFailTo = setTimeout(() => {
            logError("11 " + error, data)
        }, 100)
    }
    /**
     * Loads the notifications (services/notification/notificationStore.js) and
     * follows their changes. Called again after an invite is handled.
     */
    loadLatestNotifications() {
        const orphanCheck = checkForClientPrograms(this)

        notificationStore.connect()
        // Chat's unread badge, and its live updates (services/chat/chatStore.js)
        chatStore.start()

        return notificationStore.start({
            extraUnseen: (orphanCheck?.orphans || 0) + ensureNumber(this.state.missingTimesheets),
        })
    }
    refuseCookies() {
        this.setState({
            showCookies: false, //this is just to show the cookie banner
        })
        localStorage.setItem(
            "dna-accept-cookie",
            JSON.stringify({
                rejected: true,
            })
        )
    }
    acceptCookies() {
        this.setState({
            showCookies: false,
        })

        localStorage.setItem(
            "dna-accept-cookie",
            JSON.stringify({
                accepted: true,
            })
        )
    }
    openExpensePanel() {
        this.setState({
            showExpenses: true,
            expensesForOther: null,
        })
    }
    /**
     * The same expense panel, pointed at somebody else - an administrator entering a
     * partner's expenses. Same card, same tracker; the tracker grows a person picker
     * under its title and files everything in that person's name.
     *
     * @param orgData {Object} The org to pick people from. Permission to act for someone
     *   is granted per org, so the tracker has to be told which one.
     * @param meInOrg {Object} The operator's own org person.
     * @param [onClose] {Function} Run when the panel is closed. The org expenses tab
     *   uses it to reload its grid, since anything entered in here is a new expense that
     *   belongs in that list.
     */
    openExpensePanelForOther(orgData, meInOrg, onClose) {
        this.setState({
            showExpenses: true,
            expensesForOther: { orgData, meInOrg, onClose },
        })
    }
    /**
     * Leaves and time for somebody else. These live up here rather than inside the
     * admin panel because opening one closes that panel, and anything owned by it
     * would unmount along with it - portal or not.
     *
     * @param orgData {Object} The org to pick people from.
     * @param meInOrg {Object} The operator's own org person, for the permission checks.
     */
    openLeavesPanelForOther(orgData, meInOrg) {
        this.setState({
            leavesForOther: { orgData, meInOrg },
        })
    }
    openTimePanelForOther(orgData, meInOrg) {
        this.setState({
            timeForOther: { orgData, meInOrg },
        })
    }
    initialStateLogic(q) {
        const me = this

        let state = {
            missions: [],
            phases: [],
            actions: [],
            person: {},
        }

        return state
    }
    flowResetPassword() {
        const q = getQ()
        const me = this

        apiAuth
            .signOut()
            .then(() => {
                apiAuth
                    .verifyPasswordResetCode(q.oobCode)
                    .then((res) => {
                        me.tempResetEmail = res
                        me.tempResetCode = q.oobCode

                        me.setState({
                            login: true,
                        })
                    })
                    .catch((err) => {
                        toast.error("🧐 So sorry but: " + err.message, {
                            position: "top-center",
                            autoClose: 6000,
                        })

                        this.silentFail("wekorheijled.sdseeeew" + err?.message)

                        history.push("/?login=open")

                        me.setState({
                            resetLoginStates: new Date().getTime(),
                            login: true,
                        })

                        me.forceUpdate()
                    })
            })
            .catch((err) => {
                throw err
            })
    }
    /**
     * Unlike flowResetPassword/flowRecoverEmail, makes no Firebase calls at
     * all - the vendor has no account. Just captures the token so render()
     * can show the VendorSetup FullScreen instead of the normal app shell.
     */
    flowVendorOnboarding() {
        const q = getQ()

        this.state = {
            ...this.state,
            vendorOnboarding: true,
            vendorOnboardingToken: q.token,
        }
    }
    /**
     * Same rationale as flowVendorOnboarding above - just stashes the token/intended
     * action so render() can show the InvoiceApproval FullScreen instead of the normal
     * app shell.
     */
    flowInvoiceApproval() {
        const q = getQ()

        this.state = {
            ...this.state,
            invoiceApproval: true,
            invoiceApprovalToken: q.token,
            invoiceApprovalAction: q.action,
        }
    }
    /**
     * Same as flowInvoiceApproval - stashes the token so render() shows the
     * CrApproval FullScreen instead of the app shell.
     */
    flowCrApproval() {
        const q = getQ()

        this.state = {
            ...this.state,
            crApproval: true,
            crApprovalToken: q.token,
        }
    }
    flowVerifyEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        const me = this
        let returnTo

        return apiAuth
            .verifyEmail(oobCode)
            .then((person) => {
                returnTo = getSafeVerifyReturn(person.verifyReturn)

                toast.success("Congratulations. You're now verified!", {
                    autoClose: 5000,
                })

                me.setState({
                    person: update(this.state.person, {
                        emailVerified: { $set: person.emailVerified },
                        emailList: { $set: person.emailList },
                    }),
                })
                announceEmailVerified(person)

                let toInvite = localStorage.getItem("dna-to-invite")

                if (toInvite) {
                    toInvite = JSON.parse(toInvite)?.toInvite || []
                } else {
                    toInvite = []
                }

                if (toInvite.length) {
                    localStorage.setItem(
                        "dna-to-invite",
                        JSON.stringify({
                            toInvite: [],
                        })
                    )

                    const metadata = {
                        config: {
                            permission: 2,
                        },
                        message: "Help manage our missionX workspace.",
                    }

                    toInvite.forEach((ti, i) => {
                        if (this.state.orgs.find((o) => o._id === ti.org))
                            this.orgInvitePerson(ti.org, ti.email, metadata, null, true)
                    })
                }
            })
            // Back to the page the email was sent from, if it saved one (the replace drops the link's params too)
            .finally(() => (returnTo ? history.replace(returnTo) : removeParams("oobCode,apiKey,mode,lang")))
            .catch((err) => {
                setTimeout(() => {
                    switch (err.code) {
                        case "auth/invalid-action-code":
                            return toast.error(
                                "Sorry this validation link is no longer valid. Please check your email for a more recent link.",
                                { autoClose: 6000 }
                            )
                        case "auth/expired-action-code":
                            return toast.error(
                                "The verification email has expired. Sorry please request a new one. My Space... icon top right.",
                                { autoClose: 6000 }
                            )
                        case "email_verify_unexpected":
                            return toast.error(err.message)
                        case "auth/argument-error":
                            return
                        default:
                            toast.error(
                                "Failed to verify email. The code may be invalid (new one sent) Contact us if you did not receive a new email: help@missionx.ai",
                                {
                                    autoClose: 8000,
                                }
                            )
                    }
                }, 1000)
            })
    }
    flowVerifyAndChangeEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        const me = this

        return apiAuth
            .verifyAndUpdateEmail(oobCode)
            .then(({ previousEmail, newEmail }) => {
                me.setState({
                    person: update(this.state.person, {
                        email: newEmail,
                        emailVerified: { $set: true },
                    }),
                })

                addParam("myspace", "open")
                toast.success(
                    `Congratulations. Your email was verified and successfully changed from "${previousEmail}" to "${newEmail}"!`,
                    {
                        autoClose: 8000,
                    }
                )
            })
            .finally(() => removeParams("oobCode,apiKey,mode,lang"))
            .catch((err) => {
                switch (err.code) {
                    case "auth/expired-action-code":
                        return toast.error(
                            "The verification email has expired. Sorry please try changing your email again from My Space...",
                            { autoClose: 6000 }
                        )
                    case "auth/user-token-expired":
                        return setTimeout(() => {
                            toast("Redirecting you to re-authenticate", {
                                autoClose: 2000,
                            })
                            setTimeout(() => {
                                window.location.href = "/"
                            }, 2000)
                        }, 1000)
                    default:
                        toast.error(`${err.message}. Maybe try again or contact us: help@missionx.ai`, {
                            autoClose: 10000,
                        })
                }
            })
    }
    flowVerifyEmailSecondary() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        let returnTo

        return apiAuth
            .emailListVerify(oobCode)
            .then((profile) => {
                returnTo = getSafeVerifyReturn(profile.verifyReturn)

                toast.success("🚀 Nicely done Your email has been verified!", {
                    autoClose: 5000,
                })

                this.setState({
                    person: update(this.state.person, {
                        emailList: { $set: profile.emailList },
                    }),
                })
                announceEmailVerified(profile)
            })
            .catch((err) => {
                toast.error(err.message, {
                    autoClose: 6000,
                })
            })
            // As in flowVerifyEmail
            .finally(() => (returnTo ? history.replace(returnTo) : removeParams("oobCode,mode,apiKey,lang")))
    }
    flowRecoverEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        return apiAuth
            .recoverEmail(oobCode)
            .finally(() => removeParams("oobCode,apiKey,mode,lang"))
            .then(({ recoveryEmail }) => {
                if (recoveryEmail) {
                    this.setState({
                        person: update(this.state.person, {
                            email: { $set: recoveryEmail },
                        }),
                    })
                }
                toast.success(`🚀 Yeahy! Your email "${recoveryEmail || ""}" has been recovered!`, {
                    autoClose: 5000,
                })
            })
            .catch((err) => {
                switch (err.code) {
                    case "auth/user-token-expired":
                        history.push("/?login=open")
                        this.setState({
                            login: true,
                        })
                        return toast.success(
                            "🚀 Yeahy! Your email has been recovered! Please login again to continue.",
                            {
                                autoClose: 6000,
                            }
                        )
                    default:
                        toast.error(err.message, {
                            autoClose: 6000,
                        })
                }
            })
    }
    /**
     * Keeps the link's details so render() shows the Unsubscribe page
     * (comp/Unsubscribe.jsx) over the app. Without a token the page is a preview.
     */
    flowUnsubscribe() {
        const q = getQ()

        this.state = {
            ...this.state,
            unsubscribe: { token: q.token, from: q.from, preview: q.preview },
        }
    }

    /**
     * The Unsubscribe page's button: drops the link from the URL and shows the app
     * that loaded underneath, or login when nobody is signed in.
     */
    closeUnsubscribe() {
        removeParams("mode,token,from,preview")

        if (!this.state.person?._id) {
            window.location = "/login"
            return
        }

        this.setState({ unsubscribe: null })
    }

    /**
     * Keeps a Virtual PM link's details (?mode=followUp&token=...&answer=done|approve)
     * so render() shows comp/virtualPm/FollowUpLanding over the app.
     */
    flowFollowUpLink() {
        const q = getQ()

        this.state = {
            ...this.state,
            followUpLink: { token: q.token, answer: q.answer },
        }
    }

    /** The follow-up link page's button: as closeUnsubscribe. */
    closeFollowUpLink() {
        removeParams("mode,token,answer")

        if (!this.state.person?._id) {
            window.location = "/login"
            return
        }

        this.setState({ followUpLink: null })
    }

    setPersonalSetting(obj) {
        let d = this.state.person.appSettings || {}
        d = { ...d, ...obj }

        this.personUpdate({ appSettings: d })
    }

    setUserVariable(name, value) {
        const newArr = this.state.person.uiMessageFlags.slice()
        const existsIndex = newArr.findIndex((obj) => obj?.name === name)
        if (existsIndex !== -1) {
            newArr[existsIndex].value = value
        } else {
            newArr.push({ [name]: value })
        }

        this.personUpdate({ uiMessageFlags: newArr })
    }
    getUserVariable(name) {
        const newArr = this.state.person.uiMessageFlags.slice()
        const existsIndex = newArr.findIndex((obj) => obj?.name === name)

        if (existsIndex !== -1) {
            return newArr[existsIndex].value
        }
    }
    setUiSeenFlags(param, val, local) {
        let newArr = this.state.person.uiMessageFlags || []
        if (!newArr.includes(param)) {
            if (val) {
                newArr.push(param + "-" + val)
            } else {
                newArr.push(param)
            }
            this.personUpdate({ uiMessageFlags: newArr })
        }
        if (local) localStorage.setItem(param, true)
    }
    hasSeenMsg(param) {
        return this.state.person.uiMessageFlags?.find((d) => d === param) || localStorage.getItem(param)
    }

    inLogic() {
        //Where to go after signin logic

        const section = history.location.pathname.replace("/", "")

        this.setState({
            login: false,
        })

        if (
            this.state.person._id &&
            (!this.state.person.avatar || !this.state.person.firstName?.trim() || !this.state.person.lastName?.trim())
        ) {
            history.push("/home")
            addParam("myspace", "open")

            if (
                (!this.state.person.firstName?.trim() && this.state.person.lastName?.trim()) ||
                (this.state.person.firstName?.trim() && !this.state.person.lastName?.trim())
            ) {
                toast.error("Hello. Could you please check that your first and last name is correct?", {
                    autoClose: 5000,
                })
            }

            this.setState({
                myspace: true,
                login: false,
            })
        } else if (section === "" || section === "login") {
            // Carry the query string across. Email deep links (the trial-ending email's
            // ?org=...&org-sub=ai-purchasing pair) send a signed-out person to
            // /login + search, and a bare push("/home") would drop their params at the
            // very last step - they'd land on the home board with nothing opened.
            const q = new URLSearchParams(window.location.search)

            q.delete("login")

            history.push({ pathname: "/home", search: q.toString() })
        } else {
            removeParam("login")
        }

        function isFirstLetterLowercase(word) {
            if (!word || typeof word !== "string") return false
            const firstChar = word.charAt(0)
            return firstChar === firstChar.toLowerCase() && firstChar !== firstChar.toUpperCase()
        }

        if (isFirstLetterLowercase(this.state.person.firstName)) {
            const newName = upperFirst(this.state.person.firstName)
            this.personUpdate({ firstName: newName })
        }
        if (isFirstLetterLowercase(this.state.person.lastName)) {
            const newName = upperFirst(this.state.person.lastName)
            this.personUpdate({ lastName: newName })
        }

        // geo: people located before coordinates were kept pick them up once.
        if (!this.state.person.country || !this.state.person.state || !this.state.person.geo?.lat) {
            this.setLocal(true)
        }

        if (this.hasSeenMsg("firefox")) {
            const isFirefox = typeof InstallTrigger !== "undefined"

            if (isFirefox) {
                this.confirm({
                    comp: (
                        <p>
                            Hold on. Wait a minute. You're using Firefox. Cool browser, but it has some quirks we
                            haven't had time to address yet, so you may experience an issue or two until it is fully
                            supported.
                        </p>
                    ),
                    imgComp: <img src="/img/ff.png" style={{ width: 100, marginBottom: 20 }} />,
                    yesText: "Understood",
                    onYes: () => {
                        this.setUiSeenFlags("firefox")
                    },
                })
            }
        }
    }
    loadAll() {
        SimplyX.preload()
        Power.preload()
        MxGanttMission.preload()
        this.setState({
            showAll: true,
        })
    }
    resetEntryStates() {
        setTimeout(() => {
            this.setState({
                resetLoginStates: new Date().getTime(),
            })
        }, 500)
    }

    componentWillUnmount() {
        clearInterval(this.activityInterval)
        clearTimeout(this.authWatchdog)
        unmountAppReconnect()
        this.stopEmailVerifiedListener?.()

        if (this.pendingLogoutRedirect) {
            clearTimeout(this.pendingLogoutRedirect)
            this.pendingLogoutRedirect = null
        }

        this.hasUnmounted = true
        this.hasAppReconnectedSocket = null
    }

    componentDidUpdate(prevProps, prevState) {
        // Every task write the app sees (its own or over the socket) ends in a
        // missionChange; the timesheet entry panel's per-project task cache
        // uses this to know a project moved on since its last sync.
        const change = this.state.missionChange

        if (change && change !== prevState.missionChange) {
            const touched = new Set()

            missionChangeEntries(change).forEach((e) => {
                if (e.missionId && (e.for === "actionItem" || e.for === "actionItems")) {
                    touched.add(e.missionId)
                }
            })

            touched.forEach((missionId) => touchProjectTasks(missionId))
        }
    }

    componentDidMount() {
        // The free-email list (the API's is the only one); built-in patterns answer until it lands
        api.public
            .get("/api/free-email-domains")
            .then((res) => setFreeEmailList(res.data))
            .catch(() => {})

        this.mainCircle = new mojs.Shape({
            ...CIRCLE_OPTS,
            stroke: "orange",
        })

        this.xBurstShape = new mojs.Burst({
            radius: { 0: 120 },
            count: 5,
            duration: 100,
            className: "mo-js-shape",
            strokeWidth: 1,
            left: 0,
            top: 0,
            children: {
                fill: { cyan: "yellow" },
            },
        })

        this.smallCircles = []
        const colors = ["orange", "red", "gold", "#cc0000"]

        this.taskMasterRef.current = {}
        this.taskMasterRefTasks.current = []

        for (let i = 0; i < 4; i++) {
            this.smallCircles.push(
                new mojs.Shape({
                    ...CIRCLE_OPTS,
                    parent: this.mainCircle.el,
                    className: "mo-js-c",
                    strokeWidth: { 30: 0 },
                    left: 0,
                    top: 0,
                    stroke: colors[i % colors.length],
                    delay: "rand(0, 350)",
                    x: "rand(-50, 150)",
                    y: "rand(-50, 150)",
                    radius: "rand(5, 20)",
                })
            )
        }

        this.doneBurst = new mojs.Burst({
            radius: { 0: 500 },
            //parent : this.element,
            left: 0,
            top: 0,
            className: "mo-js-shape",
            count: 20,
            children: {
                scale: { 12: 0 },
                shape: "polygon",
                points: 6,
                fill: { lime: "cyan" },
                angle: { 360: 0 },
                duration: 900,
                delay: "stagger( rand(0, 50) )",
            },
        })

        // The verification link opens a new tab; the one the email was sent from unlocks too
        this.stopEmailVerifiedListener = onEmailVerifiedElsewhere(({ personId, emailVerified, emailList }) => {
            if (!personId || personId !== this.state.person?._id) return

            this.setState({
                person: update(this.state.person, {
                    emailVerified: { $set: emailVerified },
                    emailList: { $set: emailList },
                }),
            })

            // The token carries email_verified too, and the API reads it
            apiAuth
                .getCurrentUser()
                .then((user) => user?.reload().then(() => user.getIdToken(true)))
                .catch(() => {})
        })

        Login.preload()
    }
    circleBurst(left, top) {
        this.mainCircle.tune({ x: left, y: top }).replay()

        for (let i = 0; i < this.smallCircles.length; i++) {
            this.smallCircles[i].generate().replay()
        }
    }
    coinFountain(event, options = {}) {
        if (!event) return

        const { count = 12, colors = ["#FFD700", "#FFC107", "#FFA000"], duration = 900 } = options

        const x = event.clientX
        const y = event.clientY

        for (let i = 0; i < count; i++) {
            const spread = (Math.random() - 0.5) * 110 // horizontal spread
            const height = 110 + Math.random() * 80 // jump height
            const delay = i * 20

            const coin = new mojs.Shape({
                shape: "circle",
                radius: 10,
                fill: colors[Math.floor(Math.random() * colors.length)],
                stroke: "#FFA000",
                strokeWidth: 2,
                parent: document.getElementById("mo-fx-root"),

                left: x,
                top: y,

                x: { 0: spread },
                y: { 0: -height },

                duration,
                delay,
                easing: "cubic.out",

                // 👇 fade near the top
                opacity: { 1: 0 },

                // 👇 fake spin
                scaleX: { 1: 0.2 },
                scaleY: { 1: 1 },

                isSoftHide: true,

                onComplete() {
                    this.el.remove()
                },
            })

            coin.play()

            // gravity drop (second phase)
            coin.then({
                opacity: { 1: 0 },
                duration: 200,
                easing: "quad.out",
            })
        }
    }
    xBurst(left, top) {
        this.xBurstShape.tune({ x: left, y: top }).replay()
    }
    preAuthRouting() {
        const q = getQ()

        const section = window.location.pathname.split("/")[1]

        if ((section === "board" || section === "home" || q.mission) && !q.login) {
            history.push("/")

            addParam("login", "open")

            this.setState({
                login: true,
            })
        } else if (q.login || q.mode) {
            this.setState({
                login: true,
            })
        } else if (q.mode === "verifyEmail") {
            this.setState({
                login: true,
            })
        } else {
            this.setState({
                login: undefined,
            })
        }
    }

    routing() {
        const q = getQ()

        const loc = history.location
        let section =
            loc && loc.pathname
                ? loc.pathname.replace("/", "") === ""
                    ? "login"
                    : loc.pathname.replace("/", "")
                : "login"

        if (
            this.state.person._id &&
            (!this.state.person.avatar || !this.state.person.firstName?.trim() || !this.state.person.lastName?.trim())
        ) {
            return
        }

        if (q["org"] && !this.state.org) {
            this.closeActionItem()
        }
        if (q["mission"] && !this.state.mission) {
            this.closeActionItem()
        }

        if (q["sign-off"] && q["sign-off"] !== this.state.showSignOff?.id) {
            this.setState({ showSignOff: { id: q["sign-off"], orgId: q["sign-off-org"] || q.org } })
        } else if (!q["sign-off"] && this.state.showSignOff) {
            this.setState({ showSignOff: null })
        }

        if (q["follow-up"] && q["follow-up"] !== this.state.showFollowUp?.id) {
            this.setState({ showFollowUp: { id: q["follow-up"], orgId: q["follow-up-org"] || q.org } })
        } else if (!q["follow-up"] && this.state.showFollowUp) {
            this.setState({ showFollowUp: null })
        }

        // ?chat=<conversationId>, ?chat=task:<taskId> or ?chat=person:<personId>: opens the chat on that room, once
        if (q.chat) {
            const [kind, id] = String(q.chat).includes(":") ? String(q.chat).split(":") : ["conversation", q.chat]

            chatStore.openChat(
                kind === "task" ? { taskId: id } : kind === "person" ? { personId: id } : { conversationId: id },
            )
            removeParams("chat", true)
        }

        // A reminder's email links here when it is about nothing in particular
        if (q.reminders && !this.state.showReminders) {
            this.setState({ showReminders: true })
        }

        if (q.myspace && (q["action-item"] || this.state.showDetailsData)) {
            // My Space covers the task card, so opening it closes the card; the replace re-runs routing without the param
            if (q["action-item"]) removeQueryParam("action-item")
            this.dropPendingActionItem()
            this.setState({
                showDetailsData: null,
                showDetailsDataOptions: null,
            })
        } else if (!q["action-item"] && this.state.showDetailsData) {
            this.dropPendingActionItem()
            this.setState({
                showDetailsData: null,
                showDetailsDataOptions: null,
            })
        } else if (
            q["action-item"] &&
            q["action-item"] !== this.state.showDetailsData?._id &&
            // the first open from the url waits for the mission tree (onAsyncMissionsLoaded)
            (this.state.showDetailsData || this.missionsLoadedOnce)
        ) {
            // also covers back/forward onto a task url after it was closed, and links that only add the param
            this.showActionItemDetails(q["action-item"])
        }

        if (this.state.orgsLoaded) {
            const orgIndex = q.org ? this.state.orgs.findIndex((o) => getObjectId(o) === q.org) : -1

            if (q.org && orgIndex === -1 && !q.hq) {
                toast.error("Sorry that Organization wasn't found. Maybe removed?")
                removeParams("org,org-tab,hq")
                return
            }

            if (q.hq && q["mission"]) {
                removeQueryParam("mission")
            }

            this.setState({
                org: q.org,
                mission: q.hq || q["create-mission"] ? null : q.mission, //&& !q.action ? q.mission: undefined,
                phase: q.hq || q["create-mission"] ? null : q.phase, //&& !q.action ? q.phase: undefined,
                orgIndex: orgIndex !== -1 ? orgIndex : undefined,
                missionCrud: q.mc,
                createMission: q["create-mission"],
                createProposal: q["create-proposal"],
                orgCrud: q.hq,
                myspace: q["create-mission"] || q["create-proposal"] || q.hq ? null : q.myspace || q.invite,
                board: section === "board" ? true : undefined,
                home: section === "home" ? true : undefined,
                login: undefined,
                timeTracking: q["time-tracking"] && !q.mission && !q.org,

                error: q.diagnostic,
                powerTab: q.powerTab,
            })
        } else {
            this.setState({
                myspace: q.myspace || q.invite,
                board: section === "board" ? true : undefined,
                home: section === "home" ? true : undefined,
            })
        }
    }

    personUpdatePanelState(orgId, change) {
        let nextPanelState

        this.setState(
            (prevState) => {
                // 1. Ensure we have an array to work with (fallback for old data)
                const prevPanelState = Array.isArray(prevState.person.panelState) ? prevState.person.panelState : []

                // 2. Find the existing entry for this Org
                const existingOrgEntry = prevPanelState.find((p) => p.orgId === orgId)

                // 3. Create the updated state for this specific Org
                const nextOrgState = {
                    orgId: orgId, // Always ensure the ID is present
                    tab: "missions",
                    sortIndex: 0,
                    subTab: null,
                    recents: [],
                    favourites: [],
                    ...existingOrgEntry, // Spread existing data if it exists
                    ...change, // Apply the new changes
                }

                // 4. Update the array:
                // If it exists, replace it at the same position. If not, append it.
                if (existingOrgEntry) {
                    nextPanelState = prevPanelState.map((p) => (p.orgId === orgId ? nextOrgState : p))
                } else {
                    nextPanelState = [...prevPanelState, nextOrgState]
                }

                return {
                    person: {
                        ...prevState.person,
                        panelState: nextPanelState,
                    },
                }
            },
            () => {
                if (this.state.orgs.length) {
                    nextPanelState = nextPanelState.filter((ps) => this.state.orgs.some((o) => o._id === ps.orgId))
                }

                // Sends the newly ordered array to the backend
                this.personUpdate({ panelState: nextPanelState })
            }
        )
    }

    personUploadAvatar(file, base64) {
        if (!file || !base64) return

        if (base64) {
            const mergedChange = {
                ...this.state.person,
                avatar: base64,
            }

            this.setState({
                person: update(this.state.person, { $set: mergedChange }),
            })
        }
        return apiAuth.uploadAvatar(file).then((res) => {
            if (base64) {
                const newAvatar = {
                    ...this.state.person,
                    avatar: res.avatar,
                }

                this.commitState(
                    {
                        person: update(this.state.person, { $set: newAvatar }),
                    },
                    () => {
                        this.updateStateForPersonAvatar(this.state.person, true)
                    }
                )
            }
        })
    }
    /**
     * setState for the updateStateFor* helpers, committed at once (see utils/commitState.js)
     */
    commitState(partial, cb) {
        commitComponentState(this, partial, cb)
    }
    personUpdate(newData, isRetry) {
        const me = this

        // Updater form: under createRoot two quick personUpdates outside an event can both
        // run before a render, and a merge onto this.state.person would drop the first one
        this.setState((prevState) => ({
            person: { ...prevState.person, ...newData },
        }))

        return apiAuth
            .updateProfile(newData)
            .then((res) => {
                me.updateStateForPersonAvatar(res)
            })
            .catch((err) => {
                // Never reached the server (offline, sleeping tab, dropped connection). State is
                // already updated, so send it once more when the browser is back online - the
                // current values of those keys, so a later change made meanwhile is not undone.
                if (err?.isAxiosError && !err.response) {
                    if (!isRetry) {
                        const retry = () =>
                            setTimeout(
                                () => this.personUpdate(pick(this.state.person, Object.keys(newData)), true),
                                2000,
                            )
                        if (navigator.onLine) retry()
                        else window.addEventListener("online", retry, { once: true })
                    }
                    return
                }

                try {
                    this.silentFail("personUpdatekskwiw" + err?.message + JSON.stringify(newData))
                } catch (e) {
                    this.silentFail("personUpdatekskwiw-failed")
                }
            })
    }

    showSignInError(msg, option = {}) {
        if (!toast.isActive("erkejreo-3ede")) {
            toast.warning(msg, { ...option, toastId: "erkejreo-3ede" })
        }
        this.setState({
            resetLoginStates: new Date().getTime(),
        })
    }
    doesEmailExist(email) {
        return apiAuth.existsPersonWithEmail(email)
    }

    signInErrorHandler(err) {
        if (["auth/account-exists-with-different-credential", "auth/credential-already-in-use"].includes(err?.code)) {
            // An account already exists with the same email address but different sign-in credentials.
            // Sign in using a provider associated with this email address.
            // https://firebase.google.com/docs/auth/web/microsoft-oauth#expandable-1
            // How do we handle this?
            // Maybe, prompt the user to set his personal email as the primary email and try again?
            // Or force him to set a personal email to distinguish the two accounts (no linking)?
            // In either case we need to give the option to the user, what they would like to do.
            // toast.error(
            //     "An account already exists with the same email address but different sign-in credentials. Please contact help@missionx.ai so we can help",
            //     {
            //         autoClose: false,
            //     }
            // )
        } else if (err?.code === "auth/provider-already-linked") {
            // User can only be linked to one identity for the given provider.
        }

        throw err
    }

    async signInWithSAML(email) {
        try {
            const emailDomain = getDomainFromEmail(email)

            if (!emailDomainToSamlProviderMap.has(emailDomain)) {
                return toast.error(
                    `There's no single sign-on setup for your email. Please login with another provider or reach out to an administrator from your organization.`,
                    {
                        autoClose: 10000,
                    }
                )
            }

            const { profile } = await samlSignInWithPopup(emailDomainToSamlProviderMap.get(emailDomain))
        } catch (err) {
            this.signInErrorHandler(err)
        }
    }
    async signInWithMicrosoft(email) {
        const emailDomain = getDomainFromEmail(email)

        if (emailDomainToSamlProviderMap.has(emailDomain)) {
            return toast.error(`Please sign in with single sign-on instead.`, {
                autoClose: 10000,
            })
        }

        if (!isActiveDirectoryEmail(email)) {
            return toast.error(
                `There's no microsoft setup for your email. Please login with another provider or reach out to an administrator from your organization.`,
                {
                    autoClose: 10000,
                }
            )
        }

        await apiAuth.microsoftSignInWithPopup(["User.Read"], {
            login_hint: email,
        })
    }
    signIn(email, password, errorCb, { onCreateAccount, onForgotPassword } = {}) {
        return apiAuth
            .signInWithEmailAndPassword(email, password)
            .then((res) => {
                //The auth change listener catches this
            })
            .catch((err) => {
                if (err.code === "auth/wrong-password") {
                    this.showSignInError("Ooops. Please check that your email and password are correct.")
                    if (errorCb) errorCb()
                } else if (err.code === "auth/user-not-found") {
                    if (errorCb) errorCb()

                    return apiAuth.existsPersonWithEmail(email).then((res) => {
                        if (res.exists) {
                            if (res.primaryEmail) {
                                this.showSignInError(
                                    `👋 Hello! The email you just tried is a secondary account linked to another email address. Please use your primary email ${res.primaryEmail} to login.`,
                                    { autoClose: false }
                                )
                            } else {
                                this.showSignInError(
                                    "The email you just tried is likely a secondary email on one of your projects. Please use your primary email to login.",
                                    { autoClose: false }
                                )
                            }
                        } else {
                            this.showSignInError(
                                <>
                                    <p>Oops. Either the username does not exist or the password doesn't match.</p>{" "}
                                    <p
                                        className="x-link active"
                                        onClick={() => {
                                            toast.dismiss("erkejreo-3ede")
                                            onCreateAccount?.()
                                        }}
                                    >
                                        Create account?
                                    </p>{" "}

                                    <p
                                        className="x-link active"
                                        onClick={() => {
                                            toast.dismiss("erkejreo-3ede")
                                            onForgotPassword?.()
                                        }}
                                    >
                                        Forgot password?
                                    </p>
                                </>, {
                                    autoClose:6000
                                }
                            )
                        }
                    })
                }

                if (errorCb) errorCb(err)

                throw err
            })
    }
    signUp(email, password, cb) {
        return apiAuth
            .signUp(email, password)
            .then(() => {
                const q = getQ()

                return apiAuth
                    .signInWithEmailAndPassword(email, password)
                    .then(() => apiAuth.getCurrentUser())
                    .then(() =>
                        !["invite", "orgInvite"].includes(q.from) ? apiAuth.sendEmailVerification() : Promise.resolve()
                    )
                    .catch((err) => {})
            })
            .catch((err) => {
                if (err === "Unauthorized") {
                    return
                }
                if (cb) cb(err)
            })
    }

    personSignOut(goToLogin) {
        ;(async () => {
            try {
                document.getElementById("dna-body").className = ""

                this?.block("One moment please...")

                this.setState({
                    person: null,
                })

                notificationStore.reset()
                chatStore.reset()
                unmountAppReconnect()
                this.unsubscribeFromIdTokenChanges()
                this.unsubscribeFromAuthStateChanged()

                // Signs out server + Firebase, then wipes local data (see clearSiteData).
                await apiAuth.clearSiteData()

                if (goToLogin !== false) {
                    if (window.location.href.includes("localhost:")) {
                        window.location = "/login"
                    } else {
                        window.location = "https://missionx.ai"
                    }
                }
            } catch (err) {
                toast.error("An issue occurred: " + err.message)
                this?.unBlock()
            }
        })()
    }
    personResetPasswordRequest(emailOrNumber, cb) {
        if (isEmail(emailOrNumber)) {
            apiAuth
                .sendPasswordResetEmail(emailOrNumber)
                .then((res) => {
                    toast.success("Ok sent.‍ Please check your email and follow the link.", {
                        position: "top-center",
                        autoClose: 5000,
                    })

                    cb()
                })
                .catch((err) => {
                    cb()
                    toast.error(
                        "Password reset error. " + err?.message ||
                            "I'm sorry there was an issue. Please contact help@missionx.ai.",
                        {
                            position: "top-center",
                            autoClose: 6000,
                        }
                    )
                })
        } else if (isMobilePhone(emailOrNumber)) {
            cb()
            //  https://firebase.google.com/docs/auth/web/phone-auth
            //  3. Send a verification code to the user's phone
        } else {
            cb()
            toast.error("Sorry. I didn't recoginize where you want me to send the reset details.")
        }
    }
    personConfirmPasswordReset(newPassword, cb) {
        const me = this

        apiAuth
            .confirmPasswordReset(this.tempResetCode, newPassword)
            .then((res) => {
                // Phones sign in on the app, not here
                if (window.screen.width < 800) {
                    toast.success("Success. Password has been updated.", { position: "top-center", autoClose: 5000 })
                    cb()
                    return
                }

                toast.success("Success. Password has been updated. Signing you in now...", {
                    position: "top-center",
                    autoClose: 5000,
                })

                setTimeout(() => {
                    this.signIn(
                        me.tempResetEmail,
                        newPassword,
                        (err) => {
                            //@mike  this is giving it as Unauthorized
                            window.location.href = "/login"
                        },
                        false
                    )
                }, 1000)
            })
            .catch((err) => {
                cb(err)
                toast.error("An issue occurred: " + err.message, {
                    position: "top-center",
                    autoClose: 6000,
                })
            })
    }
    personActivateCode(code) {
        //The scenario we texted a code to their phone
        //  https://firebase.google.com/docs/auth/web/phone-auth
        // i will send you an email or phone number plus the code...
        /*
        MIKE CODE
        authApi.validateResetCode(code,emailOrNumber).then(res=>{
            //MIKE CODE signperson automatically
            addParam('password-reset')
        }).catch(err=>{
        //Makis here
      })
        */
    }

    block = (...args) => {
        // defaults
        let msg = "One moment please...",
            tag = "Working",
            to = 300,
            loader = "bar"

        const first = args[0]

        // Only treat as new-style config if it's the single arg and contains known config keys.
        const looksLikeConfig =
            args.length === 1 &&
            first &&
            typeof first === "object" &&
            ("msg" in first || "tag" in first || "to" in first || "loader" in first || "type" in first)

        if (looksLikeConfig) {
            ;({ msg = "One moment please...", tag = "Working", to = 300, loader = "bar" } = first)
        } else {
            // old-style positional: (msg, to)
            ;[msg = "One moment please...", to = 300] = args
        }

        const obj = {
            loadingBlocker: true,
            loadingBlockerMessage: msg,
            loadingBlockerLoader: loader,
            loadingBlockerTag: tag,
        }

        if (this.state.loadingBlocker) return

        if (!to) {
            this.setState(obj)
        } else {
            clearTimeout(this.blockTO)
            this.blockTO = setTimeout(() => {
                this.setState(obj)
            }, Number(to))
        }
    }

    unBlock() {
        clearTimeout(this.blockTO)
        this.setState({
            loadingBlocker: false,
        })
    }
    hideAppElements() {
        this.setState({
            hideDamKnob: true,
            hideAvatar: true,
            hideExtras: true,
        })
    }

    showAppElements() {
        this.setState({
            hideDamKnob: false,
            hideAvatar: false,
            hideExtras: false,
        })
    }
    hideNavigator() {
        this.hideKnobs()
    }
    showNavigator() {
        this.showKnobs()
    }
    hideKnobs() {
        this.setState({
            hideDamKnob: true,
        })
    }

    showKnobs() {
        this.setState({
            hideDamKnob: false,
        })
    }
    hideAppAdminTools() {
        if (this.state.hideAdminTools !== true)
            this.setState({
                hideAdminTools: true,
            })
    }
    showAppAdminTools() {
        if (this.state.hideAdminTools === true)
            this.setState({
                hideAdminTools: false,
            })
    }

    onAsyncMissionsLoaded({ orgList, cached }) {
        this.setState(
            {
                waiting: false,
                missions: [],
            },
            async () => {
                const q = getQ()

                this.missionsLoadedOnce = true

                if (q["action-item"]) {
                    this.showActionItemDetails(getQ()["action-item"])
                }

                if (q["sign-off"]) {
                    this.setState({ showSignOff: { id: q["sign-off"], orgId: q["sign-off-org"] || q.org } })
                }

                this.changeListener()
            }
        )
    }

    async buildMissionTree(orgList, encryptionKey) {
        let mfaDisabledOrgs = []

        if (!this.state.multiFactor) {
            mfaDisabledOrgs = orgList.filter((o) => o.isMFARequired)
            this.setState({ mfaDisabledOrgs })
        }

        if (mfaDisabledOrgs?.length && !this.state.multiFactor && !this.hasSeenMsg("org-2fa-must")) {
            this.confirm({
                severe: true,
                comp: (
                    <>
                        <p>Hi {this.state.person.firstName}👋</p>
                        <p>
                            {mfaDisabledOrgs.length === 1 ? "An organization requires" : "Some organizations require"}{" "}
                            you to setup two-factor authentication for extra account security at login.{" "}
                        </p>
                        <p>You will not be able to access projects and data until you do so.</p>
                    </>
                ),
                yesText: "Setup up 2FA",
                noText: "I'll do it later",
                singleClick: true,
                noCancel: true,
                onNo: () => this.setUiSeenFlags("org-2fa-must"),
                onYes: () => {
                    this.setUiSeenFlags("org-2fa-must")
                    removeParams("org,mission,phase,action")
                    addParam("myspace", "2fa")
                },
            })
        }

        this.onAsyncMissionsLoaded({ missions: [], orgList })
    }

    getUserDomain(em) {
        const email = em || this.state.person?.email

        if (!email) return

        return email.slice(email.indexOf("@") + 1, email.length)
    }
    async loadNewOrg(org) {
        this.loadDataOrgs(false)
    }
    async loadDataOrgs(noBlocker) {
        try {
            if (!noBlocker) {
                this.setState({ loading: true }) // optional: show loading
            }

            const encryptionKey = await getEncryptionKey({ app: this })

            const myOrgList = await paginateAll(getOrgList())

            const orgsWithFullPeople = await this.loadFullOrgPeople(myOrgList, encryptionKey)

            const pid = this.state.person._id

            let orgsWithMe = await Promise.all(
                myOrgList.map(async (org) => {
                    const gme = await getOrgPeople(org._id, { person: pid })

                    const meIn = gme.value?.[0]
                    const orgsFullPeople = orgsWithFullPeople[org._id]

                    const others = (orgsFullPeople || [])
                        .filter((p) => getRefId(p) !== this.state.person._id)
                        .filter(Boolean)

                    const finalActivePeole = uniqPeople([meIn, ...others])

                    return {
                        ...org,
                        people: finalActivePeole.filter((p) => !isArchived(p)),
                        archivedPeople: orgsFullPeople.filter((p) => isArchived(p)),
                    }
                })
            )

            orgsWithMe = orgsWithMe.filter((o) => o.people?.length)

            this.setState(
                {
                    orgs: orgsWithMe,
                    orgsLoaded: true,
                    encryptionKey,
                    loading: false,
                },
                async () => {
                    this.routing()

                    this.buildMissionTree(orgsWithMe, encryptionKey) // initial tree with empty clients

                    this.loadLatestNotifications()
                }
            )
        } catch (error) {
            console.error("Failed to load orgs/clients", error)
        }
    }

    async loadFullOrgPeople(orgs, encryptionKey) {
        if (!orgs.length) return

        let cachedPeople = {}

        let cachedPeopleDb = await getDbItem("myOrgPeople", "store", this.state.person._id)

        // Expired cache starts over from the API alone, so people it no longer returns drop out
        if (cachedPeopleDb?.updatedAt) {
            const upDate = new Date(cachedPeopleDb?.updatedAt)

            if (isDateValid(upDate)) {
                if (differenceInDays(new Date(), upDate) > 3) {
                    cachedPeopleDb = undefined
                    deleteEntireDb("myOrgPeople")
                }
            }
        }

        if (cachedPeopleDb?.people) {
            const decryptedPeopleByOrgId = await decrypt(encryptionKey, cachedPeopleDb.people)

            // Written under another key (it changed since): unreadable, so it is no cache at
            // all. Keeping its updatedAt would ask the API for changes only and lose everyone else.
            if (decryptedPeopleByOrgId === null) {
                cachedPeopleDb = undefined
            } else {
                cachedPeople = decompress(decryptedPeopleByOrgId) || []
            }
        }

        // An org always has at least me in it, so an empty list is a broken cache (one saved
        // after such a lost read): fetch everyone again rather than only the changes.
        if (cachedPeopleDb && orgs.some((org) => !cachedPeople[org._id]?.length)) {
            cachedPeopleDb = undefined
            cachedPeople = {}
        }

        // Map each org to a promise that resolves with the hydrated org
        const orgPromises = orgs.map(async (org) => {
            const [gop, ga] = await Promise.all([
                paginateAll(
                    getOrgPeopleLite(org._id, {
                        withArchived: false,
                        updatedAt: cachedPeopleDb?.updatedAt ? `gte ${cachedPeopleDb.updatedAt}` : undefined,
                    })
                ),
                paginateAll(
                    getOrgArchivedLite(org._id, {
                        withArchived: true,
                        updatedAt: cachedPeopleDb?.updatedAt ? `gte ${cachedPeopleDb.updatedAt}` : undefined,
                    })
                ),
            ])

            const gp = [...ga.map((p) => ({ ...p, isArchived: true, _archived: true })), ...gop]

            let combinedPeople = uniqPeople([...gp, ...(cachedPeople[org._id] || [])])

            const people = combinedPeople.filter((p) => Boolean(p) && !isArchived(p))
            const archivedPeople = combinedPeople.filter((p) => Boolean(p) && isArchived(p))

            return { ...org, people: people || [], archivedPeople: archivedPeople || [] }
        })

        // Wait for all orgs to be processed in parallel
        const hydratedOrgsWithPeople = await Promise.all(orgPromises)

        const orgPeopleObj = {}

        hydratedOrgsWithPeople.forEach((o) => {
            orgPeopleObj[o._id] = [...(o.people || []), ...(o.archivedPeople || [])]
        })

        const compressedOrgPeople = compress(orgPeopleObj)
        const encryptedOrgPeople = await encrypt(encryptionKey, compressedOrgPeople)

        await addDbItem("myOrgPeople", "store", {
            id: this.state.person._id,
            people: encryptedOrgPeople,
            updatedAt: subSeconds(new Date(), 10).toISOString(),
        })

        return orgPeopleObj
    }

    async personAuthInit(profile) {
        const me = this

        await (profile ? Promise.resolve(profile) : apiAuth.getProfile())
            .then(async (personRes) => {
                if (typeof personRes.theme === "object") {
                    personRes.theme = "empty"
                }

                handleInvite({ app: this })

                const isOldStructure =
                    personRes.panelState &&
                    !Array.isArray(personRes.panelState) &&
                    typeof personRes.panelState === "object" &&
                    "byOrg" in personRes.panelState

                let newPanelState = personRes.panelState
                if (isOldStructure) {
                    // Migration 1: Transform Object-by-Org to Array
                    newPanelState = migratePanelState(personRes.panelState).filter((ps) => ps.orgId !== "undefined")
                } else if (Array.isArray(newPanelState)) {
                    // Migration 2: Ensure inner arrays (missions, proposals, etc.) use the object + sortIndex schema
                    newPanelState = newPanelState.map((org) => {
                        const fixArray = (list) => {
                            if (!Array.isArray(list)) return []
                            // If the first item is already an object with an 'id', assume it's migrated
                            if (list.length > 0 && typeof list[0] === "object" && list[0].id) {
                                return list
                            }
                            // Otherwise, convert strings/old-objects to the new schema
                            return list.map((item, i) => ({
                                id: typeof item === "string" ? item : item.id || item._id,
                                sortIndex: typeof item.sortIndex === "number" ? item.sortIndex : i,
                            }))
                        }

                        return {
                            ...org,
                            recentMissions: fixArray(org.recentMissions),
                            recentProposals: fixArray(org.recentProposals),
                            recentTemplates: fixArray(org.recentTemplates),
                            recentProcesses: fixArray(org.recentProcesses),
                        }
                    })
                }

                this.setState(
                    {
                        person: { ...personRes, panelState: newPanelState },
                    },
                    () => {
                        me.inLogic()

                        if (personRes.mode === "dark") {
                            document.getElementById("dna-body").className = "dna-dark dna-dark-bg"
                        } else {
                            document.getElementById("dna-body").className = ""
                        }

                        me.loadDataOrgs()
                    }
                )
            })
            .catch((err) => {
                if (err.code === "auth/gt-inactive") {
                    return this.personSignOut()
                }
                // Without a person the app stays on "Preparing workspace", so give a way out.
                if (!this.state.person?._id) {
                    toast.error("Oops. We couldn't load your profile. Click here to try again.", {
                        autoClose: false,
                        onClick: () => window.location.reload(),
                    })
                    this.silentFail("personAuthInit " + (err?.code || err?.message))
                }
            })
    }

    /**
     * skipOrgReload: the caller reloads the org list once itself (Accept all), instead of
     * one full org list per accept running side by side
     */
    async personAcceptInvite(inviteId, noticeId, infoObj, noToast, skipOrgReload) {
        const me = this

        notificationStore.remove(noticeId)

        const acceptMethod = infoObj?.informationalOnly === true ? apiMission.confirmInvite : apiMission.acceptInvite

        return acceptMethod(inviteId)
            .then((res) => {
                if (!toast.isActive("welcoemAbord") && !noToast) {
                    toast.success(
                        "Welcome aboard! 🚀 Check your Control panel or Mission. Vision. Board. from the project management workspace.",
                        {
                            toastId: "welcoemAbord",
                        }
                    )
                }

                if (res.org) {
                    if (!skipOrgReload) me.reloadOrgTree()
                } else {
                    if (res._id) {
                        me.missionLoad(res)
                    }
                }

                return res
            })
            .catch((err) => {
                toast.error("Sorry that invite is longer valid.")
                return null
            })
    }
    /** Full org list again, then the mission tree from it */
    reloadOrgTree() {
        return apiOrg
            .getOrgList(this)
            .then((orgList) => {
                this.buildMissionTree(orgList)
            })
            .catch((err) => {
                toast.error("There was an error getting Orgs. Notifcations sent.")
            })
    }
    personAcceptInviteOrg(inviteId, noticeId) {
        const successFn = (org) => {
            toast.success("Welcome to the organization!")

            if (org) {
                this.loadNewOrg(org)
            }

            notificationStore.remove(noticeId)
        }
        apiOrg
            .acceptInvite(inviteId)
            .then((org) => {
                successFn(org)
            })
            .catch((err) => {
                if (err.code === "invite/active-directory") {
                    successFn()
                } else {
                    toast.error(get(err, "message") || "Sorry that org invite is longer valid")
                }
            })
    }
    personRejectInvite(inviteId, org, noticeId) {
        const apiCall = org ? apiOrg : apiMission
        apiCall
            .rejectInvite(inviteId)
            .then(() => {
                notificationStore.remove(noticeId)
                toast("No problem. We'll pass the msg along. Thanks!")
            })
            .catch((err) => {
                console.error("Sorry that invite is longer valid or an error has occured.")
            })
    }
    missionLoad(mission, cb) {
        const me = this

        me.commitState(
            {
                missions: update(this.state.missions, { $push: [mission] }),
            },
            () => {
                if (cb) cb()
            }
        )
    }
    missionCreate(data, org, cb, options = {}, dontOpenMission) {
        apiMission
            .createMission(data, options)
            .then((mission) => {
                if (data.proposalLinkId) {
                    let proposalParent = this.state.missions.find((mmp) => mmp._id === data.proposalLinkId)

                    if (proposalParent) {
                        this.missionUpdate(proposalParent._id, {
                            linkedProject: mission._id,
                        })
                    }
                }

                if (mission.projectType === "power") {
                    this.planItemCreateX(mission, {
                        type: "phase",
                        startDate: mission.planStartDate,
                        endDate: mission.planEndDate,
                    })
                }

                this.updateStateForMissionCreate(mission, () => {
                    if (!dontOpenMission) {
                        if (mission.type === "power") {
                            addParams([{ param: "mission", value: mission._id }])
                        } else {
                            addParam("mission", mission._id)
                            removeParams("mc,mc-org,mc-org-goal,mc-prop,create-proposal")
                        }
                    }
                    let meInOrg = {}
                    let orgRole
                    if (org) {
                        meInOrg = (org.people || []).find((p) => getRefId(p) === mission.createdBy._id)
                        if (meInOrg) {
                            orgRole = getRole(meInOrg.role, org)
                        }
                    }

                    let roleDetailsObj = {}

                    if (!org || !org.isLicensedActive || (org && !org.projectCreationRestricted)) {
                        roleDetailsObj = {
                            role: orgRole ? orgRole._id : "Project manager",
                            rate: orgRole ? getOrgRoleRate(orgRole) || 0 : 0,
                            rateTime: orgRole ? getOrgRoleRateTime(orgRole, org) : "Monthly",
                            billRate: orgRole ? getOrgBillRate(orgRole) || 0 : 0,
                            billUnit: getOrgBillUnit(orgRole),
                            person: mission.createdBy._id, //catch flow below
                        }
                    } else if (org && org.projectCreationRestricted) {
                        roleDetailsObj = {
                            role: "Project manager",
                            rate: 0,
                            rateTime: org?.roleDefaultRateTime || "Hourly",
                            billRate: 0,
                            billUnit: "Hourly",
                            person: null,
                        }
                    }

                    //Create default role for admin / pm unless the org requires approvals
                    const createConditions =
                        mission.projectType !== "mx-gantt" &&
                        !data.isTemplate &&
                        !mission.isModel &&
                        !options?.template &&
                        !org?.projectCreationRestricted &&
                        !org?.isLicensedActive

                    if (createConditions || !org) {
                        this.planItemCreateX(
                            mission._id,
                            {
                                title: "Project manager",
                                role: roleDetailsObj.role,
                                allocation: 100,
                                rateTime: roleDetailsObj?.rateTime || "Monthly",
                                type: "person",
                                pinnedTo: "entireMission",
                                rate: roleDetailsObj.rate || 0,
                                billRate: roleDetailsObj.billRate || 0,
                                billUnit: roleDetailsObj.billUnit || "Hourly",
                                y: 0,
                                person: roleDetailsObj.person,
                                startDate: mission.planStartDate
                                    ? mission.planStartDate
                                    : getTimeUtc(startOfDay(new Date())),
                                endDate: mission.planEndDate
                                    ? mission.planEndDate
                                    : getTimeUtc(endOfMonth(addMonths(startOfDay(new Date()), 4))),
                            },
                            (res) => {
                                //check if we can approve this role and assign person

                                //If PM

                                if (org && meInOrg) {
                                    if (
                                        org.rolesNeedApproval &&
                                        (meInOrg.canApproveRoles || meInOrg.permission === 2)
                                    ) {
                                        assignPersonToRole(meInOrg, res, meInOrg.role, org, mission, this, null, true)
                                    }
                                }
                            }
                        )
                    }

                    if (cb) cb(mission)
                })
            })
            .catch((err) => {
                toast.error(err?.msg || err || "Problem creating project please refresh and try again. We're sorry.")
                console.error(err)

                switch (err.code) {
                    case "account_limit":
                        return toast("Hello! Sorry there is a limit for now. Please contact us help@missionx.ai", {
                            autoClose: 7000,
                        })
                }

                this.unBlock()

                removeParam("create-mission")

                return toast.error("Mission create issue: " + err.message)
            })
    }

    /**
     * Board sections are actions under the board phase (utils/sections.js). These take and
     * hand back sections in the shape getSections() gives (title, color, from/to,
     * colomnSortIndex, dependsOn, defaultAiCode).
     */
    missionAddSection(missionId, section, cb) {
        const mission = this.state.missions.find((m) => m._id === missionId)
        const phase = getBoardPhase(mission)

        if (!phase) {
            toast.error("Sorry, this project has no board to add a section to. Please refresh and try again.")
            return
        }

        const sections = getSections(mission)
        const change = toActionChange(section)
        const data = {
            ...change,
            title: section?.title || "",
            isSection: true,
            position: change.position ?? (sections.length ? Math.max(...sections.map((s) => s.colomnSortIndex)) + 1 : 0),
            dependencies: (section?.dependsOn || []).filter((id) => sections.some((s) => s._id === id)),
            planItemId: phase._id,
        }

        // An action holds both dates or neither
        if (!data.startDate || !data.endDate || data.startDate >= data.endDate) {
            delete data.startDate
            delete data.endDate
        }

        return this.actionCreateX(data, (res) => {
            if (cb) cb(toSection(res))
        })?.catch((err) => {
            toast.error(
                get(err, "message") ||
                    "Sorry an error occured. Please refresh and try again. We are also investigating."
            )
        })
    }
    async loadMission(id, select) {
        const m = await getMissions({
            expand: "people",
            id: id,
            select: select,
        })

        return m?.value?.[0]
    }
    missionUpdateSection(mission, section, change, cb) {
        if (!section || section._id === CATCH_ALL_ID) {
            return
        }

        // The freshest copy: screens hold on to the mission they rendered with
        mission = this.state.missions.find((m) => m._id === mission._id) || mission

        const action = getSectionActions(mission).find((a) => a._id === section._id)

        if (!action) {
            this.silentFail("sectionUpdateMissing " + section._id)
            return
        }

        const actionChange = toActionChange(change)
        const before = toSection(action)

        if ("dependsOn" in change) {
            this.missionUpdateSectionDependsOn(mission, action, change.dependsOn || [])
        }

        if (isEmpty(actionChange)) {
            if (cb) cb(toSection({ ...action, ...actionChange }))
            return
        }

        this.updateStateForActionUpdate(action, actionChange)

        apiAction
            .updateAction(action._id, actionChange)
            .then((res) => {
                this.applySectionsPushedOut(mission, res?._dependentsShifted)
                this.missionUpdateSectionDependents(before, change, mission)

                if (mission.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(mission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
                if (cb) {
                    cb(toSection({ ...action, ...actionChange }))
                }
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") ||
                        "Sorry an error occured. Please refresh and try again. We are also investigating."
                )

                this.updateStateForActionUpdate(action, pick(action, Object.keys(actionChange)))
            })
    }

    /**
     * The sections the API pushed out because they wait for one whose end moved later. The server
     * does this so a date typed into a picker pushes work out the same way a dragged bar does; the
     * moves come back with the response because this tab ignores its own changes over the socket.
     *
     * @param mission {object}
     * @param [shifted] {{_id: string, startDate: number, endDate: number}[]}
     */
    applySectionsPushedOut(mission, shifted) {
        if (!shifted?.length) return

        this.updateStateForActionUpdateBulk(mission._id, shifted)

        const lastEnd = Math.max(...shifted.map((s) => s.endDate))

        // The freshest copy: this runs twice for one change (on the drop, then with the response),
        // and the project's end must not be sent again once the first pass has pushed it out
        const current = this.state.missions.find((m) => m._id === mission._id) || mission

        if (lastEnd > current.planEndDate) {
            if (!toast.isActive("ext-plan")) {
                toast.warning("🥑 This change has caused your project end date to be pushed out.", {
                    toastId: "ext-plan",
                    autoClose: 8000,
                })
            }

            this.missionUpdate(mission._id, { planEndDate: lastEnd })
        }
    }

    /** A section's dependsOn is its action's dependencies, kept through their own endpoints */
    missionUpdateSectionDependsOn(mission, action, dependsOn) {
        const current = toSection(action).dependsOn
        const sectionIds = getSections(mission).map((s) => s._id)
        const wanted = uniq(dependsOn.filter((id) => sectionIds.includes(id) && id !== action._id))
        const added = wanted.filter((id) => !current.includes(id))
        const removed = current.filter((id) => !wanted.includes(id))

        if (!added.length && !removed.length) return

        const phase = mission.planItems.find((p) => p._id === action.missionPlanId)
        const dependencies = [
            ...(action.dependencies || []).filter((d) => !removed.includes(getObjectId(d.action))),
            ...added.map((id) => ({
                action: { _id: id, missionId: mission._id },
                mission: { _id: mission._id, title: mission.title },
                missionPlan: { _id: phase?._id, title: phase?.title },
            })),
        ]

        this.updateStateForActionUpdate(action, { dependencies })

        Promise.all([
            ...added.map((id) => apiAction.addActionDependency(action._id, id)),
            ...removed.map((id) => apiAction.removeActionDependency(action._id, id)),
        ]).catch((err) => {
            this.silentFail("sectionDependsOn " + (err?.message || err))
        })
    }

    /** Deletes a section; its tasks fall back to the catch-all (the API moves them) */
    missionDeleteSection(missionId, section, cb) {
        const mission = this.state.missions.find((m) => m._id === missionId)
        const action = getSectionActions(mission).find((a) => a._id === section?._id)
        const catchAll = getBoardAction(mission)

        if (!action || !catchAll) {
            this.silentFail("sectionDeleteMissing " + section?._id)
            return
        }

        apiAction
            .deleteAction(action._id, { moveTo: catchAll._id })
            .then((res) => {
                // Other sections that depended on it no longer do
                getSectionActions(mission)
                    .filter((a) => a._id !== action._id && toSection(a).dependsOn.includes(action._id))
                    .forEach((a) =>
                        this.updateStateForActionUpdate(a, {
                            dependencies: (a.dependencies || []).filter(
                                (d) => getObjectId(d.action) !== action._id
                            ),
                        })
                    )

                // Its tasks as they are now: ones deleted meanwhile stay deleted
                const current = getSectionActions(this.state.missions.find((m) => m._id === missionId)).find(
                    (a) => a._id === action._id
                )

                this.updateStateForActionItemUpdateBulk(
                    missionId,
                    (current?.actionItems || []).map((ai) => ({
                        obj: ai,
                        change: { _id: ai._id, actionId: catchAll._id, missionPlanId: catchAll.missionPlanId },
                    }))
                )
                this.updateStateForActionDelete(current || action)

                if (cb) cb(res)

                if (mission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(mission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") ||
                        "Sorry an error occured. Please refresh and try again. We are also investigating."
                )
            })
    }

    /**
     * Moves tasks into a section (or, with CATCH_ALL_ID, out of every section), with any other
     * fields that change with the move (e.g. y, col). Returns the save, which rejects (after the
     * toast) when it fails.
     */
    actionItemMoveToSection(mission, actionItems, sectionId, extraChange = {}, cb) {
        mission = this.state.missions.find((m) => m._id === mission?._id) || mission

        const toAction = getSectionTaskAction(mission, sectionId)

        if (!toAction) {
            toast.error("Sorry, that section was not found. Please refresh and try again.")
            return Promise.reject(new Error("section not found"))
        }

        const moving = actionItems.filter((ai) => ai.actionId !== toAction._id)
        const staying = actionItems.filter((ai) => ai.actionId === toAction._id)

        if (staying.length && !isEmpty(extraChange)) {
            this.actionItemUpdateBulk(
                mission._id,
                staying.map((ai) => ({ obj: ai, change: { _id: ai._id, ...extraChange } }))
            )
        }

        if (!moving.length) {
            if (cb) cb()
            return Promise.resolve()
        }

        const change = { ...extraChange, actionId: toAction._id, missionPlanId: toAction.missionPlanId }

        this.updateStateForActionItemUpdateBulk(
            mission._id,
            moving.map((ai) => ({ obj: ai, change: { ...change, _id: ai._id } }))
        )

        return apiActionItem
            .moveActionItemBulk(
                mission._id,
                moving.map((ai) => ({ ...extraChange, _id: ai._id, actionId: toAction._id }))
            )
            .then(() => {
                if (cb) cb()
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") || "Sorry, the move did not save. Please refresh and try again."
                )

                this.updateStateForActionItemUpdateBulk(
                    mission._id,
                    moving.map((ai) => ({
                        obj: { ...ai, ...change },
                        change: { ...pick(ai, Object.keys(change)), _id: ai._id },
                    }))
                )

                throw err
            })
    }

    simpleMissionsAddRoleForNewPerson(person, mission) {
        if (this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson) return

        this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson = true

        let org, orgRole, meInOrg

        if (!mission) return

        if (mission.org) {
            org = this.state.orgs.find((o) => o._id === getObjectId(mission.org))

            meInOrg = org?.people.find((op) => getRefId(op) === this.state.person._id)

            if (org && (!org.rolesNeedApproval || person.autoCreateRole)) {
                const personInOrg = (org.people || []).find(
                    (p) => getRefId(p) === (person.inviteeRef || getRefId(person.ref) || getRefId(person))
                )
                if (personInOrg) {
                    orgRole = getRole(personInOrg.role, org)
                }
            } else {
                return false
            }
        }

        if (!org?.isLicensed) {
            return false
        }

        //Catches the roles need approval scenario and the person can approve override (CheckBoxes from mission invite)
        if (org && org.rolesNeedApproval && !person.autoCreateRole) return

        const theID = person.inviteeRef || getRefId(person)

        if (getQ()["invite-to-phase"]) {
            const pi = mission.planItems.find((pi) => pi._id === getQ()["invite-to-phase"])

            if (pi) {
                this.planItemUpdateX(
                    pi,
                    {
                        person: theID,
                    },
                    () => {
                        toast("Person was added to the role.")
                    }
                )
            }

            removeParam("invite-to-phase")
            return
        }

        const planItemAlreadyExists = mission.planItems.find((pi) => pi.person === theID && !pi.personLeftRole)

        if (planItemAlreadyExists) {
            if (
                !mission.people.find((p) => {
                    return getRefId(p) === planItemAlreadyExists.person
                })
            ) {
                this.updateStateForPlanItemRemove(planItemAlreadyExists)
                return
            }

            toast.error(
                'Sorry we found a potential conflict with another role. Please assign manually in the projects "Budget" panel',
                {
                    autoClose: false,
                }
            )
            return
        }

        const catchStd =
            isAfter(startOfDay(new Date()), toZonedTime(mission.planEndDate)) ||
            isBefore(startOfDay(new Date()), toZonedTime(mission.planStartDate))
                ? toZonedTime(mission.planStartDate)
                : startOfDay(new Date())

        const cathEnd = toZonedTime(mission.planEndDate)

        this.planItemCreateX(
            mission._id,
            {
                title: orgRole ? orgRole.title : person.config ? person.config.role : "Team member",
                role: orgRole ? orgRole._id : null,
                allocation: 100,
                rateTime: getOrgRoleRateTime(orgRole, org),
                type: "person",
                pinnedTo: "entireMission",
                rate: getOrgRoleRate(orgRole) || 0,
                billRate: mission.billUsingMilestones ? 0 : getOrgBillRate(orgRole) || 0,
                billUnit: getOrgBillUnit(orgRole),
                y: 0,
                person: theID,
                startDate: getTimeUtc(catchStd),
                endDate: getTimeUtc(cathEnd),
            },
            (piRes) => {
                if (org && meInOrg) {
                    if (org.rolesNeedApproval && (meInOrg.canApproveRoles || meInOrg.permission === 2)) {
                        assignPersonToRole(theID, piRes, orgRole ? orgRole._id : null, org, mission, this, null, true)
                    }
                }

                this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson = undefined
            }
        )
    }
    profileUpdateState(changeObj) {
        this.setState({
            person: update(this.state.person, {
                $merge: changeObj,
            }),
        })
    }

    /**
     * Fetch one or more mission trees and update state.
     * @param mid {string|string[]} One or more mission ids
     */

    missionUpdateState(id, change, cb, push) {
        missionUpdateStateFor(this, id, change, cb, push)
    }
    /**
     * @param [options] {{ derived: Boolean, pinnedOnly: Boolean, shift: object }}
     *   derived: the dates were worked out from the plan itself (its phases or tasks), so they
     *   aren't checked against the work that has started.
     *   pinnedOnly: only pinned items follow the new dates - whoever moved the tasks moves
     *   the rest (Gantt and Workboard task edits).
     *   shift: {from, to} - "shift what hasn't started": unpinned items that haven't started
     *   move this far instead of taking the project's rules (see missionUpdatePinnedItems)
     */
    missionUpdate(id, change, cb, overrideState, options = {}) {
        const changedIndex = this.state.missions.findIndex((mission) => mission._id === id)

        if (changedIndex === -1 && !overrideState) {
            toast.warning(
                "An update was triggered but I couldn't find the mission you are trying to update. Please email us at help@missionx.ai if the problem persists",
                {
                    autoClose: 6000,
                }
            )
            this.silentFail("An update was triggered but I couldn't find the mission you are trying to " + id)
            return
        }

        if (change.org && typeof change.org === "string") {
            change.org = this.state.orgs.find((org) => org._id === change.org)
        }

        if (change.org && typeof change.org !== "string") {
            change.org = change.org._id
        }

        const preChange = { ...this.state.missions[changedIndex] }

        // Work that is done or under way stays where it happened: the project can't start
        // after it or end before it. What hasn't started can still be shifted.
        const blockedBy =
            changedIndex !== -1 && !options.derived
                ? getDateChangeBlock(this.state.missions[changedIndex], change)
                : null

        if (blockedBy) {
            const taskName = blockedBy.task?.title ? `"${blockedBy.task.title}"` : "a task"
            const date = format(blockedBy.date, "d MMM yyyy")

            toast.warning(
                blockedBy.field === "start"
                    ? `The project can't start after ${taskName}, which is ${
                          isTaskDone(blockedBy.task) ? "completed" : "in progress"
                      } (${date}). To move the rest of the plan, shift what hasn't started.`
                    : `The project can't end before ${taskName}, which is completed (${date}).`,
                { autoClose: 9000, toastId: "project-dates-blocked" }
            )
            this.unBlock()

            return Promise.resolve()
        }

        let missionData = { ...this.state.missions[changedIndex], ...change }

        if (missionData?.isTemplate && !change.hasOwnProperty("isTemplateSaved")) {
            change.isTemplateSaved = false
            missionData.isTemplateSaved = false
        }

        if (missionData.planEndDate < missionData.planStartDate) {
            const length = preChange.planEndDate - preChange.planStartDate

            // A start moved past the end takes the end along: the project keeps its length and
            // everything in it moves as one, rather than being squeezed into a single week
            missionData.planEndDate =
                change.planStartDate && !change.planEndDate && length > 0
                    ? change.planStartDate + length
                    : getTimeUtc(endOfWeek(toZonedTime(missionData.planStartDate), 1, { weekStartsOn: 1 }))
            // From the merged start - an end-only change has no planStartDate
            change.planEndDate = missionData.planEndDate
        }

        const datesChanged = Boolean(change.planStartDate || change.planEndDate)

        this.missionUpdateState(id, change, () => {
            if (cb) cb(this.state.missions[changedIndex])
        })

        return apiMission.updateMission(id, change).then(
            (res) => {
                // Plan items follow the dates once the project has them - a refused or failed
                // save leaves both where they were
                if (datesChanged) {
                    try {
                        const current = this.state.missions.find((m) => m._id === id)

                        this.missionUpdatePinnedItems(
                            current
                                ? {
                                      ...current,
                                      planStartDate: missionData.planStartDate,
                                      planEndDate: missionData.planEndDate,
                                  }
                                : missionData,
                            preChange.planStartDate,
                            preChange.planEndDate,
                            { pinnedOnly: options.pinnedOnly, shift: options.shift }
                        )
                    } catch (e) {
                        this.silentFail("missionUpdatePinnedItems error: " + getErrorMsg(e))
                    }
                }

                return res
            },
            (err) => {
                const ddta = JSON.stringify({ ...change, _id: id })
                try {
                    this.silentFail("missionUpdate error: " + getErrorMsg(err) + ddta)
                } catch (e) {
                    this.silentFail("rt55t5" + getErrorMsg(err) + ddta)
                }

                if (datesChanged && changedIndex !== -1) {
                    // Put back the dates the server didn't take, unless something newer replaced them
                    const current = this.state.missions.find((m) => m._id === id)
                    const revert = {}

                    ;["planStartDate", "planEndDate"].forEach((field) => {
                        if (current && current[field] === missionData[field] && preChange[field] !== missionData[field]) {
                            revert[field] = preChange[field]
                        }
                    })

                    if (Object.keys(revert).length) this.missionUpdateState(id, revert)

                    toast.warning(
                        err?.code === "project/dates_fixed_by_started_work" && err?.message
                            ? err.message
                            : "The project's dates couldn't be saved, so they were put back.",
                        { autoClose: 9000, toastId: "project-dates-blocked" }
                    )
                }
            }
        )
    }

    missionVendorAdd(mission, vendorId, cb) {
        apiMission
            .addMissionVendor(mission._id, vendorId)
            .then((res) => {
                this.missionUpdateState(mission._id, { vendors: res.vendors })
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }

    missionVendorRemove(mission, vendorId, cb) {
        apiMission
            .removeMissionVendor(mission._id, vendorId)
            .then((res) => {
                this.missionUpdateState(mission._id, { vendors: res.vendors })
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }

    /**
     * A section's dates changed: its open tasks outside the new dates move to its start, unless
     * they're being worked on (kanban: past todo; simple: this week, started and staffed).
     */
    missionUpdateSectionDependents(section, change, mission) {
        if (!change.from && !change.to) {
            return
        }

        const from = change.from ?? section.from
        const to = change.to ?? section.to

        if (!from) {
            return
        }

        const action = getSectionActions(mission).find((a) => a._id === section._id)

        // The day a task sits on the workboard: its start, unless that is no longer in its week
        // (the week is what the board shows)
        const placedOn = (ai) =>
            ai.startDate && (!ai.week || isSameWeek(toZonedTime(ai.startDate), toZonedTime(ai.week), { weekStartsOn: 1 }))
                ? ai.startDate
                : ai.week
        const outside = (ai) => {
            const day = placedOn(ai)

            return ai.status !== "done" && Boolean(day) && (day < from || (to && day > to))
        }

        let tasks = (action?.actionItems || []).filter(outside)

        if (mission.projectType === "kanban") {
            tasks = tasks.filter((ai) => ai.col === "todo")
        } else if (mission.projectType === "simple") {
            tasks = tasks.filter(
                (ai) =>
                    !(
                        isThisWeek(toZonedTime(placedOn(ai))) &&
                        isBefore(toZonedTime(placedOn(ai)), new Date()) &&
                        ai.people?.length > 0
                    )
            )
        }

        // Onto the section's first day, the way "Add to workboard" places a task: its week, its
        // day and hour in that week, and a length that still fits the week
        const day = toZonedTime(from).getDay()
        const startHour = day === 0 ? 6 * 8 : (day - 1) * 8
        const week = getTimeUtc(startOfWeek(toZonedTime(from), { weekStartsOn: 1 }))

        const changes = tasks.map((ai) => ({
            obj: ai,
            change: {
                _id: ai._id,
                week,
                startDate: from,
                startHour,
                ...(typeof ai.estimatedDuration === "number" && {
                    estimatedDuration:
                        startHour + ai.estimatedDuration > 56 ? 56 - startHour : ai.estimatedDuration,
                }),
            },
        }))

        if (!changes.length) {
            return
        }

        const ending = changes.length === 1 ? "" : "s"

        if (!toast.isActive("sectTagKiller"))
            toast.success(
                changes.length +
                    " task" +
                    ending +
                    " on your work board not being worked on " +
                    (ending === "s" ? "have been" : "has been") +
                    " moved to align with the new dates.",
                {
                    autoClose: 7000,
                    toastId: "sectTagKiller",
                }
            )

        this.actionItemUpdateBulk(mission._id, changes)
    }
    missionUpdatePerson(missionId, missionPersonId, changeObj, cb) {
        const myMission = this.state.missions.find((m) => m._id === missionId)

        return apiMission
            .updateMissionPeople(missionId, missionPersonId, changeObj)
            .then((res) => {
                if (res?.people) {
                    this.missionUpdateState(missionId, { people: res.people })
                } else if (res) {
                    const myIndex = myMission.people?.findIndex((p) => p._id === missionPersonId)
                    myMission.people[myIndex] = res

                    this.missionUpdateState(missionId, { people: myMission.people })
                }

                if (cb) cb(myMission)
            })
            .catch((err) => {
                toast.error(`🤔 Something went wrong.... ${err ? err.message : ""}`)
                if (cb) cb()
            })
    }
    orgUpdatePerson(orgId, orgPersonId, changeObj, cb) {
        apiOrg
            .updateOrgPeople(orgId, orgPersonId, changeObj)
            .then((res) => {
                if (cb) {
                    cb(res)
                }

                let newOrg = this.state.orgs.find((o) => getObjectId(o) === orgId)
                let personIndex = newOrg.people.findIndex((p) => getRefId(p) === getRefId(res))
                const ref = newOrg.people[personIndex].ref

                if (personIndex === -1) return

                let newPeople = newOrg.people.slice()

                newPeople[personIndex] = { ...res, ref }

                this.orgUpdateState(newOrg, { people: newPeople })
            })
            .catch((err) => {
                toast.error(`On no. Something went wrong updating the member. ${err ? err.message : ""}`, {
                    autoClose: 5000,
                })
                this.silentFail("wjehyhkk-1" + err?.message || err)
            })
    }

    ganttGetEndDate(ai, newStartDate) {
        const dur = ai.estimatedDuration / 8

        let theEnd = endOfDay(addDays(newStartDate, dur - 1))

        if (ai.includeWeekends) {
            return theEnd
        } else {
            if (isSaturday(newStartDate)) {
                theEnd = addDays(theEnd, 2)
            } else if (isSunday(newStartDate)) {
                theEnd = addDays(theEnd, 1)
            }

            if (isSaturday(theEnd)) {
                theEnd = nextMonday(theEnd)
            } else if (isSunday(theEnd)) {
                theEnd = nextTuesday(theEnd)
            }

            return theEnd
        }
    }
    missionPlanDates(id) {
        let mission

        if (typeof id === "string") {
            mission = this.state.missions.find((m) => m._id === id)
        } else {
            mission = this.state.missions.find((m) => m._id === id._id)
        }

        if (!mission) return

        const myPerm = getMissionPerson(mission, this.state.person._id)

        if (myPerm && myPerm.permission !== 1 && myPerm.permission !== 2) {
            return
        }

        if (mission.projectType === "power") {
            if (mission.planItems.filter((p) => p.type === "phase").length === 0) {
                return
            }

            const planItems = mission.planItems.filter((p) => p.type === "phase")

            if (planItems.length) {
                const planStartDate = planItems.sort((a, b) => a.startDate - b.startDate)[0].startDate
                const planEndDate = planItems.sort((a, b) => a.endDate - b.endDate).reverse()[0].endDate

                this.missionUpdate(
                    mission._id,
                    {
                        planStartDate: planStartDate,
                        planEndDate: planEndDate,
                    },
                    undefined,
                    undefined,
                    { derived: true }
                )
            }
        }
    }
    /**
     * @param [options] {{ pinnedOnly: Boolean, shift: object }} See missionUpdate. Either way
     *   everything goes out in one planItemUpdateBulk, so nothing is moved twice
     */
    missionUpdatePinnedItems(mission, beforeStartDate, beforeEndDate, options = {}) {
        if (typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === mission)
        }

        let changeArray = []

        if (!mission?.planItems || !mission.planStartDate || !mission.planEndDate) {
            return
        }

        if (mission.isTemplate) {
            return
        }

        // Pinned items follow the project's dates and keep their length. When the whole project
        // moves, the roles and equipment lines that aren't pinned move with it (see
        // utils/pinned-dates.js)
        const pinnedIds = new Set()
        // Unpinned items take the project's rules only when nothing else moves them
        const projectRules = !options.pinnedOnly && !options.shift
        const projectMove = projectRules ? getProjectMove(mission, beforeStartDate, beforeEndDate) : null

        mission.planItems
            .filter((pi) => {
                if (pi.type === "fundable_milestone") return false
                if (pi.personLeftRole || pi.wasDeleted || pi.inactive) return false

                // A one-off cost spread over the whole project means nothing. An equipment line's
                // dates are when the machines are needed, even when it's priced per use
                const pins = getLinePins(pi)

                if (
                    pins.start &&
                    pins.end &&
                    pi.type === "cost" &&
                    pi.rateTime === "One time" &&
                    pi.billUnit === "One time" &&
                    !isEquipmentLine(pi)
                ) {
                    return false
                }

                return true
            })
            .forEach((pi) => {
                const next = getPinnedDates(pi, mission)

                if (!next) {
                    const moved = getMovedDates(pi, projectMove)

                    if (moved) changeArray.push({ obj: pi, change: { _id: pi._id, ...moved } })

                    return
                }

                pinnedIds.add(pi._id)

                if (!isPinnedChange(pi, next)) return

                changeArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        startDate: next.startDate,
                        endDate: next.endDate,
                        requestedDays: next.requestedDays,
                    },
                })
            })

        // Cost lines that aren't pinned move when the whole project does, and are brought back
        // inside the project's dates when they no longer fit - in every kind of project. Pinned
        // lines followed their pins above; equipment lines and lines tied to a task never take
        // these rules
        if (projectRules) {
            mission.planItems
                .filter(
                    (pi) =>
                        pi.type === "cost" &&
                        !isEquipmentLine(pi) &&
                        !pinnedIds.has(pi._id) &&
                        !pi.wasDeleted &&
                        !pi.inactive
                )
                .forEach((pi) => {
                    const next = getCostLineDates(pi, mission, {
                        startDate: beforeStartDate,
                        endDate: beforeEndDate,
                    })

                    if (next) changeArray.push({ obj: pi, change: { _id: pi._id, ...next } })
                })
        }

        if (options.shift) {
            changeArray.push(...this.getShiftUnstartedChanges(mission, options.shift, beforeEndDate))
        }

        // Roles take their schedules along and equipment lines their machine bookings -
        // planItemUpdateBulk asks about those
        if (changeArray.length) {
            this.planItemUpdateBulk(mission._id, changeArray)
        }
    }
    /**
     * "Shift what hasn't started": the roles, equipment lines and cost lines that aren't
     * pinned and haven't started move as far as `from` -> `to`, keeping their length. What
     * has started or finished stays where it is. Pinned items follow the project's dates
     * (missionUpdatePinnedItems) and budgets on tasks follow their tasks. The tasks
     * themselves are moved by whoever calls this - each project type has its own way.
     *
     * @param missionId {string}
     * @param shift {{ from: Number, to: Number }} Two dates the shift's length apart
     */
    missionShiftUnstarted(missionId, shift = {}) {
        const mission = this.state.missions.find((m) => m._id === missionId)
        const changes = this.getShiftUnstartedChanges(mission, shift)

        if (changes.length) return this.planItemUpdateBulk(missionId, changes)
    }
    /**
     * The planItemUpdateBulk changes for missionShiftUnstarted
     *
     * @param [endBefore] {number} The project's end before the shift, if it has already moved
     */
    getShiftUnstartedChanges(mission, { from, to } = {}, endBefore = mission?.planEndDate) {
        if (!mission?.planItems || mission.isTemplate || !from || !to || from === to) return []

        const move = { fromStart: from, toStart: to }
        // Lines moving later may run past a project end that is still on its way out
        const within = { ...mission, planEndDate: Math.max(endBefore, endBefore + (to - from)) }
        const changes = []

        mission.planItems
            .filter((pi) => pi.type !== "fundable_milestone" && !pi.personLeftRole && !pi.wasDeleted && !pi.inactive)
            .forEach((pi) => {
                const pins = getLinePins(pi)

                if (pins.start || pins.end) return

                const next = getMovedDates(pi, move) || getCostLineDates(pi, within, {}, { move })

                if (next) changes.push({ obj: pi, change: { _id: pi._id, ...next } })
            })

        return changes
    }
    missionCleanUpDeleted(id, personId, cb) {
        let q = getQ()

        const isMissionOpen = q.mission && q.mission === id

        const paramArray = []

        if (q["mission-create"]) {
            paramArray.push("mission-create")
        }
        if (q["mc"]) {
            paramArray.push("mc")
        }

        if (isMissionOpen) {
            paramArray.push("mission")
            paramArray.push("mission-tab")
            paramArray.push("make-week")
            paramArray.push("week")

            if (personId && personId !== this.state.personId)
                toast("Sorry this project is no longer accessible", {
                    autoClose: 6000,
                })
        }

        const missionIndex = this.state.missions.findIndex((m) => m._id === id)

        if (missionIndex === -1) {
            return
        }

        removeParams(paramArray.join(","))

        const missionData = this.state.missions[missionIndex]

        let orgOfMission = missionData?.org
            ? this.state.orgs.find((o) => getObjectId(o) === getObjectId(missionData.org))
            : null

        const meInOrg = orgOfMission ? orgOfMission?.people?.find((p) => getRefId(p) === this.state.person._id) : null

        let passThrough = false

        if (meInOrg?.permission === 1 || meInOrg?.permission === 2) {
            if (!meInOrg.accessibleDepartments?.length) {
                //Can see it at  org level
                passThrough = true
            } else if (!missionData.departments?.length) {
                //free for all
                passThrough = true
            } else if (missionData.departments?.filter((value) => meInOrg.accessibleDepartments.includes(value))) {
                //has access to the dept
                passThrough = true
            }
        }

        let newMissions = this.state.missions.slice()

        if (passThrough && personId) {
            const meInMissionIndex = newMissions[missionIndex].people.findIndex(
                (p) => getRefId(p) === this.state.person._id
            )

            if (meInMissionIndex !== -1) {
                newMissions[missionIndex].people[meInMissionIndex].permission = 4
                newMissions[missionIndex].people[meInMissionIndex].isProjectManager = null
            }
        } else {
            newMissions.splice(missionIndex, 1)
        }

        let changePasser = {
            missions: newMissions,
        }

        if (orgOfMission?.missions) {
            let mOrgIndex = orgOfMission.missions.findIndex((mm) => mm._id === missionData._id)

            if (mOrgIndex !== -1) {
                orgOfMission.missions.splice(mOrgIndex, 1)

                let newOrgs = this.state.orgs.slice()

                const myOrgIndex = this.state.orgs.find((o) => getObjectId(o) === getObjectId(missionData.org))

                newOrgs[myOrgIndex] = orgOfMission

                changePasser.orgs = newOrgs
            }
        }

        this.commitState(changePasser, () => {
            this.commitState(
                {
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId: id,
                    },
                },
                () => {
                    if (cb) cb()
                }
            )
        })

        //test
    }

    orgRemoveMissionFromDeadline(mission, org) {
        if (!org) return

        let newProposalDeadlines = (org.proposalDeadlines || []).slice()
        let newProposalDeadlinesIndex = newProposalDeadlines.findIndex((t) => t.missionId === mission._id)

        if (newProposalDeadlinesIndex === -1) {
            return
        }

        newProposalDeadlines[newProposalDeadlinesIndex] = {
            ...newProposalDeadlines[newProposalDeadlinesIndex],
            ...{
                missionId: null,
            },
        }

        newProposalDeadlines.forEach((item, i) => {
            item.y = item.y || 0
            delete item._id
        })

        this.orgUpdate(org._id, {
            proposalDeadlines: newProposalDeadlines,
        })
    }
    missionArchive(id, cb) {
        //  this.block("Removing project ☠️")

        const me = this
        const mission = this.state.missions.find((m) => m._id === id)

        //Delete a proposal with linked project
        if (mission.linkedProject) {
            const linkedMission = this.state.missions.find((m) => m._id === mission.linkedProject)

            apiMission
                .deleteMission(id)
                .then((res) => {
                    emitMissionDeleted(id)
                    me.missionCleanUpDeleted(id, null, () => {
                        toast("Deleted " + mission.title + ". help@missionx.ai.", {
                            autoClose: 3000,
                        })
                    })

                    if (linkedMission) {
                        apiMission
                            .deleteMission(linkedMission._id)
                            .then((res) => {
                                emitMissionDeleted(linkedMission._id)
                                me.missionCleanUpDeleted(linkedMission._id)
                            })
                            .catch((err) => {
                                toast.error("🤔 " + err?.message)
                            })
                    }
                })
                .catch((err) => {
                    this.silentFail("kvnjerhfk44---" + (err?.message + " - " + err?.toString()))

                    toast.error("🤔 " + err?.message)
                })
        } else if (mission.isTemplate && mission.linkedTemplate) {
            this.block("One sec...")

            apiTemplate
                .deleteTemplateBulk([mission.linkedTemplate])
                .then(() => {
                    apiMission
                        .deleteMission(id)
                        .then((res2) => {
                            this.unBlock()
                            emitMissionDeleted(id)
                            me.missionCleanUpDeleted(id, null, () => {
                                toast("Ok done help@missionx.ai", {
                                    autoClose: 3000,
                                })
                                if (cb) cb()
                            })
                        })
                        .catch((err) => {
                            toast.error("🤔 " + err?.message)
                        })
                })
                .catch((err) => {
                    this.silentFail("we3333rredfcerewr-" + (err?.message + " - " + err?.toString()))
                    toast.error("🤔 " + err?.message)
                    this.unBlock()
                })
        } else {
            apiMission
                .deleteMission(id)
                .then((res) => {
                    emitMissionDeleted(id)
                    me.missionCleanUpDeleted(id, null, () => {
                        toast("Deleted " + mission.title + ". help@missionx.ai.", {
                            autoClose: 3000,
                        })
                    })
                })
                .catch((err) => {
                    this.silentFail("ewty56uhfdrtr---" + (err?.message + " - " + err?.toString()))
                    //toast.error("🤔 " + err?.message)
                })
        }
    }
    orgInvitePerson(orgid, inviteeEmail, details, cb, noTip) {
        apiOrg
            .createInvite(orgid, inviteeEmail, details)
            .then(async (res) => {
                try {
                    const newPerson = await getOrgPeople(orgid, {
                        limit: 1,
                    })

                    this.updateStateForNewOrgPerson(orgid, { ...newPerson.value[0] })
                } catch (erre) {}

                if (!noTip) toast.success("Great! Invitation sent to " + inviteeEmail, { autoClose: 1000 })

                if (cb) cb(res)
            })
            .catch((err) => {
                if (cb) cb("ERROR")
                toast.error(
                    "Oh oh. Something unexpected just happened. An urgent ticket was created and a missionX helper will get back to you ASAP. In the meantime please try a browser refresh to see if that helps",
                    { autoClose: 8000 }
                )
                this.silentFail("243oih3henw" + (err?.message || err))
            })
    }

    async missionInvitePerson(missionId, inviteeEmail, deets, cb, noToast) {
        let details = { ...deets, ...{ invitee: null } }

        const myMission = this.state.missions?.find((m) => m._id === missionId)

        const myOrg = myMission?.org ? this.state.orgs?.find((o) => o._id === getObjectId(myMission?.org)) : null

        const meInOrg = myOrg?.people?.find((p) => getRefId(p) === this.state.person._id)

        const isOrgPersonAddingThemselves =
            (meInOrg?.permission === 1 || meInOrg?.permission === 2) && inviteeEmail === meInOrg?.email

        try {
            const res = await apiMission.createInvite(missionId, inviteeEmail, details, {
                notify: !isOrgPersonAddingThemselves && !myOrg?.disableSetupNotifications,
            })

            const cbRes = { ...res, ...{ inviteDetails: deets } }

            const newMissionPeople = myMission?.people.slice()

            if (isOrgPersonAddingThemselves && myMission) {
                try {
                    const myIndex = myMission?.people.findIndex((p) => getRefId(p) === getRefId(meInOrg))

                    newMissionPeople[myIndex] = res?._id
                        ? res
                        : {
                              ...newMissionPeople[myIndex],
                              permission: 2,
                              isProjectManager: true,
                          }

                    this.missionUpdateState(myMission._id, { people: newMissionPeople })
                } catch (e) {
                    this.silentFail("isOrgPersonAddingThemselves" + e?.message)
                } finally {
                    if (cb) {
                        cb(cbRes)
                    }
                }

                return
            } else {
                newMissionPeople.push(res)
                this.missionUpdateState(myMission._id, { people: newMissionPeople })
            }

            if (cb) cb({ ...res, ...{ inviteDetails: deets } })

            toast.success("Mission invite sent to " + inviteeEmail, {
                position: "bottom-right",
            })

            if (cb) cb(cbRes)

            if (details.autoCreateRole) {
                try {
                    this.simpleMissionsAddRoleForNewPerson({ ...deets, ...res }, myMission)
                } catch (e) {
                    this.silentFail("isOrewrerergPersonAddis" + e?.message)
                }
            }

            const meInMission = myMission?.people?.find((p) => getRefId(p) === this.state.person._id)

            if (myMission?.autoAssign && (meInMission?.permission === 2 || meInMission?.isProjectManager)) {
                this.missionUpdate(missionId, {
                    autoAssign: false,
                })
            }

            return cbRes
        } catch (err) {
            if (err.code && err.code.replaceAll(" ", "") === "invite/already_invited") {
                const personsOnMission = myMission?.people.find((p) => getRefId(p) === err.data.personId)

                if (!personsOnMission) {
                    toast("Oops. " + err?.message, { autoClose: 5000 })
                    this.silentFail(":sdhjidhdw" + err?.message)
                    if (cb) {
                        cb(personsOnMission)
                    }
                    return
                }

                if (personsOnMission.permission <= 3) {
                    toast("Oops. That person appears to already be on the mission team!", { autoClose: 5000 })
                    if (cb) cb(personsOnMission)
                    return personsOnMission
                }

                if (cb) cb(personsOnMission)

                toast.success("Mission invite for " + inviteeEmail, {
                    position: "bottom-right",
                })

                if (details.autoCreateRole) {
                    try {
                        this.simpleMissionsAddRoleForNewPerson({ ...deets, ...personsOnMission }, myMission)
                    } catch (e) {
                        this.silentFail("swejwjiww__kmmmmm" + e?.message)
                    }
                }

                return personsOnMission
            }

            try {
                this.silentFail("welkj983k03---3" + (err?.message + " - " + err?.toString()))

                toast.error("Sorry. " + err.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                })

                if (cb) cb(false)
            } catch (err) {
                this.silentFail("welkj983k03---47498" + (err?.message + " - " + err?.toString()))
                if (cb) cb(false)
                toast.error(
                    "Sorry an issue occured. We are investigating. Please try again or contact help@missionx.ai"
                )
            }
        }
    }
    async missionResendInvite(missionId, peopleId, cb) {
        const myMission = this.state.missions?.find((m) => m._id === missionId)

        try {
            const res = await apiMission.resendInvite(missionId, peopleId)

            const newMissionPeople = myMission?.people.slice()
            const myIndex = newMissionPeople?.findIndex((p) => p._id === peopleId)

            if (myIndex > -1) {
                newMissionPeople[myIndex] = { ...newMissionPeople[myIndex], ...res }
                this.missionUpdateState(missionId, { people: newMissionPeople })
            }

            toast.success("Invitation resent.", { position: "bottom-right" })

            if (cb) cb(res)
        } catch (err) {
            toast.error(err?.message || "Failed to resend the invite. Please try again.", {
                autoClose: 6000,
            })
            if (cb) cb(false)
        }
    }
    async missionDeletePerson({ mission, person, noToast, app, cb }) {
        let missionPerson = mission.people.find((p) => getRefId(p) === getRefId(person))

        // The local list can lag behind the server (an invite whose socket event has not arrived yet)
        if (!missionPerson) {
            try {
                const res = await getMissionPeople({ project: mission._id, person: getRefId(person) })
                missionPerson = res.value?.[0]
            } catch (e) {}

            if (missionPerson) {
                const liveMission = this.state.missions.find((m) => m._id === mission._id) || mission
                const people = liveMission.people.some((p) => getRefId(p) === getRefId(missionPerson))
                    ? liveMission.people
                    : [...liveMission.people, missionPerson]

                mission = { ...liveMission, people }
            }
        }

        if (!missionPerson) {
            toast.warning(
                "Hmmm. It appears that person in not on the mission so that was easy. If this is not the case could you please refresh and try again? I have also sent an email to the team to investigate",
                { autoClose: 8000 }
            )
            app?.silentFail(
                "missionDeletePerson no person" + missionPerson?._id + "-" + getRefId(person) + "---" + mission?._id
            )

            return
        }

        const myOrg = mission.org ? app?.state.orgs.find((o) => o._id === getObjectId(mission.org)) : null

        const orgPerson = myOrg?.people?.find((p) => getRefId(p) === getRefId(person))

        const isSeniorOrgPerson = orgPerson?.permission === 2 || orgPerson?.permission === 1

        const missionPersonIndex = mission.people.findIndex((p) => getRefId(p) === getRefId(person))
        const ogPeople = mission.people.slice()
        let newMissionPeople = mission.people.slice()

        if (!isSeniorOrgPerson) {
            newMissionPeople.splice(missionPersonIndex, 1)
        } else {
            newMissionPeople[missionPersonIndex] = {
                ...newMissionPeople[missionPersonIndex],
                permission: 4,
                isProjectManager: null,
            }
        }

        if (!isSeniorOrgPerson) {
            if (this.state.mission === mission._id && getRefId(person) === this.state.person._id) {
                removeParam("mission")
            }
        }

        this.missionUpdateState(mission._id, { people: newMissionPeople })

        return apiMission
            .deleteMissionPeople(mission._id, missionPerson._id)
            .then((res) => {
                if (!noToast)
                    toast(
                        `${
                            getFullName(missionPerson?.ref?.firstName, missionPerson?.ref?.lastName) || "Person"
                        } has been removed.`
                    )

                if (cb) cb()
            })
            .catch((err) => {
                this.missionUpdateState(mission._id, { people: ogPeople })
                toast.error("Oops " + (err?.message || "Was not able to remove this person"), {
                    autoClose: 6000,
                })
                const meInMission = mission.people.find((p) => getRefId(p) === app.state.person._id)
                try {
                    this.silentFail(
                        "wewww3333qeq-w8" +
                            err?.message +
                            " " +
                            mission?._id +
                            " deleteing:" +
                            missionPerson?.email +
                            " Prm:" +
                            meInMission.permission
                    )
                } catch (e) {
                    this.silentFail(
                        "wewww3333qeq-w8-ERER" +
                            err?.message +
                            " " +
                            mission?._id +
                            " adding:" +
                            missionPerson?.email +
                            " Prm:" +
                            meInMission.permission
                    )
                }
            })
    }
    orgDeletePerson(orgId, refId, ref, options = {}, cb) {
        const org = this.state.orgs.find((o) => o._id === orgId)

        if (!org) {
            window.location.href = "/home"
        }

        const meInOrg = org.people?.find((p) => getRefId(p) === this.state.person._id)
        const isMeBeingRemoved = refId === this.state.person._id
        const numberOfAdmins = org.people?.filter((p) => p.permission === 2).length
        const iAmAnAdmin = meInOrg?.permission === 2

        //Deleteing myselef scenarios

        if (isMeBeingRemoved && numberOfAdmins === 1 && iAmAnAdmin && org.people.length > 1) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>🖐️ Warning 🖐️</p>
                        <p>
                            You are the only admin for this organization. If you leave it without making someone else an
                            admin it will be deleted along with all projects.
                        </p>
                        <p>Are you 100% sure you want to delete your organization?</p>
                    </div>
                ),
                onYes: () => {
                    this.orgDelete(orgId)
                },
            })

            return
        }
        if (isMeBeingRemoved && org.people?.length === 1) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>🖐️ Warning 🖐️</p>
                        <p>
                            Leaving this org along with all its projects will delete it since you are the only person in
                            it!
                        </p>
                        <p>Are you 100% sure you want to delete this organization?</p>
                    </div>
                ),
                onYes: () => {
                    this.orgDelete(orgId)
                },
            })

            return
        }

        if (isMeBeingRemoved) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>😢 Leave this organization and all projects?</p>
                    </div>
                ),

                onYes: () => {
                    apiOrg
                        .deleteOrgPeople(org._id, refId, { removeFromMissions: true })
                        .then(() => {
                            toast.success(
                                "Ok! You no longer have access to the organization. Why not start your own? 🦁",
                                {
                                    autoClose: 5000,
                                }
                            )

                            if (cb) cb()

                            this.orgCleanUpDeleted(org._id)
                        })
                        .catch((err) => {
                            toast.error(err.message)
                        })
                },
            })

            return
        }

        //Its not me anymore....

        const personBeingRemoved = org.people.find((p) => getRefId(p) === refId)

        this.confirm({
            severe: true,
            comp: (
                <div>
                    <p>
                        Remove{" "}
                        {getFullName(
                            personBeingRemoved.ref?.firstName,
                            personBeingRemoved.ref?.lastName,
                            "this person"
                        )}
                        ? This will remove them from the organization and all projects they are on!
                    </p>
                </div>
            ),
            onYes: () => {
                this.block()

                this.orgUpdatePerson(
                    orgId,
                    refId,
                    {
                        endDate: getTimeUtc(endOfDay(new Date())),
                    },
                    () => {
                        apiOrg
                            .deleteOrgPeople(org._id, refId, { removeFromMissions: true })
                            .then(() => {
                                if (ref) {
                                    toast(`${getFullName(ref.firstName, ref.lastName) || "Person"} has been removed.`)
                                } else {
                                    toast("Done.")
                                }
                                this.unBlock()

                                if (cb) cb()
                                this.updateStateForPersonRemovedOrg(refId, orgId, true)
                            })
                            .catch((err) => {
                                toast.warning(err.message, {
                                    autoClose: 6000,
                                })
                                this.unBlock()
                                this.silentFail("2iu3sss2i3" + (err?.message + " - " + err?.toString()))
                            })
                    }
                )
            },
        })
    }
    actionResetItems(action) {
        let myActionItemsAffected = []

        action.actionItems
            .filter((localAi) => localAi.startDate && localAi.status !== "done")
            .forEach((affectedActionItem) => {
                //Reset all the action items
                myActionItemsAffected.push({
                    obj: affectedActionItem,
                    change: {
                        _id: affectedActionItem._id,
                        startDate: null,
                        endDate: null,
                        y: null,
                        estimatedDuration: null,
                        estimatedEndDate: null,
                        startHour: null,
                    },
                })
            })

        if (myActionItemsAffected.length) {
            clearTimeout(this.yourChangesMsgTO)

            this.yourChangesMsgTO = setTimeout(() => {
                if (!toast.isActive("actionKiller"))
                    toast(
                        "🚧  One second please. " +
                            myActionItemsAffected.length +
                            " action item" +
                            (myActionItemsAffected.length === 1 ? "" : "s") +
                            " " +
                            (myActionItemsAffected.length === 1 ? "was" : "were") +
                            " moved to make dates align. This has affected your weekly plan so please review.",
                        {
                            autoClose: 9000,
                            toastId: "actionKiller",
                        }
                    )
            }, 7000)

            this.actionItemUpdateBulk(action.missionId, myActionItemsAffected)
        }
    }
    actionUpdate(obj, change, ignoreState, cancelReset, cb) {
        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        if (!ignoreState) this.updateStateForActionUpdate(obj, change, ignoreState)

        if (
            myMission.projectType !== "mx-gantt" &&
            !cancelReset &&
            change.startDate &&
            change.startDate !== obj.startDate
        ) {
            this.actionResetItems(obj)
        }

        return apiAction
            .updateAction(obj._id, change)
            .then((res) => {
                if (cb) cb(res)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                try {
                    this.silentFail(
                        "wqproir3jkdeAAA" +
                            JSON.stringify(change) +
                            " " +
                            JSON.stringify(obj) +
                            " " +
                            (err?.message || JSON.stringify(err))
                    )
                } catch (e) {
                    this.silentFail("enrjejej-SILENT")
                }
            })
    }
    actionUpdateX(obj, change, ignoreState, cb, stateCb) {
        if (!ignoreState) {
            this.updateStateForActionUpdate(obj, change, false, stateCb)
        }

        return apiAction
            .updateAction(obj._id, change)
            .then((res) => {
                if (cb) cb(res)
                const myMission = this.state.missions.find((m) => m._id === obj.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                //toast.error("An issue occured. I've let the team know.")
                this.silentFail("wlkehj2wkkoooo" + err?.message)
            })
    }
    actionUpdateBulkX(missionId, changes, cb, stateCb) {
        this.updateStateForActionUpdateBulk(missionId, changes, stateCb)

        apiAction
            .updateActionBulk(missionId, changes)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === missionId)
                if (cb) {
                    cb(myMission)
                }

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionUpdateBulk(missionId, actionChanges, updateState, cb) {
        if (actionChanges.length === 0) return

        if (updateState) {
            this.updateStateForActionUpdateBulk(missionId, actionChanges)
        }

        apiAction
            .updateActionBulk(missionId, actionChanges)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === missionId)
                const allActions = getAllActions(myMission)
                actionChanges.forEach((change) => {
                    const theAction = allActions.find((a) => a._id === change._id)

                    if (
                        change.startDate &&
                        this.state.missions.find((m) => m._id === missionId).projectType === "power"
                    ) {
                        this.actionResetItems(theAction)
                    }
                })

                if (cb) {
                    cb(res)
                }

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionCreateX(action, cb, skipState, options) {
        if (
            (action.startDate && !action.endDate) ||
            (!action.startDate && action.endDate) ||
            (action.startDate && action.endDate && action.startDate === action.endDate) ||
            action.startDate > action.endDate
        ) {
            if (!toast.isActive("app-action-create"))
                toast("Sorry was not able to create. Please refresh and try again?", {
                    toastId: "app-action-create",
                })
            return
        }

        if (!action.actionItems) {
            action.actionItems = []
        }

        return apiAction
            .createAction(action.planItemId, action, options)
            .then((res) => {
                if (!skipState) {
                    this.updateStateForActionCreate(res)
                }
                if (cb) cb(res)

                const myMission = this.state.missions.find((m) => m._id === res.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionCreate(action, cb, tip, skipStateUpdate) {
        const me = this

        if (
            (action.startDate && !action.endDate) ||
            (!action.startDate && action.endDate) ||
            (action.startDate && action.endDate && action.startDate === action.endDate) ||
            action.startDate > action.endDate
        ) {
            this.silentFail("ewrkoi48i3e-238383" + action._id)
            toast("Sorry was not able to create. Please try again?")
            return
        }

        if (!action.actionItems) {
            action.actionItems = []
        }
        return apiAction
            .createAction(action.planItemId, action)
            .then((res) => {
                if (tip !== "NONE" && !toast.isActive("activityCreateApp"))
                    toast(tip ? tip : "Successfully created ⚡", {
                        toastId: "activityCreateApp",
                    })

                if (!skipStateUpdate) me.updateStateForActionCreate(res)

                if (cb) {
                    cb(res)
                }

                const myMission = this.state.missions.find((m) => m._id === res.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionDelete(action, skipState, noToast, cb) {
        apiAction
            .deleteAction(action._id)
            .then((res) => {
                if (!this.skipState) {
                    this.updateStateForActionDelete(action)
                    if (!noToast)
                        toast.success((action.title || "item") + " was deleted", {
                            autoClose: 1000,
                        })
                }

                this.actionRemoveDependenciesAfterDelete(action)

                this.actionReplaceParentIdsAfterDelete(action)

                if (cb) cb(res, action)
            })
            .catch((err) => {
                throw err
            })
    }
    actionRemoveDependenciesAfterDelete(depAction) {
        const mission = this.state.missions.find((m) => m._id === depAction.missionId)

        getAllActions(mission)?.forEach((action, i) => {
            const foundMatch = action.dependencies?.find((d) => d.action._id === depAction._id)

            if (foundMatch) {
                apiAction.removeActionDependency(action._id, depAction._id).catch((err) => {
                    throw err
                })

                let dependencies = action.dependencies || []

                let myIndex = dependencies.find((d) => d.action._id === depAction._id)

                if (myIndex !== -1) {
                    dependencies.splice(myIndex, 1)
                }

                this.updateStateForActionUpdate(action, { dependencies: dependencies })
            }
        })
    }
    actionReplaceParentIdsAfterDelete(action, cb) {
        //Remove all parentId instances

        const myMission = this.state.missions.find((m) => m._id === action.missionId)
        const allActions = getAllActions(myMission)

        const myKids = allActions.filter((a) => a.parentId === action._id)

        let changesArray = []

        myKids.forEach((a, i) => {
            changesArray.push({
                _id: a._id,
                parentId: action.parentId || null,
            })
        })

        if (changesArray.length) {
            this.actionUpdateBulkX(myMission._id, changesArray, null, (res) => {
                if (cb) cb(res)
            })
        }
    }
    actionDeleteX(action, cb) {
        action = { ...action }

        apiAction
            .deleteAction(action._id)
            .then(() => {
                this.actionRemoveDependenciesAfterDelete(action)
                this.updateStateForActionDelete(action, (res) => {
                    if (cb) cb(res, action)
                })
            })
            .catch((err) => {
                throw err
            })
    }
    actionAddDependencyX({ action, depAction, mission, cb }) {
        apiAction
            .addActionDependency(action._id, depAction._id)
            .catch((err) => {
                throw err
            })
            .then((res) => {
                if (cb) {
                    cb(res)
                }
            })

        let dependencies = action.dependencies || []

        let newDep = {
            _id: depAction._id,
            title: depAction.title,
            missionId: depAction.missionId,
            planItemId: depAction.planItemId,
        }
        let newMiss = {
            _id: mission._id,
            title: mission.title,
        }
        let mathcingPi = mission.planItems.find((p) => p._id === depAction.missionPlanId)
        let newPi = {
            _id: mathcingPi._id,
            title: mathcingPi.title,
        }

        dependencies.push({
            action: newDep,
            missionPlan: newPi,
            mission: newMiss,
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionRemoveDependencyX({ action, depAction, mission, cb }) {
        apiAction
            .removeActionDependency(action._id, depAction._id)
            .catch((err) => {
                throw err
            })
            .then((res) => {
                if (cb) {
                    cb(res)
                }
            })

        let dependencies = action.dependencies || []

        let myIndex = dependencies.find((d) => d.action._id === depAction._id)

        if (myIndex !== -1) {
            dependencies.splice(myIndex, 1)
        }

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionAddDependency(actionId, dependencyActionId, action, dependencies) {
        if (!actionId || !dependencyActionId) {
            console.error("id missing")
        }

        apiAction.addActionDependency(actionId, dependencyActionId).catch((err) => {
            throw err
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionRemoveDependency(actionId, dependencyActionId, action, dependencies) {
        if (!actionId || !dependencyActionId) {
            console.error("id missing")
        }

        apiAction.removeActionDependency(actionId, dependencyActionId).catch((err) => {
            throw err
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionItemAddDependency(ai, dependencyAi, linkType = "dependsOn", cb, lag, onError) {
        if (!ai || !dependencyAi) return

        if (!linkType) {
            this.silentFail("we3e9999--" + ai._id)
            toast.warning("Oops. We spotted an issue and the team has been notified. We will respond asap! ")
            return
        }

        if (ai._id === dependencyAi._id) {
            this.silentFail("wewe727272--" + ai._id)
            return
        }

        const mission = this.state.missions.find((m) => m._id === ai.missionId)
        const aiMap = makeHash(getAllActionItems(mission))

        // Any actionItemUpdateBulk refetch-and-writeback still in flight for this mission was
        // issued before this dependency existed server-side. Bumping the shared sequence here
        // marks that older bulk save stale so its writeback (when it lands) skips overwriting
        // state instead of clobbering the dependency we're about to merge in.
        if (!this.aiBulkSeq) this.aiBulkSeq = {}
        this.aiBulkSeq[getObjectId(ai.missionId)] = (this.aiBulkSeq[getObjectId(ai.missionId)] || 0) + 1

        return apiActionItem.addDependency(ai._id, dependencyAi._id, linkType, lag).then(async (deps) => {
            const [gai1, gai2] = await Promise.all([
                getActionItems({
                    id: ai._id,
                    select: ["dependencies"],
                }),
                getActionItems({
                    id: dependencyAi._id,
                    select: ["dependencies"],
                }),
            ])

            const ai1 = { ...ai, ...gai1.value[0] }
            const ai2 = { ...dependencyAi, ...gai2.value[0] }

            const newDeps1 = []
            ai1.dependencies?.forEach((d, i) => {
                newDeps1.push({
                    ...d,
                    linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                    linkTo: hydrateDepEnd(aiMap, d.linkTo),
                })
            })
            const newDeps2 = []
            ai2.dependencies?.forEach((d, i) => {
                newDeps2.push({
                    ...d,
                    linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                    linkTo: hydrateDepEnd(aiMap, d.linkTo),
                })
            })

            this.updateStateForActionItemUpdate(
                ai,
                {
                    dependencies: newDeps1,
                },
                null,
                (r) => {
                    this.updateStateForActionItemUpdate(
                        ai2,
                        {
                            dependencies: newDeps2,
                        },
                        null,
                        (rr, m) => {
                            if (cb) cb(r, m)
                        }
                    )
                }
            )
        }).catch((err) => {
            toast.error(get(err, "message") || "Sorry, that dependency could not be created. Please try again.", {
                autoClose: 6000,
            })

            // Opt-in for callers that must see a failure (the mAX tool executors). The
            // promise still resolves, so existing callers keep their old behaviour.
            if (onError) onError(err)
        })
    }
    actionItemUpdateDependency(ai, dependencyItem, linkType, lag, cb) {
        if (!ai || !dependencyItem) return

        const existingDep = ai.dependencies?.find((l) => getObjectId(l.linkTo) === dependencyItem._id)

        if (!existingDep) {
            this.silentFail("actionItemUpdateDependency-missing--" + ai._id)
            return
        }

        const mission = this.state.missions.find((m) => m._id === ai.missionId)
        const aiMap = makeHash(getAllActionItems(mission))

        if (!this.aiBulkSeq) this.aiBulkSeq = {}
        this.aiBulkSeq[getObjectId(ai.missionId)] = (this.aiBulkSeq[getObjectId(ai.missionId)] || 0) + 1

        return apiActionItem.updateDependency(ai._id, getObjectId(existingDep), linkType, lag).then(async () => {
            const [gai1, gai2] = await Promise.all([
                getActionItems({
                    id: ai._id,
                    select: ["dependencies"],
                }),
                getActionItems({
                    id: dependencyItem._id,
                    select: ["dependencies"],
                }),
            ])

            const ai1 = { ...ai, ...gai1.value[0] }
            const ai2 = { ...dependencyItem, ...gai2.value[0] }

            const newDeps1 = []
            ai1.dependencies?.forEach((d) => {
                newDeps1.push({
                    ...d,
                    linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                    linkTo: hydrateDepEnd(aiMap, d.linkTo),
                })
            })
            const newDeps2 = []
            ai2.dependencies?.forEach((d) => {
                newDeps2.push({
                    ...d,
                    linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                    linkTo: hydrateDepEnd(aiMap, d.linkTo),
                })
            })

            this.updateStateForActionItemUpdate(
                ai,
                {
                    dependencies: newDeps1,
                },
                null,
                (r) => {
                    this.updateStateForActionItemUpdate(
                        ai2,
                        {
                            dependencies: newDeps2,
                        },
                        null,
                        (rr, m) => {
                            cb?.(r, m)
                        }
                    )
                }
            )
        }).catch((err) => {
            toast.error(get(err, "message") || "Sorry, that dependency could not be updated. Please try again.", {
                autoClose: 6000,
            })
        })
    }
    actionItemRemoveDependency(ai, dependencyItem, cb) {
        if (!ai || !dependencyItem) return

        if (ai._id === dependencyItem._id) {
            toast.error("Circular dependency")
            return
        }

        // linkTo is the task, or just its id when the link was not hydrated
        const removeDepIndex = (ai.dependencies || []).findIndex((l) => getRefId(l.linkTo) === dependencyItem._id)
        const dependencyToKill = ai.dependencies[removeDepIndex]

        if (!dependencyToKill) {
            this.silentFail("actionItemRemoveDependency-missing--" + ai._id)
            return
        }

        const mission = this.state.missions.find((m) => m._id === ai.missionId)
        const aiMap = makeHash(getAllActionItems(mission))

        const dependencyAi = aiMap[dependencyItem._id]

        if (!this.aiBulkSeq) this.aiBulkSeq = {}
        this.aiBulkSeq[getObjectId(ai.missionId)] = (this.aiBulkSeq[getObjectId(ai.missionId)] || 0) + 1

        apiActionItem.removeDependency(ai._id, getObjectId(dependencyToKill)).then(async () => {
            const [gai1, gai2] = await Promise.all([
                getActionItems({
                    id: ai._id,
                    select: ["dependencies"],
                }),
                getActionItems({
                    id: dependencyAi?._id,
                    select: ["dependencies"],
                }),
            ])

            const ai1 = { ...ai, ...gai1.value[0] }
            const ai2 = dependencyAi ? { ...dependencyAi, ...gai2.value[0] } : null

            const newDeps1 = []
            ai1.dependencies?.forEach((d, i) => {
                newDeps1.push({
                    ...d,
                    linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                    linkTo: hydrateDepEnd(aiMap, d.linkTo),
                })
            })

            let newDeps2 = []

            if (ai2) {
                ai2.dependencies?.forEach((d, i) => {
                    newDeps2.push({
                        ...d,
                        linkFrom: hydrateDepEnd(aiMap, d.linkFrom),
                        linkTo: hydrateDepEnd(aiMap, d.linkTo),
                    })
                })
            }

            //obj, change, dontUpdateView, cb, fromSocket

            this.updateStateForActionItemUpdate(
                ai,
                {
                    dependencies: newDeps1,
                },
                null,
                (r, mm) => {
                    if (ai2) {
                        this.updateStateForActionItemUpdate(
                            ai2,
                            {
                                dependencies: newDeps2,
                            },
                            null,
                            (rr, m) => {
                                cb?.(r, m)
                            }
                        )
                    } else {
                        cb?.(r, mm)
                    }
                }
            )
        }).catch((err) => {
            toast.error(get(err, "message") || "Sorry, that dependency could not be removed. Please try again.", {
                autoClose: 6000,
            })
        })
    }
    async actionItemCreateX(action, data, cb) {
        if (!data.seen) {
            data.seen = {
                by: this.state.person._id,
                when: getTimeUtc(new Date()),
            }
        }

        let myMission = this.state.missions.find((m) => m._id === action.missionId)

        let codes = myMission?.fullyLoaded ? getAllActionItems(myMission).map((a) => a?.code) : null

        if (!myMission?.fullyLoaded) {
            const gm = await getMissions({
                id: action.missionId,
                select: ["defaultTaskCode", "_id"],
            })

            myMission = gm.value[0]
        }

        // One past the highest number in use: counting tasks repeated codes after deletes, and a
        // project not loaded here had no tasks to count, so every task got PRJ-1
        if (myMission?.defaultTaskCode && !data.code) {
            if (!codes) {
                const all = await paginateAll(
                    getActionItems({ project: action.missionId, withArchived: true, select: ["_id", "code"] })
                )
                codes = all.map((a) => a.code)
            }
            data.code = nextTaskCode(myMission.defaultTaskCode, codes)
        }

        if (!data.code) {
            data.code = Math.random().toString(36).substring(2, 6).toUpperCase()
        }

        return apiActionItem
            .createActionItem(action._id, data)
            .then((res) => {
                this.updateStateForActionItemCreate(res, () => {
                    if (cb) cb(res)
                })
            })
            .catch((err) => {
                this.silentFail("actionItemCreateXCatch: " + getErrorMsg(err) + " action: " + action?._id)
                throw err
            })
    }

    // A failed sub-task save used to be rethrown inside a promise nobody awaits: no message at all
    checklistFail(where, err) {
        this.silentFail(where + ": " + getErrorMsg(err))
        toast.error("Sorry, the sub-task could not be saved: " + getErrorMsg(err))
    }
    checklistItemCreateX({ ai, options, cb }) {
        // Never sort ai.checklist here: it is the task in state
        const saveObj = { ...options, sortIndex: nextChecklistSortIndex(ai.checklist) }

        apiActionItem
            .addChecklistItem(ai._id, saveObj)
            .then((res) => {
                //obj, change, dontUpdateView, cb, fromSocket
                this.updateStateForActionItemUpdate(
                    ai,
                    res,
                    false,
                    () => {
                        if (cb) cb(res)
                    },
                    true
                )
            })
            .catch((err) => this.checklistFail("checklistItemCreateX", err))
    }
    checklistUpdateState(ai, res, cb) {
        this.updateStateForActionItemUpdate(
            ai,
            { checklist: res.checklist },
            null,
            () => {
                if (cb) cb()
            },
            true
        )
    }
    checklistItemsUpdateBulk(ai, changeList) {
        apiActionItem
            .updateChecklistItemBulk(ai._id, changeList)
            .then((res) => {
                this.checklistUpdateState(ai, res)
            })
            .catch((err) => this.checklistFail("checklistItemsUpdateBulk", err))
    }
    checklistItemUpdateX(ai, cl, change, cb) {
        //Always an Optimist

        if (change.hasOwnProperty("person") && change.person) {
            this.actionItemAddPerson(ai, change.person)
        }

        if (change.hasOwnProperty("done")) {
            change.completedOn = change.done ? getTimeUtc(new Date()) : null
            change.completedBy = change.done ? this.state.person._id : null
        }

        apiActionItem
            .updateChecklistItem(ai._id, cl._id, change)
            .then((res) => {
                this.checklistUpdateState(ai, res, cb)
            })
            .catch((err) => this.checklistFail("checklistItemUpdateX", err))
    }
    checklistItemDeleteX(ai, cl, cb) {
        apiActionItem
            .deleteChecklistItem(ai._id, cl._id)
            .then((res) => {
                this.checklistUpdateState(ai, res, cb)
            })
            .catch((err) => this.checklistFail("checklistItemDeleteX", err))
    }

    // keepOpen and onError are for the mAX tool executors: the task being copied
    // stays open (its mAX thread is mid turn), and a failure is reported.
    async actionItemDuplicateX({ ai, options, cb, mission, isOther, keepOpen, onError }) {
        const fail = (err, where) => {
            this.unBlock()
            this.silentFail("actionItemDuplicateX " + where + ": " + getErrorMsg(err) + " ai: " + ai?._id)
            if (onError) onError(err)
            else toast.error("The task could not be copied: " + getErrorMsg(err))
        }

        let aiObj
        let action

        try {
            // Into another project: its catch-all, not whichever action (a board section) comes first
            const ga = await getActions({
                project: mission._id,
                limit: isOther ? 200 : 1,
                select: isOther ? ["_id", "title", "source", "isSection"] : "_id",
                id: isOther ? undefined : ai.actionId,
            })
            action = isOther
                ? ga.value.find(isCatchAllAction) || ga.value.find((a) => !a.isSection) || ga.value[0]
                : ga.value[0]

            if (!action) {
                toast.error(
                    "Please have an admin or porject manager visit the project workspace to finish setup before copying "
                )
                this.silentFail("seiwjowlked552525")
                if (onError) onError(new Error("The project has no section to copy the task into yet."))
                return
            }

            // Numbered among the codes of the project the copy lands in, archived included
            let code
            if (ai.code) {
                const codes = await paginateAll(
                    getActionItems({ project: mission._id, withArchived: true, select: ["_id", "code"] })
                )
                code = nextTaskCode(
                    getTaskCodePrefix(ai.code),
                    codes.map((a) => a.code)
                )
            }

            aiObj = { ...buildDuplicateTask({ ai, mission, isOther, code }), ...options }
        } catch (err) {
            return fail(err, "prepare")
        }

        const created = this.actionItemCreateX(action, aiObj, async (res) => {
            if (!keepOpen) removeParam("action-item")
            toast.success("Created")

            try {
                if (ai.files?.length) {
                    apiActionItem
                        .copyFiles(ai._id, res._id)
                        .catch((err) => this.silentFail("actionItemDuplicateX copyFiles: " + getErrorMsg(err)))
                }

                if (mission.fullyLoaded) {
                    this.block()
                    const copyPlanItems =
                        mission.planItems?.filter((p) => {
                            return p.linkedToTask === ai._id && p.type === "cost"
                        }) || []

                    for (const cpi of copyPlanItems) {
                        await delay(100)
                        await duplicateCostPlanItem({
                            pi: { ...cpi, linkedToTask: res._id },
                            mission,
                            app: this,
                        })
                        await delay(100)
                    }

                    await delay(200)

                    duplicateRaciRoles({ newAi: res, oldAi: ai, mission, app: this })
                }
            } catch (err) {
                // The copy exists; only its cost lines / roles are missing
                this.silentFail("actionItemDuplicateX extras: " + getErrorMsg(err) + " ai: " + ai?._id)
                toast.error("The task was copied but its cost lines or roles were not: " + getErrorMsg(err))
            } finally {
                this.unBlock()
            }

            if (cb) {
                cb(res)
            }
        })

        try {
            await created
        } catch (err) {
            fail(err, "create")
        }
    }
    actionItemUpdateX(ai, change, cb, fromSocket, fromTask, onError) {
        if (change.startDate && !change.initialStartDate) {
            if (!ai.initialStartDate || change.startDate < ai.initialStartDate) {
                change.initialStartDate = change.startDate
            }
        }

        if (change.status === "done") {
            this.closeActionItem()

            change.completedOn = getTimeUtc(new Date())
            change.completedBy = this.state.person._id
        } else if (change.status) {
            change.completedOn = null
            change.completedBy = null
        }

        const taskMoves = getTaskMoves([{ obj: ai, change }], { [ai._id]: ai })

        this.updateStateForActionItemUpdate(ai, change, false, () => {}, fromSocket)

        return apiActionItem
            .updateActionItem(ai._id, change)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === ai.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }

                // The task's dates changed: the budgets on it follow (role windows and hours,
                // then the cost lines tied to it)
                if (
                    myMission?.projectType === "mx-gantt" &&
                    (change.hasOwnProperty("startDate") || change.hasOwnProperty("endDate"))
                ) {
                    updateBudgetOnRaciTasks({ mission: myMission, app: this, taskMoves })
                    reconcileCostItems({ mission: myMission, app: this })
                }

                if (change.hasOwnProperty("col") && myMission?.cols) {
                    const myColIndex = myMission.cols?.findIndex((c) => c.id === res.col)
                    const myCol = myMission.cols?.[myColIndex]
                    if (myColIndex !== 0 && myColIndex !== -1 && myColIndex !== myMission.cols.length - 1) {
                        if (myCol.people?.length) {
                            myCol.people.forEach((newPerson, i) => {
                                const missionPerson = myMission.people.find(
                                    (ppp) => getRefId(ppp) === getRefId(newPerson)
                                )

                                if (
                                    missionPerson &&
                                    missionPerson.permission < 3 &&
                                    !ai.people.find((pp) => getRefId(pp) === getRefId(missionPerson))
                                ) {
                                    this.actionItemAddPerson(ai, getRefId(missionPerson))
                                }
                            })
                        }
                    }
                }

                if (cb) cb(res)
            })
            .catch((err) => {
                const message =
                    err instanceof Error
                        ? err.message
                        : typeof err === "string"
                        ? err
                        : (() => {
                              try {
                                  return JSON.stringify(err)
                              } catch {
                                  return "[unserializable error]"
                              }
                          })()

                this.silentFail(`updateActionItemXCatch: ${message} ai: ${ai?._id} ${JSON.stringify(change)}`)

                // Opt-in for callers that must see a failure (the mAX tool executors).
                // cb stays success-only: existing callers read the result unguarded.
                if (onError) onError(err)
            })
    }

    actionItemUpdate(id, change, obj, cb, skipOpenDoneLogic) {
        const me = this

        if (!obj) {
            console.error("Sorry you did not pass an Object to actionItemUpdate")
            return
        }

        //Catch initial back date for item so we know what timesheets it can appear on
        if (change.startDate && !change.initialStartDate) {
            if (!obj.initialStartDate || change.startDate < obj.initialStartDate) {
                change.initialStartDate = change.startDate
            }
        }

        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        //Check if being completed
        if (change.status === "done" && obj.status !== "done") {
            if (!change.completedOn) {
                change = {
                    ...change,

                    completedOn: getTimeUtc(new Date().getTime()),
                }
            }
        }
        if (change.status === "done") {
            change = { ...change, completedBy: this.state.person._id }
        } else if (change.status && change.status !== "done") {
            change = { ...change, completedBy: null }
        }

        if (change.status === "open" && obj.status === "done") {
            if (myMission && myMission.projectType === "power" && obj.startDate) {
                change = {
                    ...change,
                    completedBy: null,
                    completedOn: null,
                    startDate: null,
                    estimatedDuration: null,
                    y: null,
                    startHour: null,
                }
            } else {
                change = { ...change, completedBy: null, completedOn: null }
            }
        }

        if (!obj || !change) {
            console.log("Please pass an object.")
            this.silentFail("Please pass an object.")
        } else {
            me.updateStateForActionItemUpdate(obj, change) //just in case
        }

        delete change.people

        if (change.description) {
            change.descriptionUpdateById = this.state.person._id
            change.descriptionUpdate = getTimeUtc(new Date())
        }

        if ((this.state.showDetailsData || this.stateshowDocData) && this.state.showDetailsData._id === obj._id) {
            if (this.state.showDetailsData) {
                this.setState({
                    showDetailsData: update(this.state.showDetailsData, { $merge: change }),
                })
            }

            if (this.state.showDocData) {
                this.setState({
                    showDocData: update(this.state.showDocData, { $merge: change }),
                })
            }
        }

        return apiActionItem
            .updateActionItem(id, change)
            .then((res) => {
                //Should not populate people @mike

                res.people.forEach((p, i) => {
                    res.people[i] = p._id
                })

                if (cb) cb(res)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }


                if (myMission.isProcess && change.title) {
                    setTimeout(() => {
                        const m = this.state.missions.find((m) => m._id === obj.missionId)
                        syncProcessFlow({ mission: m, app: this })
                    }, 100)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionItemUpdateBulk(missionId, data, skipState, cb, cbAfterRes) {
        if (!skipState) {
            try {
                this.updateStateForActionItemUpdateBulk(missionId, data, cb)
            } catch (e) {
                this.silentFail("aiBulkOptimistic " + (e?.message || e))
            }
        }

        // Every bulk save refetches the mission's action items and writes them back over state.
        // Without ordering, a slow response from an earlier save lands after a newer one and
        // reverts it — bars snapping back to old positions. Stamp each save and let only the
        // newest one apply its refetch.
        const seqKey = getObjectId(missionId)

        if (!this.aiBulkSeq) this.aiBulkSeq = {}

        const seq = (this.aiBulkSeq[seqKey] || 0) + 1
        this.aiBulkSeq[seqKey] = seq

        const isStale = () => this.aiBulkSeq[seqKey] !== seq

        // Superseded by a newer save: skip the refetch write-back, but still run the caller's
        // chained work against the freshest mission we hold. Callers assign the argument straight
        // to missionRef, so never hand them undefined — if the mission is gone (navigated away
        // mid-save) there is nothing safe to reconcile against and we drop the callback.
        const finishStale = () => {
            const currentMission = this.state.missions.find((m) => m._id === seqKey)

            if (cbAfterRes && currentMission) {
                cbAfterRes(currentMission)
            }
        }

        const changeArray = data.map((obj) => {
            const ai = obj.obj
            let change = obj.change || obj.changes

            if (!change._id) {
                change._id = ai._id
            }

            return change
        })

        return apiActionItem
            .updateActionItemBulk(missionId, changeArray)
            .then(async (res) => {
                // A newer save is already in flight; its own refetch will be authoritative.
                if (isStale()) {
                    finishStale()
                    return
                }

                const newActionItems = await paginateAll(
                    getActionItems({
                        project: missionId,
                        limit: 100,
                        select: ["+dependencies"],
                    })
                )

                if (isStale()) {
                    finishStale()
                    return
                }

                const dataMap = newActionItems.map((ai) => {
                    return {
                        obj: ai,
                        changes: ai,
                    }
                })

                this.updateStateForActionItemUpdateBulk(missionId, dataMap, (newMission) => {
                    if (cbAfterRes) {
                        cbAfterRes(newMission)
                    }

                    if (newMission?.isTemplate) {
                        setTimeout(() => {
                            this.missionUpdate(newMission._id, {
                                isTemplateSaved: false,
                            })
                        }, 200)
                    }
                })

                return
            })
            .catch((err) => {
                this.silentFail("29837jnd" + (err?.message || err))
                throw err
            })
    }
    closeActionItem() {
        const n = new URLSearchParams(window.location.search)

        if (n.get("action-item")) {
            this.dropPendingActionItem()
            removeQueryParam("action-item")
            this.setState({
                showDetailsData: null,
                showDetailsDataOptions: null,
            })
        }
    }
    // A close makes any task fetch still in flight stale: it must not open the card again
    dropPendingActionItem() {
        this.actionItemOpenSeq = (this.actionItemOpenSeq || 0) + 1
        this.loadingActionItemId = null
    }
    async showActionItemDetails(ai, options) {
        const aiId = getObjectId(ai)

        // routing() fires on every history change, so don't fetch the same task twice while one is in flight
        if (this.loadingActionItemId === aiId) return
        this.loadingActionItemId = aiId

        const seq = (this.actionItemOpenSeq = (this.actionItemOpenSeq || 0) + 1)

        apiActionItem
            .getActionItem(aiId)
            .then((myAi) => {
                if (seq !== this.actionItemOpenSeq) return

                this.setState({
                    showDetailsData: myAi,
                    showDetailsDataOptions: options,
                    timeTracking: this.state.timeTracking,
                })

                // the url names the open task: add it, or swap a stale one left by an earlier card
                // Still flagged as loading here: setState is batched, so the routing() this push
                // runs synchronously sees no open task yet and would fetch it a second time - and
                // that second fetch landing after a quick close reopened the card.
                if (new URLSearchParams(window.location.search).get("action-item") !== myAi._id) {
                    addParam("action-item", myAi._id)
                }
            })
            .catch((err) => {
                if (seq !== this.actionItemOpenSeq) return

                toast.warning("🥑 Sorry this task is no longer available.")
                removeParam("action-item")
                return
            })
            .finally(() => {
                if (this.loadingActionItemId === aiId) this.loadingActionItemId = null
            })
    }

    async actionItemDeleteBulk(actionItems, cb, stateCb) {
        this.block("Deleting...")

        const actionItemResults = await Promise.allSettled(
            actionItems.map((ai, i) => {
                return apiActionItem.deleteActionItem(ai._id)
            })
        )

        let deletedAis = actionItemResults.length
            ? actionItemResults.filter((result) => result.status === "fulfilled")
            : []

        if (deletedAis.length > 0) {
            this.persistDanglingDependencies(this.updateStateForActionItemDeleteBulk(actionItems, stateCb))
        }

        this.unBlock()

        if (cb) cb()
    }
    /**
     * Deleting an action item leaves the *other* end of each of its dependencies pointing at
     * nothing. The state reducers strip those locally; this persists the same removal so the
     * links don't come back on the next load as "dependency target not found".
     *
     * Fire-and-forget: the delete itself has already succeeded, and a failure here degrades to
     * the pre-existing behaviour rather than blocking the user.
     */
    persistDanglingDependencies(danglingDeps) {
        if (!danglingDeps?.length) return

        const removals = []

        danglingDeps.forEach((d) => {
            d.removedDependencyIds?.forEach((depId) => {
                if (!depId) return
                removals.push(apiActionItem.removeDependency(d.obj._id, depId))
            })
        })

        if (!removals.length) return

        Promise.allSettled(removals).then((results) => {
            const failed = results.filter((r) => r.status === "rejected").length

            if (failed) {
                this.silentFail(`danglingDeps ${failed}/${removals.length} link removals failed`)
            }
        })
    }
    updateStateForNewOrgPerson(orgId, person) {
        const orgList = this.state.orgs.slice()

        if (!person) {
            return
        }

        const changedOrgIndex = (orgList || []).findIndex((org) => org._id === orgId)

        if (changedOrgIndex === -1) {
            return
        }

        try {
            this.commitState(
                {
                    orgs: update(orgList, {
                        [changedOrgIndex]: {
                            people: {
                                $push: [person],
                            },
                        },
                    }),
                },
                () => {
                    this.commitState({
                        orgChange: {
                            for: "people",
                            timestamp: uniqid(),
                        },
                    })
                }
            )
        } catch (e) {}
    }
    updateStateForActionDeleteBulk(actions, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === actions[0].missionId)

        const mission = this.state.missions[missionIndex]

        let newMissions = this.state.missions.slice()

        actions.forEach((ai, i) => {
            const indexes = getActionItemIndexes(ai, this.state)

            if (!indexes) {
                console.error("indexes issue")
                return
            }

            try {
                newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex]?.actions.splice(
                    indexes.missionActionIndex,
                    1
                )
            } catch (err) {
                console.error(err)
            }
        })

        if (cb) {
            cb(newMissions[missionIndex])
        }

        this.commitState(
            {
                missions: newMissions,
            },
            () => {
                this.commitState({
                    missionChange: {
                        for: "action",
                        change: "delete buld",
                        timestamp: uniqid(),
                        items: actions,
                        missionId: mission._id,
                    },
                })
            }
        )
    }
    updateStateForActionItemDeleteBulk(actionItems, cb) {
        const mission = this.state.missions.find((m) => m._id === actionItems[0].missionId)

        if (!mission) {
            console.error("indexes issue")
            return []
        }

        const deletedIds = actionItems.map((ai) => ai._id)

        // Same treatment as the single delete: remove by id (index-based splices against
        // pre-delete state removed the wrong items once more than one came out of the same
        // work package) and strip the dependencies now pointing at nothing.
        const bulkChanges = getDanglingDependencyChanges(this.state.missions, mission._id, deletedIds)

        let newMissions = removeActionItemsFrom(this.state.missions, mission._id, deletedIds)

        bulkChanges.forEach((change) => {
            newMissions = applyActionItemChange(newMissions, mission._id, change)
        })

        this.commitState(
            {
                missions: newMissions,
            },
            () => {
                if (cb) {
                    cb(newMissions.find((m) => m._id === mission._id))
                }
                this.commitState({
                    missionChange: {
                        for: "actionItems",
                        change: "delete",
                        timestamp: uniqid(),
                        items: [actionItems],
                        missionId: mission._id,
                        dependencyChange: bulkChanges.length > 0,
                    },
                })
            }
        )

        return bulkChanges
    }
    actionItemDeleteX(ai, mission, cb) {
        removeParam("action-item")
        const danglingDeps = this.updateStateForActionItemDelete(ai, cb)

        apiActionItem
            .deleteActionItem(ai._id)
            .then((res) => {
                this.persistDanglingDependencies(danglingDeps)

                if (this.state.showDetailsData?._id === ai._id) {
                    this.setState({
                        showDetailsData: null,
                        showDetailsDataOptions: null,
                    })
                }
                if (mission.isTemplate) {
                    this.missionUpdate(mission._id, {
                        isTemplateSaved: false,
                    })
                }
                toast.success("Done", { autoClose: 500 })

                if (mission.isProcess || mission.projectType === "mx-gantt") {
                    let pisNeedUpdating = mission.planItems.filter((p) =>
                        p.raciOnTasks?.find((r) => r.taskId === ai._id)
                    )
                    let changesArray = []
                    pisNeedUpdating.forEach((pi, i) => {
                        let newRaciOnTasks = pi.raciOnTasks?.slice().filter((r) => r.taskId !== ai._id)

                        changesArray.push({
                            obj: pi,
                            change: {
                                _id: pi._id,
                                raciOnTasks: newRaciOnTasks,
                            },
                        })
                    })

                    // once, after the loop: inside it every role went out again with each later one
                    if (changesArray.length) {
                        this.planItemUpdateBulk(mission._id, changesArray)
                    }
                }
            })
            .catch((err) => {
                // the task is already gone from the screen but still on the server
                this.silentFail("actionItemDeleteX: " + getErrorMsg(err) + " ai: " + ai?._id)
                toast.error("Sorry, the task could not be deleted. Please refresh the page and try again.")
            })
    }
    actionItemDelete(obj, skipState) {
        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        // Computed up front so the links are still visible in state when skipState suppresses
        // the local cleanup.
        const danglingDeps = skipState
            ? getDanglingDependencyChanges(this.state.missions, obj.missionId, [obj._id])
            : this.updateStateForActionItemDelete(obj)

        apiActionItem.deleteActionItem(obj._id).then((res) => {
            this.persistDanglingDependencies(danglingDeps)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    actionItemAddPerson(actionItem, personId, cb, onError) {
        const id = actionItem?._id

        if (actionItem.people?.find((p) => getRefId(p) === personId)) {
            return
        }

        const myOrg = this.state.orgs.find(
            (o) => o._id === getObjectId(actionItem.org) || o._id === getObjectId(actionItem.orgId)
        )

        return apiActionItem
            .addActionItemPeople({
                actionItemId: id,
                peopleId: personId,
                options: {
                    notify: !myOrg?.disableSetupNotifications,
                },
            })
            .then((res) => {
                const alt = {
                    people: res.people,
                    peopleAttached: res.peopleAttached,
                }

                if (this.state.showDetailsData && this.state.showDetailsData._id === res._id) {
                    this.setState({
                        showDetailsData: { ...this.state.showDetailsData, ...alt },
                    })
                }
                this.updateStateForActionItemUpdate(res, alt, false, cb)
            })
            .catch((err) => {
                this.silentFail("wejwie++we" + (err?.message + " - " + err?.toString()))

                // Opt-in for callers that must see a failure (the mAX tool executors).
                // cb stays success-only: existing callers toast "Done" from it.
                if (onError) onError(err)
            })
    }
    actionItemRemovePerson(actionItem, personId, cb) {
        const id = actionItem?._id || actionItem
        apiActionItem
            .deleteActionItemPeople(id, personId)
            .then((res) => {
                this.updateStateForActionItemUpdate(res, { people: res.people }, false, cb)
            })

            .catch((err) => {
                this.silentFail("actionItemRemovePerson-3u983" + (err?.message + " - " + err?.toString()))
            })
    }
    actionItemRemovePersonAll(id, cb) {
        return apiActionItem
            .deleteActionItemPeopleAll(id)
            .then((res) => {
                this.updateStateForActionItemUpdate(res, { people: res.people }, null, () => {
                    if (cb) {
                        cb()
                    }
                })
            })
            .catch((err) => {
                throw err
            })
    }
    planItemCreateX(missionId, obj, cb) {
        return apiPlanItems.createPlanItem(missionId, obj).then((res) => {
            this.updateStateForPlanItemCreate(res)

            if (cb) cb(res)

            const myMission = this.state.missions.find((m) => m._id === missionId)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    planItemCreate(missionId, obj, cb, skipDateMatch) {
        const miss = this.state.missions.find((m) => m._id === missionId)

        return apiPlanItems
            .createPlanItem(missionId, obj)
            .then((res) => {
                this.updateStateForPlanItemCreate(res)

                if (!skipDateMatch) {
                    this.missionPlanDates(missionId)
                    this.missionUpdatePinnedItems(missionId)
                }

                if (cb) {
                    cb(res)
                }

                if (miss?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(miss._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    async planItemCreateBulk(data) {
        /*this.block("One moment. Creating entries...")

        const planItemResults = await Promise.allSettled(
            data.map((planItemConfig) => {
                if (!start || !end) return null

                return apiPlanItems.createPlanItem(mission._id, planItemConfig)
            })
        )

        let planItemsCreated = []

        planItemResults
            .filter((result) => result.status === "fulfilled")
            .forEach((result, i) => {
                if (result.value) planItemsCreated.push(result.value)
            })

        if (planItemsCreated.length) this.updateStateForPlanItemCreateBulk(mission._id, planItemsCreated)*/
    }
    planItemAddDependency(planItem, dependencyItem, linkType = "dependsOn") {
        return apiPlanItems.addDependency(planItem._id, dependencyItem._id, linkType).catch((err) => {
            throw err
        })
        const myMission = this.state.missions.find((m) => m._id === planItem.missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }
    }
    planItemRemoveDependency(planItem, dependencyItem) {
        if (!planItem || !dependencyItem) return
        planItem = { ...planItem }

        const mission = this.state.missions.find((m) => m._id === planItem.missionId)
        if (typeof dependencyItem === "string") {
            dependencyItem = mission.planItems.find((p) => p._id === dependencyItem)
        }

        const removeDepIndex = planItem.dependencies.findIndex((l) => l.linkTo._id === dependencyItem._id)
        const dependencyToKill = planItem.dependencies[removeDepIndex]

        if (dependencyToKill) {
            planItem.dependencies.splice(removeDepIndex, 1)
            this.updateStateForPlanItemUpdate(planItem, {
                dependencies: planItem.dependencies,
            })
        }

        const removeDepIndexOther = dependencyItem.dependencies.findIndex((l) => l.linkTo._id === planItem._id)
        const dependencyToKillOther = dependencyItem.dependencies[removeDepIndexOther]

        if (dependencyToKillOther) {
            dependencyItem.dependencies.splice(removeDepIndexOther, 1)
            this.updateStateForPlanItemUpdate(dependencyItem, {
                dependencies: dependencyItem.dependencies,
            })
        }

        if (mission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(mission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        return apiPlanItems.removeDependency(planItem._id, dependencyToKill._id).catch((err) => {
            throw err
        })
    }
    planItemUpdateX(pi, change, cb) {
        if (!pi) {
            this.silentFail("djhjwklwkw" + JSON.stringify(change || { error: "error" }))
            return
        }

        // An edit that would leave the start after the end moves the other date instead
        const latest = this.planItemInState(pi)

        fitDateRange(latest, change)

        if (!dateValidationPass({ obj: latest, ...change })) return this.planItemDatesRefused(pi, change)

        const before = { ...latest }
        const scheduleChange = this.planItemPrepareDateEdit(pi, change)

        this.updateStateForPlanItemUpdate(pi, change)

        if (pi.type === "person" && pi.pinnedTo === null && !Object.prototype.hasOwnProperty.call(change, "pinnedTo")) {
            change.pinnedTo = null
        }

        return this.planItemSave(pi, change, before).then(
            (res) => {
                try {
                    if (cb) cb(res)

                    if (scheduleChange) this.scheduleRefit(pi.missionId, [pi._id])

                    const myMission = this.state.missions.find((m) => m._id === pi.missionId)

                    if (myMission?.isTemplate) {
                        setTimeout(() => {
                            this.missionUpdate(myMission._id, {
                                isTemplateSaved: false,
                            })
                        }, 200)
                    }
                } catch (e) {
                    this.silentFail("euwye4u3e-saved " + getErrorMsg(e) + " pi" + pi._id)
                }
            },
            (err) => {
                // Undo the optimistic update: what's on screen is what's saved
                this.updateStateForPlanItemUpdate(pi, pick(before, Object.keys(change)))

                if (err?.code === "mission_plan/person_has_time") {
                    toast.warning(err.message, { autoClose: 9000 })
                    return
                }

                try {
                    this.silentFail(
                        "euwye4u3e " +
                            (err?.code || "") +
                            " " +
                            getErrorMsg(err) +
                            " " +
                            JSON.stringify(change) +
                            " pi" +
                            pi._id +
                            " mission:" +
                            pi.missionId,
                    )
                } catch (e) {}

                if (err?.code === "invalid_dates") {
                    toast.warning("Those dates couldn't be saved: the end has to be after the start. Nothing was changed.")
                    return
                }

                toast.error("Oops. An issue occured but I have opened a ticket for the team to investigate ASAP!")
            },
        )
    }
    /**
     * A plan item as it is in state now - a caller's copy may be older
     * @param pi {object}
     * @return {object}
     */
    planItemInState(pi) {
        const mission = this.state.missions.find((m) => m._id === pi?.missionId)

        return mission?.planItems?.find((p) => p._id === pi?._id) || pi
    }
    /**
     * Dates that can't make a range even fitted (missing, not dates): nothing is sent and
     * nothing throws - callers that wait get a rejection they can catch.
     * @return {Promise<never>}
     */
    planItemDatesRefused(pi, change) {
        this.silentFail(
            "planItemDatesRefused " + JSON.stringify(pick(change, ["startDate", "endDate"])) + " pi" + pi?._id,
        )
        toast.warning("Those dates couldn't be saved: the end has to be after the start.")

        const err = new Error("Invalid date values")

        err.code = "invalid_dates"

        const refused = Promise.reject(err)

        refused.catch(() => {})

        return refused
    }
    /**
     * Saves a plan item change. When the API refuses its dates, what was on screen was older
     * than what's saved (two edits racing): the change is sent once more, with the date it
     * didn't carry as on screen - or, when that can't make a range, moved to keep the length.
     * Mutates `change` with what the retry added.
     * @param pi {object}
     * @param change {object}
     * @param before {object} The item as it was on screen before this change
     * @return {Promise<object>}
     */
    planItemSave(pi, change, before) {
        return apiPlanItems.updatePlanItem(pi.missionId, pi._id, change).catch((err) => {
            const retry = getDatesRetry(err?.code === "invalid_dates" ? err.data : null, change, before)

            if (!retry) throw err

            Object.assign(change, retry)
            this.updateStateForPlanItemUpdate(pi, retry)

            return apiPlanItems.updatePlanItem(pi.missionId, pi._id, change)
        })
    }
    /**
     * Creates one or more schedule blocks (own-collection version) for a plan item.
     * @param pi {object} The plan item
     * @param scheduleData {object|object[]}
     * @param cb {function}
     */
    scheduleCreate(pi, scheduleData, cb) {
        return apiPlanItems
            .createScheduleV2(pi._id, scheduleData)
            .then((res) => {
                if (cb) cb(res)
            })
            .catch((err) => {
                toast.error("Oops. An issue occured but I have opened a ticket for the team to investigate ASAP!")
            })
    }
    /**
     * Updates one or more schedule blocks (own-collection version) belonging to a plan item.
     * @param pi {object} The plan item
     * @param scheduleData {object|object[]} Each item must include the _id
     * @param cb {function}
     */
    scheduleUpdate(pi, scheduleData, cb) {
        return apiPlanItems
            .updateScheduleV2(pi._id, scheduleData)
            .then((res) => {
                if (cb) cb(res)
            })
            .catch((err) => {
                toast.error("Oops. An issue occured but I have opened a ticket for the team to investigate ASAP!")
            })
    }
    /**
     * Deletes one or more schedule blocks (own-collection version) belonging to a plan item.
     * @param pi {object} The plan item
     * @param scheduleIdList {string|string[]}
     * @param cb {function}
     */
    scheduleDelete(pi, scheduleIdList, cb) {
        return apiPlanItems
            .deleteScheduleV2(pi._id, scheduleIdList)
            .then((res) => {
                if (cb) cb(res)
            })
            .catch((err) => {
                toast.error("Oops. An issue occured but I have opened a ticket for the team to investigate ASAP!")
            })
    }
    /**
     * Bulk create/update/delete schedule blocks across many plan items within one mission.
     * @param missionId {string}
     * @param payload {object} {create, update, delete}
     * @param cb {function}
     */
    scheduleBulkUpdate(missionId, payload, cb) {
        return apiPlanItems
            .updateScheduleBulkV2(missionId, payload)
            .then((res) => {
                if (cb) cb(res)
                return res
            })
            .catch((err) => {
                toast.error("Oops. An issue occured but I have opened a ticket for the team to investigate ASAP!")
            })
    }
    planItemRemoveRole(pi) {
        const startDateAfterToday = isAfter(toZonedTime(pi.startDate), new Date())
        const todayAfterEndDate = isAfter(new Date(), toZonedTime(pi.endDate))

        const whatIsTheEndDate = startDateAfterToday
            ? endOfDay(toZonedTime(pi.startDate))
            : todayAfterEndDate
            ? toZonedTime(pi.endDate)
            : endOfDay(new Date())

        const change = {
            person: null,
            endDate: getTimeUtc(whatIsTheEndDate),
            pinnedTo: null,
            personLeftRole: {
                when: getTimeUtc(new Date()),
                personId: pi.person,
                whoKilledTheRole: this.state.person._id,
            },
        }

        this.updateStateForPlanItemUpdate(pi, change)

        return apiPlanItems.updatePlanItem(pi.missionId, pi._id, change).then((res) => {
            toast("The project role was removed.")

            // The role ends today: what was scheduled on it after that goes
            this.scheduleRefit(pi.missionId, [pi._id])

            const myMission = this.state.missions.find((m) => m._id === res.missionId)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    planItemUpdate(obj, changeObj, skipMin, skipDateMatch) {
        if (!obj || !changeObj) return

        obj = { ...obj }
        changeObj = { ...changeObj }

        if (obj.type === "milestone") {
            skipMin = true
            skipDateMatch = true
        }

        if (typeof obj.startDate === "object") obj.startDate = getTimeUtc(obj.startDate)

        if (typeof obj.endDate === "object") obj.endDate = getTimeUtc(obj.endDate)

        if (typeof changeObj.startDate === "object") changeObj.startDate = getTimeUtc(changeObj.startDate)

        if (typeof changeObj.endDate === "object") changeObj.endDate = getTimeUtc(changeObj.endDate)

        // An edit that would leave the start after the end moves the other date instead
        const latest = this.planItemInState(obj)

        fitDateRange(latest, changeObj)

        if (!dateValidationPass({ obj: latest, ...changeObj })) return this.planItemDatesRefused(obj, changeObj)

        const before = { ...latest }
        const scheduleChange = this.planItemPrepareDateEdit(obj, changeObj)

        this.updateStateForPlanItemUpdate(obj, changeObj)

        if (!skipDateMatch && (changeObj.startDate || changeObj.endDate)) {
            setTimeout(() => {
                this.missionPlanDates(obj.missionId)
            }, 10)
            setTimeout(() => {
                this.missionUpdatePinnedItems(obj.missionId)
            }, 20)
        }

        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        const request = this.planItemSave(obj, changeObj, before).catch((err) => {
            // Undo the optimistic update: what's on screen is what's saved
            this.updateStateForPlanItemUpdate(obj, pick(before, Object.keys(changeObj)))

            throw err
        })

        if (scheduleChange) {
            request.then(() => this.scheduleRefit(obj.missionId, [obj._id])).catch(() => {})
        }

        return request
    }
    /**
     * A plan item's dates edited by hand: a pinned end moved off the project's date is
     * unpinned (or the next project change would snap it back) and a remembered length is
     * dropped. A line that moves takes its typed months along. Mutates `change`.
     * @param pi {object} The plan item before the edit
     * @param change {object}
     * @return {boolean} Whether a role's dates moved, so its schedule has to follow
     */
    planItemPrepareDateEdit(pi, change) {
        if (!pi || !change || (change.startDate === undefined && change.endDate === undefined)) {
            return false
        }

        const mission = this.state.missions.find((m) => m._id === pi.missionId)
        const pinnedTo = getHandEditPinnedTo(pi, change, mission)

        // From the line as it is now (a caller's copy may be older), on its pins before this edit
        const monthly = getMovedMonthly(mission?.planItems?.find((p) => p._id === pi._id) || pi, change)

        if (monthly) change.monthly = monthly

        if (pinnedTo !== undefined) change.pinnedTo = pinnedTo

        if (pi.requestedDays && !Object.prototype.hasOwnProperty.call(change, "requestedDays")) {
            change.requestedDays = null
        }

        return Boolean(mission) && !mission.isTemplate && hasScheduleChange(pi, change)
    }
    /**
     * A schedule refit call (api planItemSchedule.shift.js). One at a time per project and
     * in the order they were asked for, so each sees what the one before it left.
     * @param missionId {string}
     * @param payload {object} {mode: "preview"|"apply"|"discard", planItemIds}
     * @return {Promise<object>}
     */
    scheduleRefitRequest(missionId, payload) {
        this.scheduleRefitQueue = this.scheduleRefitQueue || {}

        const run = () =>
            apiPlanItems.refitScheduleV2(missionId, {
                ...payload,
                today: getTimeUtc(startOfDay(new Date())),
            })
        const request = (this.scheduleRefitQueue[missionId] || Promise.resolve()).then(run, run)

        this.scheduleRefitQueue[missionId] = request.catch(() => {})

        return request
    }
    /**
     * Roles whose dates were changed one by one: their future schedule follows straight
     * away - a move takes the hours along, days and monthly plans the role lost are removed,
     * and a schedule that ran up to an end that moved out carries on. The past never changes.
     * @param missionId {string}
     * @param [planItemIds] {string[]} Only these roles - every role waiting otherwise
     */
    scheduleRefit(missionId, planItemIds) {
        if (!missionId) return

        return this.scheduleRefitRequest(missionId, { mode: "apply", planItemIds })
            .then((res) => this.scheduleRefitDone(missionId, res))
            .catch((err) => this.scheduleRefitFailed(err))
    }
    /**
     * Roles and equipment lines moved by a project date change (or several at once): asks
     * before their schedules and machine bookings follow. A project is often moved in more
     * than one edit, and those should go from where they were to where the dates end up -
     * not through every step. Nothing is lost by waiting: each plan item remembers the dates
     * they reflect.
     * @param missionId {string}
     */
    scheduleRefitAsk(missionId) {
        if (!missionId) return

        const days = (n) => `${n} ${n === 1 ? "day" : "days"}`

        return this.scheduleRefitRequest(missionId, { mode: "preview" })
            .then((res) => {
                const changed = res
                    ? [
                          res.moved && `${days(res.moved)} to move`,
                          res.removed && `${days(res.removed)} to remove`,
                          res.added && `${days(res.added)} to add`,
                          res.months && `${res.months} monthly ${res.months === 1 ? "plan" : "plans"} to update`,
                          res.bookings &&
                              `${res.bookings} machine ${res.bookings === 1 ? "booking" : "bookings"} to update`,
                      ].filter(Boolean)
                    : []

                if (!changed.length) {
                    if (this.scheduleRefitAsked === missionId) {
                        this.scheduleRefitAsked = null
                        this.setState({ confirm: null })
                    }

                    // Plan items waiting with nothing to change: nothing to ask about
                    return res?.pending ? this.scheduleRefit(missionId) : undefined
                }

                const act = (mode) => {
                    this.scheduleRefitAsked = null

                    this.scheduleRefitRequest(missionId, { mode })
                        .then((done) => (mode === "apply" ? this.scheduleRefitDone(missionId, done) : null))
                        .catch((err) => this.scheduleRefitFailed(err))
                }

                const hasPeople = res.moved || res.removed || res.added || res.months
                const what = hasPeople && res.bookings ? "schedules and machine bookings" : hasPeople ? "schedules" : "machine bookings"
                const taken = res.equipment?.unbooked?.length || 0

                // Asked again while open (a second date edit), this replaces the open box
                this.scheduleRefitAsked = missionId
                this.confirm({
                    severe: true,
                    singleClick: true,
                    noCancel: true,
                    comp: (
                        <div>
                            <p>
                                Dates changed on this project. Update the {what} that depend on them? (
                                {changed.join(", ")})
                            </p>
                            {taken > 0 && (
                                <p>
                                    {taken} {taken === 1 ? "machine is" : "machines are"} already booked elsewhere on
                                    the new dates and will be unbooked from this project.
                                </p>
                            )}
                        </div>
                    ),
                    yesText: `Update ${what}`,
                    noText: "Leave as they are",
                    onYes: () => act("apply"),
                    onNo: () => act("discard"),
                })
            })
            .catch((err) => this.scheduleRefitFailed(err))
    }
    /**
     * Tells the user what a schedule refit changed and which conflicts it made.
     * @param missionId {string}
     * @param res {object} The refit result
     */
    scheduleRefitDone(missionId, res) {
        if (!res) return

        const days = (n) => `${n} ${n === 1 ? "day" : "days"}`
        const c = res.conflicts || {}

        const changed = [
            res.moved && `${days(res.moved)} moved`,
            res.removed && `${days(res.removed)} removed`,
            res.added && `${days(res.added)} added`,
            res.months && `${res.months} monthly ${res.months === 1 ? "plan" : "plans"} updated`,
        ].filter(Boolean)

        const conflicts = [
            c.doubleBooked && `${days(c.doubleBooked)} double-booked`,
            c.onLeave && `${days(c.onLeave)} on leave`,
            c.holiday && `${days(c.holiday)} on a public holiday`,
        ].filter(Boolean)

        const summary = changed.length ? `Schedule updated to the new dates: ${changed.join(", ")}.` : ""

        // Open Scheduling and equipment panels reloaded when the dates changed, before what
        // hangs off them did
        if (changed.length || res.bookings) {
            this.setState({ scheduleChange: { missionId, timestamp: uniqid() } })
        }

        // Machines are one of a kind: say exactly what happened to each booking that didn't
        // simply follow, so it can be rebooked
        if (res.equipment) {
            this.confirm({
                severe: true,
                singleClick: true,
                noCancel: true,
                width: 520,
                comp: <EquipmentRefitNotice equipment={res.equipment} />,
                yesText: res.equipment.unbooked?.length ? "OK, I'll rebook" : "OK",
                onYes: () => {},
            })
        }

        if (conflicts.length) {
            toast.warning(`${summary} This creates conflicts (${conflicts.join(", ")}). Please review the Schedule tab.`, {
                autoClose: 12000,
            })
        } else if (summary) {
            toast(summary)
        }

        // Some of what an open question was about may be done now
        if (this.scheduleRefitAsked === missionId) {
            this.scheduleRefitAsk(missionId)
        }
    }
    scheduleRefitFailed(err) {
        // People who can't edit the schedule can still edit role dates
        if (err?.status === 403 || err?.statusCode === 403) return

        this.silentFail("scheduleRefit " + getErrorMsg(err))
    }
    planItemUpdateBulk(missionId, changes, noStateChange, cb) {
        let sendOff = []

        if (!noStateChange) {
            const inState = this.state.missions.find((m) => m._id === missionId)?.planItems || []

            // New dates from anywhere but the pinned pass drop a squeezed item's remembered length
            changes.forEach((cc) => {
                const change = cc.change || cc.changes
                const now = cc.obj && inState.find((p) => p._id === cc.obj._id)

                // One item whose start would land after its end fails the whole batch
                fitDateRange(now || cc.obj, change)

                if (
                    change &&
                    cc.obj?.requestedDays &&
                    (change.startDate !== undefined || change.endDate !== undefined) &&
                    !Object.prototype.hasOwnProperty.call(change, "requestedDays")
                ) {
                    change.requestedDays = null
                }

                // A line that moves (with the project, its pins, its task or a shift) takes its
                // typed months along - from the line as it is now, a caller's copy may be older
                const monthly = change && getMovedMonthly(now || cc.obj, change)

                if (monthly) change.monthly = monthly
            })

            this.updateStateForPlanItemUpdateBulk(changes, cb)

            changes.forEach((cc) => {
                sendOff.push({
                    ...(cc.change || cc.changes),
                    _id: getObjectId(cc.obj),
                    // The Scheduling grid moving a role's dates to fit what it just scheduled
                    ...(cc.keepSchedule ? { keepSchedule: true } : {}),
                })
            })

            if (sendOff.length) {
                const request = apiPlanItems.updatePlanItemBulk(missionId, sendOff).catch((err) => {
                    // Refused dates: on screen was older than what's saved - fill them in, once
                    const refused = err?.code === "invalid_dates" && Array.isArray(err.data) ? err.data : []
                    const fixes = refused.map((saved) => {
                        const body = sendOff.find((s) => String(s._id) === String(saved._id))
                        const cc = changes.find((c) => String(getObjectId(c.obj)) === String(saved._id))
                        const shown = inState.find((p) => String(p._id) === String(saved._id)) || cc?.obj
                        const retry = body && getDatesRetry(saved, body, shown)

                        return retry && cc ? { body, cc, retry } : null
                    })

                    if (!fixes.length || fixes.some((f) => !f)) throw err

                    fixes.forEach(({ body, retry }) => Object.assign(body, retry))
                    this.updateStateForPlanItemUpdateBulk(fixes.map(({ cc, retry }) => ({ obj: cc.obj, change: retry })))

                    return apiPlanItems.updatePlanItemBulk(missionId, sendOff)
                })

                // Roles whose dates moved: their schedules may have to follow
                if (
                    typeof missionId === "string" &&
                    changes.some((cc) => !cc.keepSchedule && hasScheduleChange(cc.obj, cc.change || cc.changes)) &&
                    !this.state.missions.find((m) => m._id === missionId)?.isTemplate
                ) {
                    request.then(() => this.scheduleRefitAsk(missionId)).catch(() => {})
                }

                return request
            }
        } else {
            if (changes.length) return apiPlanItems.updatePlanItemBulk(missionId, changes)
        }

        const myMission = this.state.missions.find((m) => m._id === missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }
    }
    planItemRemoveX(pi) {
        this.updateStateForPlanItemRemove(pi)
        const myMission = this.state.missions.find((m) => m._id === pi.missionId)
        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        return apiPlanItems.deletePlanItem(pi._id).catch((err) => {
            this.silentFail(formatError(err))
        })
    }
    planItemRemove(mission, obj, skipDates) {
        if (!mission || typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === obj.missionId)
        }
        if (!mission) return

        const removeLogic = () => {
            this.updateStateForPlanItemRemove(obj)

            if (!skipDates && obj.type !== "cost") {
                setTimeout(() => {
                    this.planItemCleanUpPinnedTo(mission, obj)
                }, 300)

                setTimeout(() => {
                    this.planItemCleanUpDependencies(obj, mission)
                }, 100)

                setTimeout(() => {
                    this.missionPlanDates(mission._id)
                }, 150)
            }

            const myMission = this.state.missions.find((m) => m._id === mission._id)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }

            return apiPlanItems.deletePlanItem(obj._id).catch((err) => {
                this.silentFail(formatError(err))
            })
        }

        return removeLogic()
    }
    planItemCleanUpPinnedTo(mission, planItem) {
        let changeArray = []

        mission.planItems
            .filter((pi) => pi.pinnedTo === planItem._id)
            .forEach((pi, i) => {
                changeArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        pinnedTo: null,
                    },
                })
            })

        if (changeArray.length) {
            this.planItemUpdateBulk(mission._id, changeArray)
        }
    }
    planItemCleanUpDependencies(planItem, mission) {
        let changesArray = []
        let newPhases = mission.planItems.slice()

        newPhases = newPhases.filter((p) => {
            return (
                p.myDependencies &&
                p.dependencyOnMe &&
                (p.myDependencies.indexOf(planItem._id) !== -1 || p.dependencyOnMe.indexOf(planItem._id) !== -1)
            )
        })

        newPhases.forEach((pi, i) => {
            const index1 = pi.myDependencies.findIndex((d) => d === planItem._id)

            if (index1 !== -1) {
                pi.myDependencies.splice(index1, 1)
                changesArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        myDependencies: pi.myDependencies,
                    },
                })
            }
            const index2 = pi.dependencyOnMe.findIndex((d) => d === planItem._id)
            if (index2 !== -1) {
                pi.dependencyOnMe.splice(index2, 1)
                changesArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        dependencyOnMe: pi.dependencyOnMe,
                    },
                })
            }
        })

        if (changesArray.length) {
            this.planItemUpdateBulk(planItem.missionId, changesArray)
        }
    }

    orgCreate(data, logo, secondaryLogo, cb) {
        apiOrg
            .createOrg(data)
            .then((newOrg) => {
                if (logo) {
                    apiOrg.uploadLogo(newOrg._id, logo)
                }

                if (secondaryLogo) {
                    apiOrg.uploadSecondaryLogo(newOrg._id, secondaryLogo)
                }

                this.commitState(
                    {
                        orgs: update(this.state.orgs, {
                            $push: [{ ...newOrg, archivedPeople: newOrg.archivedPeople || [] }],
                        }),
                    },
                    () => {
                        if (cb) cb(newOrg)

                        if (getQ()["create-proposal"]) {
                            return
                        }

                        removeParam("hq")

                        if (!getQ().mc) {
                            addParams([
                                { param: "org", value: newOrg._id },
                                { param: "org-cfg", value: "1" },
                            ])
                        } else {
                            addParam("mc-org", newOrg._id)
                        }
                    }
                )

                toast.success("Success 👍")
            })
            .catch((err) => {
                throw err
            })
    }
    orgDelete(id) {
        removeParams("org,hq,mc-org")

        this.orgCleanUpDeleted(id)

        apiOrg
            .deleteOrg(id)
            .then((res) => {
                toast.success("Org deleted as requested. help@missionx.ai")
            })
            .catch((err) => {
                throw err
                //toast.error("I'm sorry but I was not able to delete this organization. help@missionx.ai")
            })
    }
    orgUpdate(id, change, cb) {
        if (id?._id) {
            id = getObjectId(id)
        }

        const beforeOrg = this.state.orgs.find((o) => o._id === id)

        return apiOrg
            .updateOrg(id, change)
            .then((res) => {
                let newUpdateObj = { ...res }

                if (!res.people && beforeOrg.people) {
                    newUpdateObj = { ...newUpdateObj, people: beforeOrg.people }
                }

                newUpdateObj = { ...newUpdateObj, ...change }

                this.orgUpdateState(newUpdateObj, change)

                if (cb) {
                    cb(res)
                }
            })
            .catch((err) => {
                switch (err.status) {
                    case 400:
                        return toast.error("A bad request received. Try again and if the problem persists contact us.")
                    case 401:
                        return toast.error("Make sure you have the right permissions to perform this action.")
                    case 402:
                        return toast.error("Requires an organization license.")
                    default:
                        throw err
                }
            })
    }
    orgUpdateState(obj, change, cb) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === obj._id)
        const orgA = this.state.orgs[orgIndex]

        if (!obj.people) {
            obj.people = orgA.people
        }

        if (orgIndex !== -1) {
            // Updater form: merges onto the latest orgs, so back-to-back updates outside an
            // event don't drop each other
            this.setState(
                (prevState) => {
                    const i = prevState.orgs.findIndex((o) => o._id === obj._id)

                    if (i === -1) return null

                    return {
                        orgs: update(prevState.orgs, {
                            [i]: { $merge: change },
                        }),
                    }
                },
                () => {
                    const latest = this.state.orgs.find((o) => o._id === obj._id)

                    this.setState(
                        {
                            orgChange: {
                                _id: obj._id,
                                timestamp: uniqid(),
                                obj: latest,
                            },
                        },
                        () => {
                            if (cb) {
                                cb(this.state.orgs.find((o) => o._id === obj._id))
                            }
                        }
                    )
                }
            )
        }
    }
    orgClientUpdate(org, client, change, cb) {
        apiOrg
            .updateOrgClient(org._id, client._id, change)
            .then((res) => {
                this.updateStateForClientUpdate(res, cb)
            })
            .catch((err) => {
                throw err
            })
    }
    orgClientCreate(org, data, cb) {
        apiOrg
            .createOrgClient(org._id, data)
            .then((res) => {
                this.updateStateForClientCreate(res, cb)
            })
            .catch((err) => {
                throw err
            })
    }
    orgVendorCreate(org, data, cb) {
        return apiOrg
            .createOrgVendor(org._id, data)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgVendorUpdate(org, vendor, change, cb) {
        return apiOrg
            .updateOrgVendor(org._id, vendor._id, change)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgVendorBulkImport(org, rows, cb) {
        return apiOrg
            .bulkImportOrgVendors(org._id, rows)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgVendorSendOnboardingEmail(org, vendor, cb) {
        return apiOrg
            .sendOrgVendorOnboardingEmail(org._id, vendor._id)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgPoNumberCreate(org, data, cb) {
        return apiOrg
            .createOrgPoNumber(org._id, data)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgPoNumberUpdate(org, poNumber, change, cb) {
        return apiOrg
            .updateOrgPoNumber(org._id, poNumber._id, change)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgPoNumberBulkImport(org, rows, cb) {
        return apiOrg
            .bulkImportOrgPoNumbers(org._id, rows)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgGlCodeCreate(org, data, cb) {
        return apiOrg
            .createOrgGlCode(org._id, data)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgGlCodeUpdate(org, glCode, change, cb) {
        return apiOrg
            .updateOrgGlCode(org._id, glCode._id, change)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgGlCodeBulkImport(org, rows, cb) {
        return apiOrg
            .bulkImportOrgGlCodes(org._id, rows)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgCostCenterCreate(org, data, cb) {
        return apiOrg
            .createOrgCostCenter(org._id, data)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgCostCenterUpdate(org, costCenter, change, cb) {
        return apiOrg
            .updateOrgCostCenter(org._id, costCenter._id, change)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgTaxCodeCreate(org, data, cb) {
        return apiOrg
            .createOrgTaxCode(org._id, data)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgTaxCodeUpdate(org, taxCode, change, cb) {
        return apiOrg
            .updateOrgTaxCode(org._id, taxCode._id, change)
            .then((res) => {
                cb?.(res)
            })
            .catch((err) => {
                throw err
            })
    }
    orgClientRemove(org, client, cb) {
        apiOrg.deleteOrgClient(org._id, client._id).then(() => {
            this.updateStateForClientDelete(org._id, client._id, cb)
        })
        // TODO: Handle this
    }

    orgCleanUpDeleted(id) {
        const me = this

        const orgIndex = this.state.orgs.findIndex((o) => o._id === id)

        if (orgIndex !== -1) {
            const orgDeleted = [this.state.orgs[orgIndex]]

            setTimeout(() => {
                // Filtered from the state at apply time, not a copy taken 500ms earlier
                // that would undo anything that landed in between
                me.setState(
                    (prevState) => ({
                        missions: prevState.missions.filter((m) => getObjectId(m.org) !== id),
                        orgs: prevState.orgs.filter((o) => o._id !== id),
                    }),
                    () => {
                        toast.warning((orgDeleted?.[0]?.title || "An organization") + " was removed.", {
                            position: "bottom-right",
                        })

                        const q = getQ()

                        if (q["org"] === orgDeleted?.[0]?._id) {
                            removeParam("org")
                        }
                    }
                )
            }, 500)
        }
    }
    updateStateForGoalChange(org, goal) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === org._id)

        const fgIndex = org.goals.findIndex((g) => g._id === goal._id)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: {
                    [fgIndex]: { $set: goal },
                },
            },
        })

        const orgGoalState = upOrg

        this.commitState({
            orgs: orgGoalState,
        })
    }
    updateStateForGoalDelete(orgId, goalId) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === orgId)

        const fgIndex = this.state.orgs[orgIndex].goals.findIndex((g) => g._id === goalId)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: { $splice: [[fgIndex, 1]] },
            },
        })

        const orgGoalState = upOrg

        this.commitState({
            orgs: orgGoalState,
        })
    }
    updateStateForGoalCreate(org, goal) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === org._id)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: { $push: [goal] },
            },
        })

        const orgGoalState = upOrg

        this.commitState({
            orgs: orgGoalState,
        })
    }
    updateStateForPersonRemoved(personId, missionId) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)
        const mission = this.state.missions[missionIndex]

        if (!mission) {
            return
        }

        let actions = getAllActions(mission).slice()

        ;(actions || []).forEach((a) => {
            a.actionItems.forEach((ai, i) => {
                if (!ai.people) return

                let pIndex = ai.people.findIndex((obj) => obj._id === personId)
                a.actionItems[i].people.splice(pIndex, 1)
            })
        })

        if (missionIndex === -1) return

        const missionPeopleIndex = this.state.missions[missionIndex].people.findIndex((mp) => {
            if (mp.ref) {
                return getRefId(mp) === personId
            } else {
                return false
            }
        })

        if (missionPeopleIndex === -1) return

        this.commitState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: {
                        people: { $splice: [[missionPeopleIndex, 1]] },
                    },
                }),
            },
            () => {
                this.commitState({
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]?._id,
                    },
                })
            }
        )
    }
    updateStateForPersonRemovedOrg(refId, orgId) {
        const orgIndex = this.state.orgs.findIndex((m) => m._id === orgId)
        const personIndex = this.state.orgs[orgIndex]?.people?.findIndex((mp) => getRefId(mp) === refId)

        let newOrgs = this.state.orgs.slice()

        if (personIndex !== -1) {
            const x = this.state.orgs[orgIndex]?.people[personIndex]

            newOrgs = update(this.state.orgs, {
                [orgIndex]: {
                    people: { $splice: [[personIndex, 1]] },
                    archivedPeople: { $push: [{ ...x, _archived: true, isArchived: true }] },
                },
            })
        }

        this.commitState(
            {
                orgs: newOrgs,
            },
            () => {
                this.state.missions
                    .filter((m) => getObjectId(m.org) === orgId)
                    .forEach((m) => {
                        const missionPerson = (m.people || []).find((mPerson) => getRefId(mPerson) === refId)

                        if (missionPerson) {
                            this.updateStateForPersonRemoved(missionPerson._id, m._id)
                        }
                    })
            }
        )
    }
    updateStateForPersonAvatar(obj, isAvatarChange) {
        let newMissions = this.state.missions.slice()
        let newOrgs = this.state.orgs.slice()

        newMissions.forEach((m, ind) => {
            let i = m.people?.findIndex((p) => getRefId(p) === obj._id)
            if (i !== -1 && typeof newMissions[ind].people[i].ref === "object") {
                newMissions[ind].people[i].ref.avatar = obj.avatar
            }
        })

        newOrgs.forEach((o, ind) => {
            if (o.people) {
                let i = o.people?.findIndex((p) => getRefId(p) === obj._id)
                if (i !== -1 && typeof newOrgs[ind].people[i].ref === "object") {
                    newOrgs[ind].people[i].ref.avatar = obj.avatar
                }
            }
        })

        this.commitState(
            {
                missions: newMissions,
                orgs: newOrgs,
                avKey: isAvatarChange ? uniqid() : this.state.avKey,
            },
            () => {
                if (isAvatarChange) this.forceUpdate()
            }
        )
    }
    updateStateForActionItemCreateBulk(actionItems, mission, fastCallBack) {
        let missions = this.state.missions.slice()
        const mIndex = missions.findIndex((m) => m._id === mission._id)

        actionItems.forEach((obj, i) => {
            let indexes = getActionItemIndexes(obj, this.state)

            missions = update(missions, {
                [indexes.missionIndex]: {
                    planItems: {
                        [indexes.missionPhaseIndex]: {
                            actions: {
                                [indexes.missionActionIndex]: {
                                    actionItems: { $push: [obj] },
                                },
                            },
                        },
                    },
                },
            })
        })

        if (fastCallBack) {
            fastCallBack(missions[mIndex])
        }

        this.commitState(
            {
                missions: missions,
            },
            () => {
                this.commitState({
                    missionChange: {
                        for: "actionItem",
                        change: "create-bulk",
                        changes: actionItems,
                        timestamp: uniqid(),
                        missionId: mission?._id,
                    },
                })
            }
        )
    }
    updateStateForActionUpdateBulk(missionId, changes, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)

        if (missionIndex === -1) {
            this.silentFail("ewrmjoi4enridss")
            return
        }

        const mission = this.state.missions[missionIndex]

        // Map changes by action id for fast lookup
        const changeMap = changes.reduce((acc, c) => {
            acc[c._id] = c
            return acc
        }, {})

        const newPlanItems = mission.planItems.map((planItem) => ({
            ...planItem,
            actions: planItem.actions.map((action) => {
                const change = changeMap[action._id]

                if (!change) return action

                const merged = {
                    ...action,
                    ...change,
                }

                return merged
            }),
        }))

        const newMissions = [...this.state.missions]

        newMissions[missionIndex] = {
            ...mission,
            planItems: newPlanItems,
        }

        this.commitState({ missions: newMissions }, () => {
            const updatedMission = newMissions[missionIndex] //this.state.missions[missionIndex]

            this.commitState(
                {
                    missions: newMissions,
                    missionChange: {
                        for: "action",
                        change: "bulk",
                        timestamp: uniqid(),
                        changes,
                        missionId,
                    },
                },
                () => {
                    if (cb) cb(updatedMission)
                }
            )
        })
    }

    updateStateForActionCreateBulk(actions) {
        //Supports simple and kanban and gantt only
        const action = actions[0]

        const myMissionIndex = this.state.missions.findIndex((m) => m._id === action.missionId)

        if (myMissionIndex === -1) return null

        const myPhaseInMissionIndex = this.state.missions[myMissionIndex].planItems.findIndex(
            (p) => p._id === action.missionPlanId
        )
        if (myPhaseInMissionIndex === -1) return null

        let newMissions = this.state.missions.slice()

        const newActionsForMission = uniqBy(
            [...newMissions[myMissionIndex].planItems[myPhaseInMissionIndex].actions, ...actions],
            "_id"
        )

        newMissions[myMissionIndex].planItems[myPhaseInMissionIndex].actions = newActionsForMission

        this.commitState(
            {
                missions: newMissions,
            },
            () => {
                this.commitState({
                    missionChange: {
                        for: "action",
                        change: "create-bulk",
                        changes: actions,
                        timestamp: uniqid(),
                        missionId: this.state.missions[myMissionIndex]._id,
                    },
                })
            }
        )
    }
    updateStateForActionCreate(obj) {
        let missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) {
            window.location.href = window.location.href
            return
        }

        const missionPhaseIndex = this.state.missions[missionIndex].planItems.findIndex(
            (m) => m._id === obj.missionPlanId
        )

        this.commitState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: {
                        planItems: {
                            [missionPhaseIndex]: { actions: { $push: [obj] } },
                        },
                    },
                }),
            },
            () => {
                this.commitState({
                    missionChange: {
                        for: "action",
                        change: "new",
                        timestamp: uniqid(),
                        obj: obj,
                        missionId: this.state.missions[missionIndex]._id,
                    },
                })
            }
        )
    }
    updateStateForActionUpdate(obj, change, waitToUpdate, cb) {
        let indexes = getActionItemIndexes(obj, this.state)

        if (!indexes) {
            this.commitState({
                missionChange: {
                    for: "action",
                    change: change,
                    timestamp: uniqid(),
                    obj: obj,
                    missionId: obj.missionId,
                },
            })
            return
        }

        const newMissions = this.state.missions.slice()

        const originalActionFromState =
            newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex].actions[indexes.missionActionIndex]

        obj.actionItems?.forEach((ai, i) => {
            if (typeof ai === "string") {
                //its an id
                const hydrated = originalActionFromState.actionItems.find((a) => a._id === ai)

                obj.actionItems[i] = hydrated
            }
        })

        newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex].actions[indexes.missionActionIndex] = {
            ...obj,
            ...change,
        }

        this.commitState(
            {
                missions: newMissions,
            },
            () => {
                if (cb) {
                    cb(this.state.missions[indexes.missionIndex], {
                        ...obj,
                        ...change,
                    })
                }
                if (!waitToUpdate) {
                    this.commitState({
                        missionChange: {
                            for: "action",
                            change: change,
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                        },
                    })
                }
            }
        )
    }
    updateStateForActionDelete(obj, cb) {
        let indexes = getActionItemIndexes(obj, this.state)

        this.commitState(
            {
                missions: update(this.state.missions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    $splice: [[indexes.missionActionIndex, 1]],
                                },
                            },
                        },
                    },
                }),
            },
            () => {
                if (cb) {
                    cb(this.state.missions[indexes.missionIndex])
                }
                this.commitState({
                    missionChange: {
                        for: "action",
                        change: "delete",
                        obj: obj,
                        timestamp: uniqid(),
                        missionId: obj.missionId,
                    },
                })
            }
        )
    }
    updateStateForActionItemCreate(obj, cb) {
        const indexes = getActionItemIndexes(obj, this.state)

        if (!indexes) {
            cb?.()
            console.error("indexs issue")
            return
        }

        this.commitState(
            {
                missions: update(this.state.missions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    [indexes.missionActionIndex]: {
                                        actionItems: { $push: [obj] },
                                    },
                                },
                            },
                        },
                    },
                }),
            },
            () => {
                this.commitState(
                    {
                        missionChange: {
                            for: "actionItem",
                            change: "create",
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                        },
                    },
                    () => {
                        if (cb) cb()

                        const m = this.state.missions[indexes.missionIndex]

                        if (m.isProcess && m.isTemplate) {
                            setTimeout(() => {
                                syncProcessFlow({ mission: m, app: this })
                            }, 100)
                        }
                    }
                )
            }
        )
    }

    updateStateForActionItemUpdateBulk(mission, changes, cb) {
        if (changes.length === 0 || !mission) return

        if (typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === mission)
        }
        if (!mission) {
            console.error("Bulk AI update requires mission")
            return
        }

        let newMissions = this.state.missions.slice()
        let newShowDetailsData

        const missionId = getObjectId(mission)

        // Which tasks' dates this batch moves, measured from the tasks as they are now - the
        // budgets on them follow once the batch is in (below)
        const currentMission = this.state.missions.find((m) => m._id === missionId)
        const taskMoves =
            currentMission?.projectType === "mx-gantt"
                ? getTaskMoves(changes, makeHash(getAllActionItems(currentMission)))
                : []

        changes.forEach((change, i) => {
            let c = change.change || change.changes

            if (!change.obj || !c) return

            if (this.state.showDetailsData?._id === change.obj._id) {
                newShowDetailsData = { ...(newShowDetailsData || this.state.showDetailsData), ...c }
            }

            try {
                // Applied against the working copy, not this.state, so earlier splices in this
                // same batch don't invalidate the indexes resolved for later entries.
                newMissions = applyActionItemChange(newMissions, missionId, change)
            } catch (e) {
                // One malformed row must not abort the whole batch's state update.
                this.silentFail("aiBulkState " + (e?.message || e))
            }
        })

        let updateObj = {
            missions: newMissions,
        }

        if (newShowDetailsData) {
            updateObj.showDetailsData = newShowDetailsData
        }

        this.commitState(updateObj, () => {
            const newMission = this.state.missions.find((m) => m._id === getObjectId(mission))
            if (cb) cb(newMission)

            if (newMission?.projectType === "mx-gantt") {
                updateBudgetOnRaciTasks({ mission: newMission, app: this, taskMoves })

                if (taskMoves.length) reconcileCostItems({ mission: newMission, app: this })
            }

            this.commitState({
                missionChange: {
                    timestamp: uniqid(),
                    for: "actionItem",
                    change: "bulk",
                    changes: changes,
                    missionId: mission?._id,
                },
            })
        })
    }
    updateStateForActionItemUpdate(obj, change, dontUpdateView, cb, fromSocket) {
        // 1. Guard Clause
        if (!change || !obj || !this.state) {
            if (!change) {
                console.error("change missing!")
                if (typeof this.silentFail === "function") this.silentFail("change was not passed")
            }
            return
        }

        const indexes = typeof getActionItemIndexes === "function" ? getActionItemIndexes(obj, this.state) : null

        if (!indexes) return

        // 2. Prepare the primary state changes
        const finalUpdate = {}

        // Update showDetailsData if it's the item being edited
        if (this.state.showDetailsData?._id === obj._id) {
            finalUpdate.showDetailsData = update(this.state.showDetailsData, { $merge: change })
        }

        // Update the missions array if indexes are valid
        const hasValidPath = indexes.missionActionItemIndex > -1 && Array.isArray(this.state.missions)
        if (hasValidPath) {
            finalUpdate.missions = update(this.state.missions, {
                [indexes.missionIndex]: {
                    planItems: {
                        [indexes.missionPhaseIndex]: {
                            actions: {
                                [indexes.missionActionIndex]: {
                                    actionItems: {
                                        [indexes.missionActionItemIndex]: { $merge: change },
                                    },
                                },
                            },
                        },
                    },
                },
            })
        }

        // 3. Consolidate "dontUpdateView" logic into the same state object
        if (!dontUpdateView) {
            finalUpdate.missionChange = {
                for: "actionItem",
                from: fromSocket ? "socket" : null,
                change: change,
                timestamp: typeof uniqid === "function" ? uniqid() : Date.now(),
                obj: { ...obj, ...change },
                missionId: obj.missionId,
                dependencyChange: Object.prototype.hasOwnProperty.call(Object(change), "dependencies"),
            }
        }

        // 4. Single Point of Exit: Only update if there's actually work to do
        if (Object.keys(finalUpdate).length === 0) return

        this.commitState(finalUpdate, () => {
            if (typeof cb === "function") {
                const updatedMission = finalUpdate.missions
                    ? finalUpdate.missions[indexes.missionIndex]
                    : this.state.missions[indexes.missionIndex]

                cb({ ...obj, ...change }, updatedMission)
            }
        })
    }
    updateStateForActionItemUpdateXXXXXXX(obj, change, dontUpdateView, cb, fromSocket) {
        if (!change) {
            console.error("change missing!")
            this.silentFail("change was not passed")
            return
        }

        const indexes = getActionItemIndexes(obj, this.state)
        const newState = {}

        if (!indexes) {
            return
        }

        if (this.state.showDetailsData && this.state.showDetailsData._id === obj._id) {
            newState.showDetailsData = update(this.state.showDetailsData, { $merge: change })
        }

        if (indexes.missionActionItemIndex > -1) {
            newState.missions = update(this.state.missions, {
                [indexes.missionIndex]: {
                    planItems: {
                        [indexes.missionPhaseIndex]: {
                            actions: {
                                [indexes.missionActionIndex]: {
                                    actionItems: {
                                        [indexes.missionActionItemIndex]: { $merge: change },
                                    },
                                },
                            },
                        },
                    },
                },
            })
        }

        if (!Object.keys(newState).length) {
            return
        }

        this.setState(newState, () => {
            if (cb) cb({ ...obj, ...change }, newState.missions?.[indexes.missionIndex])

            if (!dontUpdateView) {
                this.setState({
                    missionChange: {
                        for: "actionItem",
                        from: fromSocket ? "socket" : null,
                        change: change,
                        timestamp: uniqid(),
                        obj: { ...obj, ...change },
                        missionId: obj.missionId,
                        dependencyChange: Object(change).hasOwnProperty("dependencies"),
                    },
                })
            }
        })
    }
    /**
     * One socket message of other tabs' changes, applied in one commit with one notice.
     * Every task, activity, plan item and plain project change from the socket lands here;
     * the single updateStateFor* helpers are for this tab's own edits.
     *
     * An updater, committed at once like the helpers (commitState), so it builds on the
     * latest state and nothing reading this.state after it sees the old missions.
     *
     * @param reduce {(prevState) => { entries: object[], [stateKey]: any }} A pure reducer
     *   (utils/actionItemTreeState.js, utils/missionTreeSocketState.js). Of what it returns,
     *   the keys in stateKeys that changed are committed, with the entries as one notice.
     * @param stateKeys {string[]} State keys the reducer may return
     * @param [after] {(applied) => void} Runs after the commit, when anything was applied
     * @param [extraState] {(applied) => object} More state for the same commit
     */
    applySocketMessage(reduce, stateKeys, after, extraState) {
        applySocketMessageTo(this, reduce, stateKeys, after, extraState)
    }

    /** Other tabs' task changes, one message (utils/actionItemTreeState.js) */
    applyActionItemSocketMessage(kind, items) {
        if (!items?.length) return

        this.applySocketMessage(
            (prevState) => applyActionItemSocketChanges(prevState, kind, items),
            ["missions", "showDetailsData"],
            (applied) => {
                // Process templates redraw their flow when tasks come or go, as the single
                // create and delete did
                applied.touchedMissionIds.forEach((missionId) => {
                    const m = this.state.missions.find((mission) => mission._id === missionId)

                    if (m?.isProcess && m?.isTemplate) {
                        setTimeout(() => {
                            syncProcessFlow({ mission: m, app: this })
                        }, 100)
                    }
                })
            }
        )
    }

    /** Other tabs' activity changes, one message (utils/missionTreeSocketState.js) */
    applyActionSocketMessage(kind, items) {
        if (!items?.length) return

        this.applySocketMessage((prevState) => applyActionSocketChanges(prevState, kind, items), ["missions"])
    }

    /**
     * Other tabs' plan item changes, one message (utils/missionTreeSocketState.js). Org
     * screens hear about org projects' changes too: with the update, or a moment after a
     * delete, as the single helpers did.
     */
    applyPlanItemSocketMessage(kind, items) {
        if (!items?.length) return

        const orgChange = (applied) => ({
            for: "mission",
            timestamp: uniqid(),
            missionId: applied.orgMissionIds[applied.orgMissionIds.length - 1],
        })

        this.applySocketMessage(
            (prevState) => applyPlanItemSocketChanges(prevState, kind, items),
            ["missions", "phaseObj"],
            (applied) => {
                if (kind === "delete" && applied.orgMissionIds.length) {
                    setTimeout(() => {
                        this.commitState({ orgChange: { for: "mission", timestamp: uniqid() } })
                    }, 400)
                }
            },
            (applied) => (kind === "update" && applied.orgMissionIds.length ? { orgChange: orgChange(applied) } : {})
        )
    }

    /** Other tabs' plain project field changes, one message (utils/missionTreeSocketState.js) */
    applyMissionSocketMessage(items) {
        if (!items?.length) return

        this.applySocketMessage((prevState) => applyMissionSocketUpdates(prevState, items), ["missions"])
    }

    updateStateForActionItemDelete(obj, cb) {
        // Resolved from missionId alone. The old getActionItemIndexes lookup also needed a
        // matching missionPlanId/actionId on the object, so a stale one made the delete a
        // silent no-op; removal is by id now, so neither is needed.
        const missionIndex = this.state.missions.findIndex((m) => m._id === getObjectId(obj?.missionId))

        if (missionIndex === -1) {
            console.error("indexes issue")
            return []
        }

        const missionId = this.state.missions[missionIndex]._id

        // Strip references to the deleted item off the items that survive. Computed before the
        // removal, immutably — the previous version spliced `dependencies` on live state objects,
        // so the change was invisible to React and was never broadcast (the commit below was also
        // dead behind a `.lenth` typo).
        const bulkChanges = getDanglingDependencyChanges(this.state.missions, missionId, [obj._id])

        let missions = removeActionItemsFrom(this.state.missions, missionId, [obj._id])

        bulkChanges.forEach((change) => {
            missions = applyActionItemChange(missions, missionId, change)
        })

        this.commitState(
            {
                missions: missions,
            },
            () => {
                if (cb) cb(missions[missionIndex])
                this.commitState(
                    {
                        missionChange: {
                            for: "actionItem",
                            change: "delete",
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                            dependencyChange: bulkChanges.length > 0,
                        },
                    },
                    () => {
                        const m = missions[missionIndex]
                        if (m.isProcess && m.isTemplate) {
                            setTimeout(() => {
                                syncProcessFlow({ mission: m, app: this })
                            }, 100)
                        }
                    }
                )
            }
        )

        return bulkChanges
    }
    updateStateForClientCreate(client, cb) {
        this.setState(
            (prevState) => {
                const orgExists = prevState.orgs.some((org) => org._id === client.org)

                if (!orgExists) return null

                return {
                    orgs: prevState.orgs.map((org) => {
                        if (org._id !== client.org) return org

                        return {
                            ...org,
                            clients: [...(org.clients ?? []), client],
                        }
                    }),
                }
            },
            () => cb?.(client)
        )
    }
    updateStateForClientUpdate(client, cb) {
        this.setState(
            (prevState) => {
                const orgIndex = prevState.orgs.findIndex((org) => org._id === client.org)

                if (orgIndex < 0) return null

                const org = prevState.orgs[orgIndex]
                const clients = org.clients ?? []

                const clientIndex = clients.findIndex((c) => c._id === client._id)

                let newClients

                if (clientIndex >= 0) {
                    // update existing
                    newClients = clients.map((c) => (c._id === client._id ? client : c))
                } else {
                    // add new
                    newClients = [...clients, client]
                }

                const newOrgs = prevState.orgs.map((o, i) => (i === orgIndex ? { ...o, clients: newClients } : o))

                return { orgs: newOrgs }
            },
            () => cb?.(client)
        )
    }

    updateStateForClientDelete(orgId, clientId, cb) {
        this.setState(
            (prevState) => {
                const orgExists = prevState.orgs.some((o) => o._id === orgId)
                if (!orgExists) return null

                return {
                    orgs: prevState.orgs.map((org) => {
                        if (org._id !== orgId) return org

                        const clients = org.clients ?? []

                        return {
                            ...org,
                            clients: clients.filter((c) => c._id !== clientId),
                        }
                    }),
                }
            },
            () => cb?.()
        )
    }

    updateStateForMission(mission, change) {
        let newMisisons = this.state.missions?.slice()

        const missionIndex = newMisisons.findIndex((m) => getObjectId(m) === getObjectId(mission))

        if (missionIndex !== -1) {
            newMisisons[missionIndex] = { ...newMisisons[missionIndex], ...change }

            this.commitState(
                {
                    missions: newMisisons,
                },
                () => {
                    this.commitState({
                        missionChange: {
                            for: "mission",
                            change: "update",
                            timestamp: uniqid(),
                            missionId: mission._id,
                        },
                    })
                }
            )
        }
    }
    updateStateForMissionPeopleChange(missionIndex, changeItem) {
        const missionId = this.state.missions?.[missionIndex]?._id

        if (!changeItem || !missionId) {
            return
        }

        let resultPeople

        // Updater form: works on the latest missions (found by id, not an index taken before
        // the batch), and builds new objects instead of editing the ones in state
        this.setState(
            (prevState) => {
                const index = prevState.missions.findIndex((m) => m._id === missionId)
                const mission = prevState.missions[index]

                if (!mission?.people) return null

                const personIndex = mission.people.findIndex((person) => getRefId(person) === getRefId(changeItem.doc))

                const withPeople = (people) => {
                    resultPeople = people
                    const missions = prevState.missions.slice()
                    missions[index] = { ...mission, people }
                    return { missions }
                }

                if (changeItem.changeType === "create") {
                    if (personIndex !== -1) return null

                    return withPeople([...mission.people, changeItem.doc])
                }

                if (changeItem.changeType === "update") {
                    if (personIndex === -1) return null

                    return withPeople(
                        mission.people.toSpliced(personIndex, 1, {
                            ...changeItem.doc,
                            ref:
                                typeof changeItem.doc?.ref === "string"
                                    ? mission.people[personIndex]?.ref
                                    : changeItem.doc?.ref,
                        }),
                    )
                }

                if (changeItem.changeType === "delete") {
                    // Not on the project: nothing to remove (splice(-1) used to drop the last person)
                    if (personIndex === -1) return null

                    const personAffected = mission.people[personIndex]
                    const orgPerson = mission.org
                        ? prevState.orgs
                              .find((o) => o._id === getObjectId(mission.org))
                              ?.people?.find?.((p) => getRefId(p) === getRefId(personAffected))
                        : null

                    // Org admins keep seeing the project
                    if (orgPerson && (orgPerson.permission === 1 || orgPerson.permission === 2)) return null

                    if (!orgPerson && getRefId(personAffected) === prevState.person._id) {
                        resultPeople = mission.people.toSpliced(personIndex, 1)
                        return { missions: prevState.missions.toSpliced(index, 1) }
                    }

                    return withPeople(mission.people.toSpliced(personIndex, 1))
                }

                return null
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId,
                        people: resultPeople ?? this.state.missions.find((m) => m._id === missionId)?.people,
                    },
                })
            },
        )
    }
    updateStateForMissionCreate(mission, cb) {
        const me = this

        let newMissions = me.state.missions.slice()
        newMissions.push(mission)

        let changeObj = {
            missions: newMissions,
        }

        if (mission.org) {
            const orgIndex = this.state.orgs.findIndex((o) => o._id === getObjectId(mission.org))

            if (orgIndex !== -1) {
                let newOrgs = this.state.orgs.slice()

                if (newOrgs[orgIndex].missions) {
                    newOrgs[orgIndex].missions.push(mission)
                    changeObj.orgs = newOrgs
                }
            }
        }

        this.commitState(changeObj, () => {
            this.commitState({
                missionChange: {
                    for: "mission",
                    change: "create",
                    timestamp: uniqid(),
                    obj: mission,
                    missionId: mission._id,
                },
            })

            if (cb) cb()
        })
    }
    updateStateForMissionUpdate({ mission, changes }) {
        this.missionUpdateState(mission._id, changes)
    }
    updateStateForPlanItemCreateBulk(missionId, planItems) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)

        if (missionIndex === -1) {
            return
        }

        let newPlanItems = [...this.state.missions[missionIndex].planItems, ...planItems]

        this.commitState({
            missions: update(this.state.missions, {
                [missionIndex]: {
                    planItems: {
                        $set: newPlanItems,
                    },
                },
            }),
        })
    }
    updateStateForPlanItemCreate(obj, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) {
            return
        }

        let newState = {
            missions: update(this.state.missions, {
                [missionIndex]: {
                    planItems: {
                        $push: [obj],
                    },
                },
            }),
        }

        //Set and do
        this.commitState(newState, () => {
            this.commitState({
                missionChange: {
                    for: "planItem",
                    change: "create",
                    timestamp: uniqid(),
                    obj: obj,
                    missionId: obj.missionId,
                },
            })

            if (cb) cb()
        })
    }
    updateStateForPlanItemUpdateBulk(changes, cb, fastCallBack) {
        let newStateObj = {}

        if (!changes || changes.length === 0) {
            return
        }

        const obj = changes[0].obj

        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return

        let planItems = []

        let newMissions = this.state.missions.slice()

        this.state.missions[missionIndex].planItems.forEach((pi, i) => {
            const fp = changes.find((c) => c.obj._id === pi._id)

            if (fp) {
                planItems.push({ ...pi, ...fp.change })
            } else {
                planItems.push(pi)
            }
        })

        newMissions[missionIndex].planItems = planItems
        newStateObj.missions = newMissions

        if (fastCallBack) {
            fastCallBack(newMissions[missionIndex])
        }

        newStateObj.missionChange = {
            for: "planItem",
            planItems: planItems,
            changes: changes,
            timestamp: uniqid(),
            missionId: this.state.missions[missionIndex]._id,
        }

        this.setState(newStateObj, () => {
            if (cb) {
                const newM = newMissions[missionIndex]
                cb(newM)
            }
        })
    }
    updateStateForPlanItemUpdate(obj, change, cb) {
        let newStateObj = {}

        if (!obj || !change) {
            return
        }

        if (this.state.phaseObj && this.state.phaseObj._id === obj._id) {
            newStateObj.phaseObj = { ...this.state.phaseObj, ...change }
        }

        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return
        const mission = this.state.missions[missionIndex]

        const planItemIndex = this.state.missions[missionIndex].planItems.findIndex((p) => p._id === obj._id)

        if (planItemIndex === -1) return

        newStateObj.missions = update(this.state.missions, {
            [missionIndex]: {
                planItems: {
                    [planItemIndex]: { $merge: change },
                },
            },
        })

        this.commitState(newStateObj, () => {
            if (this.state.missions[missionIndex].org) {
                const newOrgObj = this.state.orgs.find((o) => o._id === getObjectId(mission.org))

                this.commitState({
                    missionChange: {
                        for: "planItem",
                        obj: obj,
                        change: change,
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]._id,
                        orgId: getObjectId(mission.org),
                        newStateOrg: newOrgObj,
                    },
                    orgChange: {
                        for: "mission",
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]._id,
                    },
                })
            }

            if (cb) cb({ ...obj, ...change })
        })
    }
    updateStateForPlanItemRemoveRolesBulk(items) {
        let newMissions = this.state.missions.slice()
        items.forEach((pi, i) => {
            const missionIndex = this.state.missions.findIndex((m) => m._id === pi.missionId)
            if (missionIndex === -1) return
            const missionPlanIndex = this.state.missions[missionIndex].planItems.findIndex((p) => p._id === pi._id)
            if (missionPlanIndex === -1) return

            newMissions[missionIndex].planItems.splice(missionPlanIndex, 1)
        })

        this.commitState({
            missions: newMissions,
        })
    }
    updateStateForPlanItemRemove(obj) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return

        const missionPlanIndex = this.state.missions[missionIndex].planItems.findIndex((m) => m._id === obj._id)

        if (missionPlanIndex === -1) return

        this.commitState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: { planItems: { $splice: [[missionPlanIndex, 1]] } },
                }),
                missionChange: {
                    for: "planItem",
                    change: "delete",
                    timestamp: uniqid(),
                    obj: obj,
                    missionId: obj.missionId,
                },
            },
            () => {
                setTimeout(() => {
                    try {
                        let mission = this.state.missions[missionIndex]
                        if (mission && mission.org) {
                            this.commitState({
                                orgChange: {
                                    for: "mission",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    } catch (e) {}
                }, 400)
            }
        )
    }

    async changeListener() {
        const me = this

        // Subscribe once per page. This runs after every org reload (socket back after a long time
        // offline, accepting an org invite), and socket.io opens a new connection for a namespace that
        // is already open - so each reload added 24 websockets and a second copy of every handler.
        // The server routes changes by user id when it sends them, so newly joined orgs need no new
        // subscription. Sign out leaves the page.
        if (this.changeListenersOn) return
        this.changeListenersOn = true

        apiOrg.onChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.orgCleanUpDeleted(changeObj._id)
                }
            })
        })
        apiOrg.onChanges("update", (changes) => {
            changes.forEach((changeObj) => {
                const orgs = this.state.orgs
                const changedOrgIndex = (orgs || []).findIndex((o) => o._id === changeObj._id)

                if (changedOrgIndex === -1) return

                if (changeObj.change.people) {
                    // Updater form: built on the latest orgs, not a snapshot an earlier
                    // event in the same batch has already replaced
                    this.setState(
                        (prevState) => {
                            const orgIndex = (prevState.orgs || []).findIndex((o) => o._id === changeObj._id)

                            if (orgIndex === -1) return null

                            return {
                                orgs: update(prevState.orgs, {
                                    [orgIndex]: {
                                        people: {
                                            $set: changeObj.change.people.map((item) => {
                                                const statePerson = (
                                                    get(prevState.orgs[orgIndex], "people") || []
                                                ).find((person) => person._id === item._id)
                                                return {
                                                    ...item,
                                                    ref: get(statePerson, "ref") || item.ref,
                                                }
                                            }),
                                        },
                                    },
                                }),
                            }
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                } else if (changeObj.byRequestId !== getUserRequestId() || changeObj.change.programs) {
                    const changedOrgIndex = (orgs || []).findIndex((o) => o._id === changeObj._id)

                    this.orgUpdateState(orgs[changedOrgIndex], changeObj.change)
                }
            })
        })

        apiOrg.onChanges("rebuild", (changeList) => {
            try {
                changeList.forEach((changeObj) => {
                    if (!changeObj.removedPeople?.length) return

                    // Updater form, and new objects instead of editing the ones in state
                    this.setState((prevState) => {
                        const newOrgIndex = prevState.orgs.findIndex((o) => o._id === changeObj._id)

                        if (newOrgIndex === -1) return null

                        const removed = changeObj.removedPeople.filter((id) => id !== prevState.person._id)

                        const newOrgs = prevState.orgs.slice()
                        newOrgs[newOrgIndex] = {
                            ...newOrgs[newOrgIndex],
                            people: (newOrgs[newOrgIndex].people || []).filter((pp) => !removed.includes(getRefId(pp))),
                        }

                        let newMissions = prevState.missions
                        const mIndex = prevState.mission
                            ? prevState.missions.findIndex((m) => m._id === prevState.mission)
                            : -1

                        if (mIndex !== -1 && prevState.missions[mIndex].people?.some((p) => removed.includes(getRefId(p)))) {
                            newMissions = prevState.missions.slice()
                            newMissions[mIndex] = {
                                ...newMissions[mIndex],
                                people: newMissions[mIndex].people.filter((p) => !removed.includes(getRefId(p))),
                            }
                        }

                        return { orgs: newOrgs, missions: newMissions }
                    })
                })
            } catch (e) {
                this.silentFail("rebuild - delkjfef:" + e.message)
            }
        })

        apiOrg.onPeopleChanges("create", (changeList) => {
            changeList.forEach((changeItem) => {
                if (!changeItem?.doc) {
                    return
                }

                try {
                    // Updater form: each push lands on the latest orgs, so several adds in one
                    // list (or two events before a render) don't overwrite each other
                    this.setState(
                        (prevState) => {
                            const changedOrgIndex = (prevState.orgs || []).findIndex(
                                (org) => org._id === changeItem.orgId,
                            )

                            if (changedOrgIndex === -1) return null

                            return {
                                orgs: update(prevState.orgs, {
                                    [changedOrgIndex]: {
                                        people: {
                                            $push: [changeItem.doc],
                                        },
                                    },
                                }),
                            }
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                } catch (e) {
                } finally {
                }
            })
        })

        apiOrg.onPeopleChanges("update", async (changeList) => {
            for (const changeItem of changeList) {
                if (getRefId(changeItem.ref) === this.state.person._id) {
                    await delay(2000)

                    try {
                        //fuck this - check if they are there
                        const check = await getOrgPeople(changeItem.orgId, {
                            limit: 1,
                            select: ["_id"],
                        })
                    } catch (err) {
                        if (err === "Forbidden") {
                            try {
                                this.orgCleanUpDeleted(changeItem.orgId)

                                const missionsToClean = this.state.missions.filter(
                                    (m) => getObjectId(m.org) === changeItem.orgId
                                )

                                missionsToClean.forEach((m) => {
                                    this.missionCleanUpDeleted(m._id, this.state.person._id)
                                })
                            } catch (ecf) {
                                return
                            }
                        }
                    }
                }

                if (!changeItem.doc) continue

                // Updater form: the latest orgs (this may run 2s after the event), and an
                // unknown org or person skips this item only, not the rest of the list
                this.setState(
                    (prevState) => {
                        const orgList = prevState.orgs
                        const changedOrgIndex = (orgList || []).findIndex((org) => org._id === changeItem.orgId)

                        if (changedOrgIndex === -1) return null

                        const orgPersonIndex =
                            orgList[changedOrgIndex]?.people?.findIndex(
                                (person) => getObjectId(person.ref) === getObjectId(changeItem.doc?.ref),
                            ) ?? -1

                        if (orgPersonIndex === -1) return null

                        return {
                            orgs: update(orgList, {
                                [changedOrgIndex]: {
                                    people: {
                                        [orgPersonIndex]: {
                                            $set: changeItem.doc,
                                        },
                                    },
                                },
                            }),
                        }
                    },
                    () => {
                        this.setState({
                            orgChange: {
                                for: "people",
                                timestamp: uniqid(),
                            },
                        })
                    }
                )
            }
        })

        //

        apiOrg.onPeopleChanges("delete", (changeList) => {
            changeList.forEach((changeItem) => {
                const changedOrgIndex = (this.state.orgs || []).findIndex((org) => org._id === changeItem.orgId)

                if (changedOrgIndex === -1) {
                    return
                }

                if (changeItem._id === this.state.person._id) {
                    // I got kicked out of this org

                    const missionsToClean = this.state.missions.filter((m) => getObjectId(m.org) === changeItem.orgId)

                    missionsToClean.forEach((m) => {
                        this.missionCleanUpDeleted(m._id, this.state.person._id)
                    })

                    this.orgCleanUpDeleted(changeItem.orgId)
                } else {
                    this.setState(
                        (prevState) => {
                            const orgIndex = (prevState.orgs || []).findIndex((org) => org._id === changeItem.orgId)

                            if (orgIndex === -1) return null

                            return {
                                orgs: update(prevState.orgs, {
                                    [orgIndex]: {
                                        people: {
                                            $set:
                                                prevState.orgs[orgIndex].people?.filter(
                                                    (person) => getObjectId(person.ref) !== changeItem._id,
                                                ) ?? [],
                                        },
                                    },
                                }),
                            }
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                }
            })
        })

        apiOrg.onClientChanges("create", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientCreate(changeObj.doc)
                }
            })
        })

        apiOrg.onClientChanges("update", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientUpdate(changeObj.doc)
                }
            })
        })

        apiOrg.onClientChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientDelete(changeObj.orgId, changeObj._id)
                }
            })
        })

        apiMission.onChanges("update", (changes) => {
            // Plain field changes, applied together after the people ones
            const plain = []

            changes.forEach((changeObj) => {
                const missionIndex = this.state.missions.findIndex((m) => m._id === changeObj._id)
                if (missionIndex === -1) return

                if (
                    Object.keys(changeObj.change).length === 1 &&
                    Object(changeObj.change).hasOwnProperty("people") &&
                    !changeObj.change.people
                ) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeObj)
                } else if (changeObj.change.people) {
                    if (changeObj.change.people && changeObj.change.people.length === 0) {
                        me.missionCleanUpDeleted(changeObj._id, changeObj.by)
                        return
                    }

                    this.updateStateForMissionPeopleChange(missionIndex, changeObj)
                } else if (changeObj.byRequestId !== getUserRequestId() || changeObj.change.files) {
                    plain.push({ _id: changeObj._id, change: changeObj.change })
                }
            })

            this.applyMissionSocketMessage(plain)
        })

        apiMission.onChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                // Every tab, this one's own request included: Home holds the mission's tasks
                emitMissionDeleted(changeObj._id || changeObj.doc?._id)

                // TODO: @makis Remove from all phases of all missions, all the dependencies that have linkToMission._id === changeObj._id

                if (changeObj.byRequestId !== getUserRequestId()) {
                    const stateMission = this.state.missions.find((m) => m._id === changeObj.doc?._id)

                    if (
                        stateMission?.people?.find((p) => getRefId(p) === this.state.person._id)?.permission < 3 &&
                        !toast.isActive("deletedMission" + changeObj.doc?._id)
                    ) {
                        toast.warning("FYI: Project " + changeObj.doc.title + " was just archived.", {
                            autoClose: 6000,
                            toastId: "deletedMission" + changeObj.doc?._id,
                            position: "bottom-right",
                        })
                    }

                    me.missionCleanUpDeleted(changeObj._id, changeObj.by)
                }
            })
        })

        apiMission.onChanges("create", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    me.updateStateForMissionCreate(changeObj.doc)
                }
            })
        })

        apiMission.onPeopleChanges("create", (changes) => {
            changes.forEach((changeItem) => {
                const missionIndex = this.state.missions.findIndex(
                    (m) => m._id === getObjectId(changeItem.doc?.mission)
                )
                if (missionIndex !== -1) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                }
            })
        })

        apiMission.onPeopleChanges("update", (changes) => {
            changes.forEach((changeItem) => {
                const missionIndex = this.state.missions.findIndex(
                    (m) => m._id === getObjectId(changeItem.doc?.mission)
                )
                if (missionIndex !== -1) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                }
            })
        })

        apiMission.onPeopleChanges("delete", (changes) => {
            changes.forEach((changeItem) => {
                if (changeItem.byRequestId !== getUserRequestId()) {
                    const missionIndex = this.state.missions.findIndex(
                        (m) => m._id === getObjectId(changeItem.doc?.mission)
                    )
                    if (missionIndex !== -1) {
                        this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                    }
                }
            })
        })

        apiPlanItems.onChanges("update", (changes) => {
            const applies = changes.filter(
                (change) =>
                    change.doc &&
                    (!!get(change, "change.dependencies") ||
                        change.byRequestId !== getUserRequestId() ||
                        (change?.change?.personLeftRole && change?.change?.person === null))
            )

            this.applyPlanItemSocketMessage("update", applies)
        })

        apiPlanItems.onChanges("create", (changes) => {
            this.applyPlanItemSocketMessage(
                "create",
                changes.filter((change) => change.byRequestId !== getUserRequestId())
            )
        })
        apiPlanItems.onChanges("delete", (changes) => {
            this.applyPlanItemSocketMessage(
                "delete",
                changes.filter((change) => change.byRequestId !== getUserRequestId())
            )
        })

        apiAction.onChanges("create", (changes) => {
            this.applyActionSocketMessage(
                "create",
                changes.filter((change) => change.byRequestId !== getUserRequestId())
            )
        })

        apiAction.onChanges("update", (rawChanges) => {
            // A task move sends both activities with plain task id lists; those must never
            // replace the task objects held (see withoutTaskIdLists)
            const changes = withoutTaskIdLists(rawChanges)

            // Full docs and the Gantt bulk endpoint's short ones (missionId + changed fields)
            // alike: see applyActionSocketChanges
            this.applyActionSocketMessage(
                "update",
                changes.filter((change) => change.doc && change.byRequestId !== getUserRequestId())
            )
        })

        apiAction.onChanges("delete", (changes) => {
            this.applyActionSocketMessage(
                "delete",
                changes.filter((change) => change.byRequestId !== getUserRequestId() && change.doc)
            )
        })

        //Action Items

        apiActionItem.onChanges("create", (changes) => {
            emitActionItemChanges("create", changes)

            this.applyActionItemSocketMessage(
                "create",
                changes.filter((change) => change.byRequestId !== getUserRequestId())
            )
        })

        apiActionItem.onChanges("update", (changes) => {
            emitActionItemChanges("update", changes)

            this.applyActionItemSocketMessage(
                "update",
                changes.filter((change) => change.doc && change.byRequestId !== getUserRequestId())
            )
        })
        apiActionItem.onChanges("delete", (changes) => {
            emitActionItemChanges("delete", changes)

            this.applyActionItemSocketMessage(
                "delete",
                changes.filter((change) => change.byRequestId !== getUserRequestId())
            )
        })
        // The notifications' own changes are the store's; the App only beeps.
        if (!this.offNotificationCreate) {
            this.offNotificationCreate = notificationStore.onCreate(() => {
                setTimeout(() => {
                    try {
                        me?.msgBeep?.current?.play()
                    } catch (e) {
                        me.silentFail("me.msgBeep.current")
                    }
                }, 1500)
            })
        }
    }

    onFileDelete(file) {
        if (!file || !file.attachedTo || !file.attachedToId) {
            return
        }

        apiFile
            .deleteFile(file._id)
            .then((res) => {
                if (file.attachedTo === "action.items") {
                    let actionItem = this.state.showDetailsData

                    if (actionItem) {
                        const fileIndex = actionItem.files.findIndex((item) => getObjectId(item) === file._id)

                        if (fileIndex > -1) {
                            let clonedFiles = actionItem.files.slice()
                            clonedFiles.splice(fileIndex, 1)

                            this.updateStateForActionItemUpdate(actionItem, {
                                files: clonedFiles,
                            })
                        }
                    }
                } else {
                    let mission = (this.state.missions || []).find((mi) =>
                        (mi.files || []).some((item) => getObjectId(item) === file._id)
                    )

                    if (mission) {
                        const fileIndex = mission.files.findIndex((item) => getObjectId(item) === file._id)

                        if (fileIndex > -1) {
                            let clonedFiles = mission.files.slice()
                            clonedFiles.splice(fileIndex, 1)

                            this.missionUpdateState(mission._id, {
                                files: clonedFiles,
                            })
                        }
                    }
                }
            })
            .catch((err) => {
                toast.error(err.message)
                this.silentFail("x-23ds4422-" + (err?.message + " - " + err?.toString()))
            })
    }
    showLeaveTracking() {
        if (this.state.orgs.length === 0) return false
        let show = false
        this.state.orgs.forEach((o, i) => {
            if (o.isLicensedActive) {
                show = true
            }
        })

        return show
    }
    showExpenseTracking() {
        if (this.state.orgs.length === 0) return false
        let show = false
        this.state.orgs.forEach((o, i) => {
            if (o.isLicensedActive && !o.expensesDisabled) {
                show = true
            }
        })

        return show
    }

    confirm(props) {
        const { onYes, onNo, onCancel } = props

        const onCancelMe = () => {
            this.setState({
                confirm: null,
            })

            if (onCancel) {
                onCancel()
            }
        }
        const onYesMe = () => {
            if (onYes) {
                let ok = onYes()

                if (ok !== false)
                    this.setState({
                        confirm: null,
                    })
            }
        }
        const onNoMe = () => {
            this.setState({
                confirm: null,
            })
            if (onNo) {
                onNo()
            }
        }

        this.setState({
            confirm: {
                ...props,
                onCancel: onCancelMe,
                onYes: onYesMe,
                onNo: onNo ? onNoMe : undefined,
            },
        })
    }
    msg(msg) {
        this.setState({
            msg: msg,
        })
    }

    render() {
        if (
            !this.state.person?._id &&
            !this.state.login &&
            !this.state.vendorOnboarding &&
            !this.state.invoiceApproval &&
            !this.state.crApproval &&
            !this.state.unsubscribe &&
            !this.state.followUpLink
        ) {
            return (
                <div className="dna-col dna-main-loading-data">
                     <SpaceRocket/>
                     <label style={{marginTop:30}} className="mono">Preparing workspace</label>


                </div>
            )
        }

        const state = this.state

        const cn = cx("dna", {
            "dna-show-home": this.state.home,
            "dna-show-board": this.state.board,
            "dna-not-base": this.state.mission || this.state.phase || this.state.org,
            "dna-no-me-avatar":
                this.state.myspace ||
                this.state.login ||
                this.state.vendorOnboarding ||
                this.state.invoiceApproval ||
                this.state.crApproval ||
                this.state.unsubscribe ||
                this.state.followUpLink ||
                this.state.orgCrud ||
                this.state.missionCrud ||
                this.state.createProposal ||
                this.state.createMission,

            "dna-no-ai": this.state.myspace,
            "dna-tone-down": this.state.waiting,
            "dna-mission-landing": true,
            "dna-show-control-panel": this.state.controlPanel,
            "dna-show-notifications-panel": this.state.notificationOpen,
            "dna-show-msg": this.state.msg,
        })

        const orgDataToShow = Boolean(this.state.orgIndex !== undefined && this.state.org)
            ? this.state.orgs.find((o) => getObjectId(o) === this.state.org)
            : null

        return (
            <>
                <div key={this.state.avKey} className={cn}>
                    <ActionItem
                        ai={this.state.showDetailsData}
                        options={this.state.showDetailsDataOptions}
                        app={this}
                        onClose={() => {
                            removeParam("action-item")
                        }}
                        open={Boolean(this.state.showDetailsData)}
                        stateChange={this.state.missionChange}
                    />

                    {/* ++++++++ SIGN-OFF (on its own: from an email, a notification or the inbox) */}
                    {this.state.showSignOff && (
                        <SignOffView
                            app={this}
                            orgId={this.state.showSignOff.orgId}
                            signOffId={this.state.showSignOff.id}
                            open={Boolean(this.state.showSignOff)}
                            onClose={() => {
                                removeParams("sign-off,sign-off-org")
                                this.setState({ showSignOff: null })
                            }}
                        />
                    )}

                    {/* ++++++++ VIRTUAL PM FOLLOW-UP (?follow-up=<id>: its notification and email) */}
                    {this.state.showFollowUp && (
                        <Card
                            closeButton
                            modal
                            portal
                            center
                            autoClose={true}
                            className="dna-dark dna-dark-bg"
                            modalIndex={9998}
                            style={{ width: "96vw", maxWidth: 640, zIndex: 9999 }}
                            onClose={() => {
                                removeParams("follow-up,follow-up-org")
                                this.setState({ showFollowUp: null })
                            }}
                            open={Boolean(this.state.showFollowUp)}
                        >
                            <ErrorBoundary app={this}>
                                <OverdueFollowUp
                                    app={this}
                                    orgId={this.state.showFollowUp.orgId}
                                    followUpId={this.state.showFollowUp.id}
                                    onClose={() => {
                                        removeParams("follow-up,follow-up-org")
                                        this.setState({ showFollowUp: null })
                                    }}
                                />
                            </ErrorBoundary>
                        </Card>
                    )}

                    {/* ++++++++ MY REMINDERS (mAX's my_reminders, or ?reminders=open from an email) */}
                    {this.state.showReminders && (
                        <Card
                            closeButton
                            modal
                            portal
                            center
                            autoClose={true}
                            className="dna-dark dna-dark-bg"
                            modalIndex={9998}
                            style={{ width: "96vw", maxWidth: 1100, zIndex: 9999 }}
                            onClose={() => {
                                removeParams("reminders")
                                this.setState({ showReminders: false })
                            }}
                            open={this.state.showReminders}
                        >
                            <ErrorBoundary app={this}>
                                <MyReminders
                                    app={this}
                                    onClose={() => {
                                        removeParams("reminders")
                                        this.setState({ showReminders: false })
                                    }}
                                />
                            </ErrorBoundary>
                        </Card>
                    )}

                    {/* ++++++++ FILE VIEWER */}
                    {!!state.fileSelected && (
                        <Drive
                            onClose={() =>
                                this.setState({
                                    fileSelected: null,
                                    fileSelectedList: null,
                                })
                            }
                            onFileDelete={(file) => this.onFileDelete(file)}
                            file={state.fileSelected}
                            fileList={state.fileSelectedList}
                            app={this}
                        />
                    )}

                    {/* +++++++++ LOGIN */}
                    <FullScreen
                        param="login"
                        className="dna-login-screen"
                        closeClass="dna-dark"
                        style={{ zIndex: 9 }}
                        open={state.login}
                        onClose={() => {
                            setTimeout(() => {
                                if (!this.state.person._id) {
                                    window.location.href = "https://www.missionx.ai/web" + window.location.search
                                }
                            }, 0)
                        }}
                    >
                        <Login app={this} reset={state.resetLoginStates} />
                    </FullScreen>

                    {/* +++++++++ VENDOR ONBOARDING (magic-link, no account) */}

                        <FullScreen
                            style={{ zIndex: 9 }}
                        open={state.vendorOnboarding}

                            onClose={() => {
                                window.location.href = "https://www.missionx.ai/web"
                            }}
                    >
                        {state.vendorOnboarding && (
                            <VendorSetup token={state.vendorOnboardingToken} />
                        )}
                        </FullScreen>

                    {/* +++++++++ INVOICE APPROVAL (magic-link, no account) */}
                    <FullScreen
                        style={{ zIndex: 9 }}
                        open={state.invoiceApproval}

                        onClose={() => {
                            window.location.href = "https://www.missionx.ai/web"
                        }}
                    >
                        {state.invoiceApproval && (
                            <InvoiceApproval
                                token={state.invoiceApprovalToken}
                                intendedAction={state.invoiceApprovalAction}
                            />
                        )}
                    </FullScreen>

                    {/* +++++++++ CHANGE REQUEST SIGN-OFF (magic-link, no account) */}
                    <FullScreen
                        className="dna-dark dna-dark-bg "
                        style={{ zIndex: 9 }}
                        closeClass={"dna-dark"}
                        open={state.crApproval}
                        onClose={() => {
                            window.location.href = "https://www.missionx.ai/web"
                        }}
                    >
                        {state.crApproval && <CrApproval token={state.crApprovalToken} />}
                    </FullScreen>

                    {/* +++++++++ UNSUBSCRIBE (email link, no sign-in) */}
                    <FullScreen
                        className="dna-dark dna-dark-bg "
                        style={{ zIndex: 9 }}
                        closeClass={"dna-dark"}
                        open={Boolean(state.unsubscribe)}
                        onClose={() => this.closeUnsubscribe()}
                    >
                        {state.unsubscribe && (
                            <Unsubscribe
                                token={state.unsubscribe.token}
                                from={state.unsubscribe.from}
                                preview={state.unsubscribe.preview}
                                onDone={() => this.closeUnsubscribe()}
                            />
                        )}
                    </FullScreen>

                    {/* +++++++++ VIRTUAL PM LINK (emailed "Done!" / "Approve", no sign-in) */}
                    <FullScreen
                        className="dna-dark dna-dark-bg "
                        style={{ zIndex: 9 }}
                        closeClass={"dna-dark"}
                        open={Boolean(state.followUpLink)}
                        onClose={() => this.closeFollowUpLink()}
                    >
                        {state.followUpLink && (
                            <FollowUpLanding
                                token={state.followUpLink.token}
                                answer={state.followUpLink.answer}
                                onDone={() => this.closeFollowUpLink()}
                            />
                        )}
                    </FullScreen>

                    {(this.state.showMySpace || this.state.showAll) && (
                        <FullScreen
                            param="myspace"
                            style={{ zIndex: this.state.myspace ? 99 : 5 }}
                            className="myspace-fs"
                            open={state.myspace}
                        >
                            <ErrorBoundary app={this} context="my-space">
                                <MySpace
                                    app={this}
                                    person={this.state.person}
                                    profileUpdateState={(change) => this.profileUpdateState(change)}
                                />
                            </ErrorBoundary>
                        </FullScreen>
                    )}
                    {/*  ++++++++ HOME & BOARD */}
                    {this.state.person?._id &&
                        !this.state.org &&
                        this.state.person.firstName &&
                        this.state.person.lastName && (
                            <ErrorBoundary app={this} context="home">
                                <Home
                                    app={this}
                                    missionChange={this.state.missionChange}
                                    taskMasterRef={this.taskMasterRef}
                                />
                            </ErrorBoundary>
                        )}

                    {this.state.board && (
                        <ErrorBoundary app={this} context="board">
                            <Board app={this} theMissionsHaveLanded={true} stateChange={this.state.missionChange} />
                        </ErrorBoundary>
                    )}

                    {/*  ++++++++ CRUD MISSION */}
                    {this.state.showAll && (
                        <>
                            <FullScreen
                                key="p-crud"
                                param="create-proposal"
                                style={{ zIndex: 8 }}
                                open={state.createProposal}
                            >
                                {state.createProposal && (
                                    <ErrorBoundary app={this} context="create-bid">
                                        <CreateBid
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    proposalCreate: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen
                                param="mc,mc-org,mc-program,create-mission,mc-org-goal,mc-prop,create-proposal,mc-departments,mc-offices,mc-client,mc-title,mc-type,mc-template"
                                style={{ zIndex: 120 }}
                                open={state.createMission}
                            >
                                {state.createMission && (
                                    <ErrorBoundary app={this} context="create-mission">
                                        <CreateMission
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    createMission: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen
                                style={{ zIndex: 999999 }}
                                open={state.createTemplate}
                                onClose={() => {
                                    this.setState({
                                        createTemplate: false,
                                    })
                                }}
                            >
                                {state.createTemplate && (
                                    <ErrorBoundary app={this} context="create-template">
                                        <CreateTemplate
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    createTemplate: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen key="crud" param="mc,mc-org" style={{ zIndex: 8 }} open={state.missionCrud}>
                                {this.state.mission && (
                                    <ErrorBoundary app={this} context="crud-mission">
                                        <CrudMission
                                            app={this}
                                            data={this.state.missions.find((m) => m._id === this.state.mission)}
                                            missionUpdateState={this.missionUpdateState.bind(this)}
                                            onClose={() => {
                                                this.setState({
                                                    missionCrud: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                        </>
                    )}
                    {this.state.mission && this.state.orgsLoaded && <MissionLoader app={this} />}

                    {/*
                        mAX is always on: one floating bubble over the whole app, holding one
                        conversation that follows the person from here into the wizard and into
                        whatever project they open. Mounted once, never keyed on what is open,
                        so navigating never restarts the thread. The launcher itself decides
                        whether it renders at all (org membership, credits).
                    */}
                    {this.state.orgsLoaded && this.state.person?._id && (
                        <ErrorBoundary app={this} context="max">
                            <MaxLauncher app={this} />
                        </ErrorBoundary>
                    )}

                    {/* Chat: people, groups and task rooms. Opened from the Chats tab, Team activity or ?chat= */}
                    {this.state.orgsLoaded && this.state.person?._id && (
                        <ErrorBoundary app={this} context="chat">
                            <Chat app={this} />
                        </ErrorBoundary>
                    )}

                    {/*  ++++++++ ORG */}

                    <FullScreen
                        param="org,org-tab,org-goal,portfolio-details,invoice,mc-prop,org-cfg,oc-domains,oc-expenses,oc-offices,oc-departments,invoice,otPeriodEnd,otPeriodStart,otPeriodType"
                        style={{ zIndex: 3 }}
                        open={Boolean(orgDataToShow)}
                        closeClass="org-close-x"
                        closeTip={"Exit organization"}
                    >
                        {this.state.orgsLoaded && !this.state.mission && (
                            <ErrorBoundary app={this} context="org">
                                <Org
                                    key={orgDataToShow?._id}
                                    orgUpdateState={this.orgUpdateState.bind(this)}
                                    missionChange={this.state.missionChange}
                                    orgData={orgDataToShow}
                                    orgChange={this.state.orgChange}
                                    app={this}
                                />
                            </ErrorBoundary>
                        )}
                    </FullScreen>

                    {/* +++++++++ CRUD ORG */}
                    <FullScreen param="hq" style={{ zIndex: 10 }} open={this.state.orgCrud}>
                        {this.state.orgCrud && (
                            <ErrorBoundary app={this} context="crud-org">
                                <CrudOrg
                                    app={this}
                                    data={state.orgs[state.orgIndex]}
                                    onClose={() => {
                                        this.setState({
                                            orgCrud: false,
                                        })
                                    }}
                                />
                            </ErrorBoundary>
                        )}
                    </FullScreen>
                    <ErrorBoundary app={this} context="budget-pro">
                        <BudgetPro
                            app={this}
                            flashRowId={this.state.budgetProMission?.flashRowId}
                            dontShowAppToolsOnExit={this.state.budgetProMission?.dontShowAppToolsOnExit}
                            open={Boolean(this.state.budgetProMission)}
                            fullMission={
                                this.state.budgetProMission?.mission?.fullyLoaded
                                    ? this.state.budgetProMission?.mission
                                    : undefined
                            }
                            missionId={
                                this.state.budgetProMission?.mission?.fullyLoaded
                                    ? null
                                    : this.state.budgetProMission?.mission?._id ||
                                      this.state.budgetProMission?.missionId
                            }
                            timesheets={this.state.budgetProMission?.timesheets?.filter(
                                (t) => t.snapshot?.mission?._id === this.state.budgetProMission?.mission?._id
                            )}
                            startTab={this.state.budgetProMission?.budgetProStartTab}
                            autoStaff={this.state.budgetProMission?.autoStaff}
                            stateChange={this.state.missionChange}
                            onClose={() => {
                                this.setState({
                                    budgetProMission: false,
                                })
                                if (this.state.budgetProMission?.onClose) {
                                    this.state.budgetProMission.onClose()
                                }
                            }}
                            fetchTimesheets={true}
                        />
                    </ErrorBoundary>
                    {/* ====== Promos ============= */}

                    <ToastContainer
                        closeButton={CloseToast}
                        autoClose={3000}
                        className="toast-the-dna no-blur"
                        position={"top-center"}
                    />
                    <Confirm open={this.state.confirm} {...this.state.confirm} />
                    <NewVersionPill enabled={Boolean(this.state.person?._id)} />
                    {this.state.person?._id && <DemoTourPill />}

                    <ErrorBoundary app={this}>
                        <PanelNotification
                            open={this.state.notificationOpen && this.state.person && this.state.person._id}
                            onClose={() => {
                                this.setState({
                                    notificationOpen: false,
                                })
                            }}
                            app={this}
                        />
                    </ErrorBoundary>

                    {/*Knobs*/}
                    {this.state.person._id &&
                        this.state.person.avatar &&
                        this.state.person.firstName &&
                        !this.state.missionCrud &&
                        !this.state.createProposal &&
                        !this.state.createMission &&
                        !this.state.orgCrud &&
                        !this.state.hideDamKnob &&
                        !this.state.timeForOther && (
                            <>
                                <Navigator app={this} open={this.state.controlPanel} theMiss ionsHaveLanded={true} />
                            </>
                        )}

                    <span
                        className={cx({
                            "dna-dark":
                                darkThemes.includes(this.state.person.theme) &&
                                this.state.home &&
                                !this.state.timeTracking &&
                                !this.state.mission &&
                                !this.state.org &&
                                !this.state.myspace,
                        })}
                    >
                        {/* ++++++++ MY AVATAR */}
                        {state.person?._id && (
                            <>
                                {!this.state.missionCrud &&
                                    !this.state.createProposal &&
                                    !this.state.createMission &&
                                    !this.state.orgCrud &&
                                    !this.state.homeCalendar &&
                                    !this.state.timeTracking &&
                                    !this.state.mission &&
                                    !this.state.hideExtras &&
                                    !this.state.timeForOther && (
                                        <>
                                            {this.state.orgs?.length > 0 && (
                                                <>
                                                    <div
                                                        className="dna-search-trigger"
                                                        onClick={() => {
                                                            this.setState({
                                                                showSearch: true,
                                                            })
                                                        }}
                                                    >
                                                        <Tip title="Find a mission">
                                                            <PiMagnifyingGlassDuotone fontSize={22} />
                                                        </Tip>
                                                    </div>

                                                    <SearchWidget
                                                        open={this.state.showSearch}
                                                        app={this}
                                                        onClose={() => {
                                                            this.setState({
                                                                showSearch: false,
                                                            })
                                                        }}
                                                    />
                                                </>
                                            )}
                                            <div
                                                className="dna-cal-trigger"
                                                onClick={() => {
                                                    this.setState({
                                                        homeCalendar: true,
                                                    })
                                                }}
                                            >
                                                <Tip title="Your assignment calendar">
                                                    <BsCalendar4Week fontSize={19} />
                                                </Tip>
                                            </div>
                                        </>
                                    )}

                                {!this.state.homeCalendar &&
                                    !this.state.timeTracking &&
                                    !this.state.hideAvatar &&
                                    !this.state.timeForOther &&
                                    !this.state.showSearch && (
                                        <>
                                            <div
                                                className="dna-me-avatar"
                                                onMouseOver={() => MySpace.preload()}
                                                onClick={() => {
                                                    removeParams("phase,search-mode")
                                                    addParam("myspace", "open")
                                                }}
                                                style={{ backgroundImage: `url(${this.state.person.avatar})` }}
                                            />
                                        </>
                                    )}

                                {this.state.isUserMxAdmin && (
                                    <FullScreen
                                        style={{ zIndex: 99999 }}
                                        className="dna-dark"
                                        open={this.state.mxAdmin}
                                        onClose={() =>
                                            this.setState({
                                                mxAdmin: false,
                                            })
                                        }
                                    >
                                        <MxAdmin />
                                    </FullScreen>
                                )}

                                {this.state.isUserMxAdmin && (
                                    <FullScreen
                                        style={{ zIndex: 99999 }}
                                        className="dna-dark"
                                        open={this.state.mxCrm}
                                        onClose={() =>
                                            this.setState({
                                                mxCrm: false,
                                            })
                                        }
                                    >
                                        {this.state.mxCrm && <MxCrm />}
                                    </FullScreen>
                                )}

                                {this.state.orgsLoaded &&
                                    !this.state.homeCalendar &&
                                    !this.state.hideExtras &&
                                    !this.state.timeForOther &&
                                    !this.state.hideAdminTools && (
                                        <Tip
                                            className="dna-speed-trigger"
                                            position="left"
                                            interactive
                                            onClick={() => {
                                                if (this.state.orgs.some((o) => o.isLicensedActive)) {
                                                    addParams([
                                                        { param: "time-tracking", value: "open" },
                                                        {
                                                            param: "week",
                                                            value: startOfWeek(new Date(), {
                                                                weekStartsOn: 1,
                                                            }).getTime(),
                                                        },
                                                    ])
                                                } else {
                                                    toast("There are no eligible organizations for Time Tracking. 🍸", {
                                                        autoClose: 10000,
                                                    })
                                                }
                                            }}
                                            html={
                                                <>
                                                    <p>My timesheets 🍸</p>
                                                    {!this.state.orgs.some((o) => o.isLicensedActive) && (
                                                        <>
                                                            <p>
                                                                Requires an{" "}
                                                                <span
                                                                    className="dna-cursor dna-orange-text"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/pricing/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    active subscription
                                                                </span>{" "}
                                                                for one of your organizations
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/time-tracking/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    time tracking
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >

                                                <IconSpeed />

                                        </Tip>
                                    )}
                            </>
                        )}

                        {!this.state.timeTracking &&
                            this.state.orgsLoaded &&
                            !this.state.homeCalendar &&
                            !this.state.hideExtras &&
                            !this.state.timeForOther &&
                            !this.state.hideAdminTools && (
                                <>
                                    <div
                                        className="dna-leave-trigger"
                                        onClick={() => {
                                            if (!this.showLeaveTracking()) {
                                                toast(
                                                    "Requires an organization with an active or trial subscription.🌻",
                                                    {
                                                        autoClose: 10000,
                                                    }
                                                )
                                                return
                                            }

                                            this.setState({
                                                showLeaveTracker: true,
                                            })
                                        }}
                                    >
                                        <Tip
                                            distance={25}
                                            position="left"
                                            interactive={true}
                                            html={
                                                <>
                                                    <p>My leave requests 🌻</p>
                                                    {!this.showLeaveTracking() && (
                                                        <>
                                                            <p>
                                                                Requires an organization with an active or trial
                                                                subscription.
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/leave-tracking/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    leave tracking
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <IconLeave width={25} />
                                        </Tip>
                                    </div>
                                </>
                            )}

                        {this.state.orgsLoaded &&
                            !this.state.timeTracking &&
                            !this.state.homeCalendar &&
                            !this.state.hideExtras &&
                            !this.state.timeForOther &&
                            !this.state.hideAdminTools && (
                                <>
                                    <div
                                        className="x-expense-trigger"
                                        onClick={() => {
                                            if (!this.showExpenseTracking()) {
                                                toast(
                                                    "Requires an organization with an active subscription and expenses enabled 🤷‍♂️",
                                                    {
                                                        autoClose: 10000,
                                                    }
                                                )
                                                return
                                            }

                                            this.setState({
                                                showExpenses: true,
                                            })
                                        }}
                                    >
                                        <Tip
                                            distance={25}
                                            position="left"
                                            html={
                                                <>
                                                    <p>My expenses. Ka-ching 💰</p>
                                                    {!this.showExpenseTracking() && (
                                                        <>
                                                            <p>
                                                                <p>
                                                                    Requires an organization with an active or trial
                                                                    subscription and expense tracking enabled.
                                                                </p>
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/expenses-online/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    submitting expenses
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <BsReceipt />
                                        </Tip>
                                    </div>

                                    <>
                                        {this.state.orgsLoaded && (
                                            <div
                                                className="x-wfh-trigger"
                                                onClick={() => {
                                                    if (this.state.orgs?.length > 0) {
                                                        this.setState({
                                                            showWfh: true,
                                                        })
                                                    } else {
                                                        toast.warning(
                                                            "Please create or join an organization first. Once you're part of an organization, you'll be able to book work-from-home days.",
                                                            { autoClose: 5000 }
                                                        )
                                                    }
                                                }}
                                            >
                                                <Tip
                                                    distance={25}
                                                    interactive
                                                    position="left"
                                                    html={
                                                        <>
                                                            <p>Manage my WFH bookings</p>
                                                        </>
                                                    }
                                                >
                                                    <PiHouseLight width={28} />
                                                </Tip>
                                            </div>
                                        )}
                                        {this.state.orgs.find((o) => o.people?.length) && (
                                            <Card
                                                closeButton
                                                modal
                                                portal
                                                center
                                                autoClose={true}
                                                className="x-wfh-card dna-dark dna-dark-bg"
                                                modalIndex={9998}
                                                modalClass="x-wfh-card-modal"
                                                style={{ width: "96vw", maxWidth: 1200, zIndex: 9999 }}
                                                onClose={() => {
                                                    this.setState({
                                                        showWfh: false,
                                                    })
                                                }}
                                                open={this.state.showWfh}
                                            >
                                                <ErrorBoundary app={this}>
                                                    {this.state.showWfh && <Wfh app={this} />}
                                                </ErrorBoundary>
                                            </Card>
                                        )}

                                        {isOrgAdmin(this) && this.state.orgsLoaded && (
                                            <>
                                                <div
                                                    className="x-org-admin-control"
                                                    onClick={() => {
                                                        if (!this.hasSeenMsg("x-app-ga-2")) {
                                                            this.setUiSeenFlags("x-app-ga-2")
                                                        }

                                                        this.setState({
                                                            showAdminPanel: true,
                                                        })
                                                    }}
                                                >
                                                    <Tip
                                                        position="left"
                                                        distance={25}
                                                        html={
                                                            <>
                                                                <p>Admin panel</p>
                                                            </>
                                                        }
                                                    >
                                                        <PiLightningDuotone />
                                                    </Tip>
                                                </div>
                                                {!this.state.org &&
                                                    !this.state.mission &&
                                                    !this.state.myspace &&
                                                    !this.state.hideAdminTools && (
                                                        <Bubble
                                                            app={this}
                                                            tag="x-app-ga-2"
                                                            x={0}
                                                            y={225}
                                                            top={0}
                                                            right={72}
                                                            delay={0}
                                                            position="fixed"
                                                            arrow={"right"}
                                                            msg={
                                                                <>
                                                                    <p>
                                                                        <b>Admin tasks</b>{" "}
                                                                        <PiLightningDuotone color="rgb(0, 255, 0)" />
                                                                    </p>
                                                                    <p>
                                                                        <p>
                                                                            Add time or leaves for others in the
                                                                            organization
                                                                        </p>
                                                                    </p>
                                                                </>
                                                            }
                                                        />
                                                    )}
                                            </>
                                        )}

                                        {this.state.isUserMxAdmin && (
                                            <div
                                                className="x-mx-admin-panel-control"
                                                onClick={() => {
                                                    this.setState({
                                                        mxAdmin: true,
                                                    })
                                                }}
                                            >
                                                <Tip
                                                    interactive
                                                    position="left"
                                                    html={
                                                        <>
                                                            <p>missionX admin panel</p>
                                                        </>
                                                    }
                                                >
                                                    <PiLockDuotone color="red" />
                                                </Tip>
                                            </div>
                                        )}

                                        {this.state.isUserMxAdmin && (
                                            <div
                                                className="x-mx-crm-panel-control"
                                                onMouseOver={() => MxCrm.preload()}
                                                onClick={() => {
                                                    this.setState({
                                                        mxCrm: true,
                                                    })
                                                }}
                                            >
                                                <Tip
                                                    interactive
                                                    position="left"
                                                    html={
                                                        <>
                                                            <p>MxCrm - signups, licences and spend</p>
                                                        </>
                                                    }
                                                >
                                                    <PiUsersThreeDuotone color="gold" />
                                                </Tip>
                                            </div>
                                        )}
                                    </>
                                </>
                            )}
                    </span>

                    {state.person._id && (
                        <>
                            <FullScreen
                                className="x-tt-fullscreen"
                                param="time-tracking,week"
                                style={{ zIndex: 2 }}
                                closeStyle={{ zIndex: 25 }}
                                open={this.state.timeTracking}
                            >
                                {this.state.timeTracking && (
                                    <ErrorBoundary app={this} context="time-tracking">
                                        <TimeTracking
                                            app={this}
                                            missionChange={this.state.missionChange}
                                            onClose={() => {
                                                removeParams("time-tracking,week")
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>

                            <Card
                                closeButton
                                modal
                                modalIndex={98}
                                center
                                portal
                                padded
                                style={{ minWidth: 500, width: 500, zIndex: 99 }}
                                onClose={() => {
                                    this.setState({
                                        showAdminPanel: false,
                                    })
                                }}
                                open={this.state.showAdminPanel}
                            >
                                {this.state.showAdminPanel && <GeneralAdmin onClose={() => {
                                    this.setState({
                                        showAdminPanel: false,
                                    })
                                }} app={this} />}
                            </Card>

                            <Card

                                modal
                                style={{ zIndex: 9999 }}
                                onClose={() => {
                                    this.setState({
                                        showLeaveTracker: false,
                                    })
                                }}
                                open={this.state.showLeaveTracker}
                                className="dna-center-card x-lt-card"
                            >
                                <ErrorBoundary app={this} context="leave-tracking">
                                    {this.state.showLeaveTracker && (
                                        <LeaveTracker
                                            orgs={this.state.orgs}
                                            app={this}
                                            encryptionKey={this.state.encryptionKey}
                                        />
                                    )}
                                </ErrorBoundary>
                            </Card>

                            <Card
                                closeButton
                                portal
                                draggable
                                modal

                                className="x-expense-tracker-card-me"
                                onClose={() => {
                                    this.state.expensesForOther?.onClose?.()
                                    this.setState({
                                        showExpenses: false,
                                        expensesForOther: null,
                                    })
                                }}
                                open={this.state.showExpenses}
                            >
                                <ErrorBoundary app={this}>
                                    {this.state.showExpenses &&
                                        (this.state.expensesForOther ? (
                                            <ExpenseTrackerMe
                                                hideExtras={true}
                                                app={this}
                                                context="other"
                                                orgContext={this.state.expensesForOther.orgData}
                                                meInOrg={this.state.expensesForOther.meInOrg}
                                            />
                                        ) : (
                                            <ExpenseTrackerMe hideExtras={true} app={this} />
                                        ))}
                                </ErrorBoundary>
                            </Card>

                            {this.state.leavesForOther && (
                                <ErrorBoundary app={this} context="leaves-for-other">
                                    <CreateLeaveForOther
                                        isOpen={true}
                                        orgData={this.state.leavesForOther.orgData}
                                        app={this}
                                        meInOrg={this.state.leavesForOther.meInOrg}
                                        noButton={true}
                                        onClose={() => {
                                            this.setState({ leavesForOther: null })
                                        }}
                                    />
                                </ErrorBoundary>
                            )}
                            {this.state.timeForOther && (
                                <ErrorBoundary app={this} context="time-for-other">
                                    <CreateTimeForOther
                                        isOpen={true}
                                        orgData={this.state.timeForOther.orgData}
                                        app={this}
                                        meInOrg={this.state.timeForOther.meInOrg}
                                        noButton={true}
                                        onClose={() => {
                                            this.setState({ timeForOther: null })
                                        }}
                                    />
                                </ErrorBoundary>
                            )}
                        </>
                    )}

                    {this.state.syncBlocker && (
                        <div
                            className="dna-dark dna-center courier dna-modal "
                            style={{ pointerEvents: "all", zIndex: 99999999 }}
                            onClick={(e) => {
                                e.stopPropagation()
                            }}
                        >
                            Synchronizing your session... one moment please
                        </div>
                    )}
                    <AnimatePresence>
                        {this.state.loadingBlocker && (
                            <motion.div
                                transition={{ duration: 0.2 }}
                                initial={{ opacity: 1 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="dna-center dna-modal dna-main-model"
                                style={{ pointerEvents: "all", zIndex: 99999999 }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                {typeof this.state.loadingBlockerMessage === "string" ? (
                                    <div className="dna-middle-flex" style={{ marginLeft: 40, marginTop: -50 }}>
                                        {this.state.loadingBlockerLoader === "bar" && (
                                            <BarLoader loading color="gray" width={70} />
                                        )}
                                        {this.state.loadingBlockerLoader === "pacman" && (
                                            <PacmanLoader
                                                loading
                                                color="gray"
                                                size={20}
                                                cssOverride={{ marginRight: 40 }}
                                            />
                                        )}
                                        {this.state.loadingBlockerLoader === "rings" && (
                                            <>
                                                <RingLoader loading color="gray" size={40} />
                                            </>
                                        )}
                                        {this.state.loadingBlockerLoader === "rise" && (
                                            <RiseLoader loading color="gray" size={10} />
                                        )}
                                        <div style={{ marginLeft: 20 }}>
                                            <b style={{ marginRight: 8, letterSpacing: 1 }}>
                                                {this.state.loadingBlockerTag}
                                            </b>{" "}
                                            {this.state.loadingBlockerMessage}
                                        </div>
                                    </div>
                                ) : (
                                    this.state.loadingBlockerMessage
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                    {/*----- Search ---------- */}
                    <FullScreen
                        open={this.state.homeCalendar && !this.state.mission}
                        style={{ zIndex: 2 }}
                        closeStyle={{ right: 30 }}
                        onClose={() => {
                            this.setState({
                                homeCalendar: false,
                            })
                        }}
                    >
                        {this.state.homeCalendar && !this.state.mission && (
                            <ErrorBoundary app={this}>
                                <Calendar app={this} />
                            </ErrorBoundary>
                        )}
                    </FullScreen>

                    <div className="dna-app-msg">{this.state.msg}</div>
                </div>

                <div id="mo-fx-root"></div>

                <audio ref={this.msgBeep} style={{ display: "none" }}>
                    <source src="/video/message.mp3" type="audio/mpeg" />
                </audio>
            </>
        )
    }
}

const getActionItemIndexes = (obj, state) => {
    if (!obj) {
        return false
    }

    const isActionItem = obj.actionId
    const theid = isActionItem ? obj.actionId : obj._id

    let missionActionItemIndex

    const missionIndex = state.missions.findIndex((a) => a._id === obj.missionId)

    if (missionIndex === -1) {
        return false
    }

    const missionPhaseIndex = state.missions[missionIndex].planItems.findIndex((a) => a._id === obj.missionPlanId)

    if (missionPhaseIndex === -1) {
        return false
    }
    const missionActionIndex = state.missions[missionIndex].planItems[missionPhaseIndex].actions.findIndex(
        (a) => a._id === theid
    )

    if (missionActionIndex === -1) {
        return false
    }

    if (isActionItem) {
        missionActionItemIndex = state.missions[missionIndex].planItems[missionPhaseIndex].actions[
            missionActionIndex
        ].actionItems.findIndex((a) => a._id === obj._id)
    }

    return {
        missionIndex: missionIndex,
        missionPhaseIndex: missionPhaseIndex,
        missionActionIndex: missionActionIndex,
        missionActionItemIndex: missionActionItemIndex,
    }
}

const CloseToast = ({ closeToast }) => (
    <span className="cursor" onClick={closeToast}>
        <IoClose color="gray" />
    </span>
)

const setCookie = (cname, cvalue, exdays) => {
    const d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = "expires=" + d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=missionx.ai;path=/"
}

const MissionLoader = ({ app }) => {
    const missionRef = useRef()
    const [mission, setMission] = useState()

    const missionHash = useMemo(() => {
        return makeHash(app.state.missions)
    }, [app.state.missions])
    const orgData = mission?.org ? app.state.orgs.find((o) => o._id === getObjectId(mission?.org)) : undefined

    const loadMission = async (missionId) => {
        //Get the full tree
        try {
            const missionArray = await apiMission.streamMissionListTree({
                mission: missionId,
                myMissions: false,
            })

            let missionData = missionArray[0]

            if (!missionData || missionData === "[" || !missionData.projectType) {
                if (!missionData) {
                    const meInOrg = orgData?.people?.find((p) => getRefId(p) === app.state.person._id)

                    if (meInOrg?.permission === 3) {
                        toast.error(
                            "Oops. As an org observer you have access to all organization workspace reports but not the projects. Please ask an admin to grant you more access. ",
                            {
                                autoClose: 9000,
                            }
                        )

                        return
                    }
                }

                toast(
                    "Sorry, I could not access the mission. Please make sure you are on the team and have permission to view.",
                    {
                        autoClose: 5000,
                    }
                )
                app.silentFail("MissionACcess: " + missionId + "-md-")
                removeParam("mission")
                return
            }

            missionData = { ...missionData, fullyLoaded: true }



            app.missionUpdateState(
                missionId,
                missionData,
                () => {
                    setMission(missionData)

                    if (missionData.people.find((p) => getRefId(p) === app.state.person._id)) {
                        const orgId = getObjectId(missionData?.org)

                        // 1. Normalize the panelState to an array for the lookup
                        const panelArray = Array.isArray(app.state.person.panelState) ? app.state.person.panelState : []

                        // 2. Find the existing entry for this Org (the 'rb' replacement)
                        const existingOrgData = panelArray.find((p) => p.orgId === orgId)

                        // If there's no entry for this org yet, we should probably initialize it
                        // rather than returning, otherwise new users won't get "recents".
                        // But keeping your logic: if (!existingOrgData) return;

                        if (!existingOrgData) {
                            return
                        }

                        // 3. Determine which "recent" field to update
                        let rcField = "recentMissions"
                        if (missionData.isProcess && missionData.isTemplate) {
                            rcField = "recentProcesses"
                        } else if (missionData.isProposal && !missionData.isTemplate) {
                            rcField = "recentProposals"
                        } else if (missionData.isTemplate) {
                            rcField = "recentTemplates"
                        }

                        // 4. Handle the array logic
                        let currentRecents = existingOrgData[rcField] || []

                        // If it's already at the top, don't waste an update
                        if (currentRecents[0] === missionId) {
                            return
                        }

                        // 1. Find the item if it exists, or create a new one
                        const updatedRecents = [
                            { id: missionId }, // The new king of the hill
                            ...currentRecents.filter((item) => item?.id && item.id !== missionId),
                        ]
                            .slice(0, 10)
                            .map((item, index) => ({
                                ...item, // Spread to keep any other potential properties
                                id: item.id, // Explicitly ensure id is present
                                sortIndex: index, // The "Magic" that fixes the shuffle
                            }))

                            .map((item, index) => ({
                                ...item,
                                sortIndex: index, // Re-assign indices 0 through 9 based on new positions
                            }))

                        // 5. Fire the update using the helper we converted earlier
                        app.personUpdatePanelState(orgId, { [rcField]: updatedRecents })
                    }

                    //wait for state to catch up
                },
                true
            )
        } catch (e) {
            app.unBlock()
            removeParam("mission")

            toast.error(
                "I could not access this mission. Please make sure you have accepted the invite, are on the team or refersh and try again. help@missionx.ai",
                {
                    autoClose: 5000,
                }
            )
            //removeParam("mission")
            app.silentFail("Mission Error" + e.message)

            return
        }
    }

    useEffect(() => {
        missionRef.current = mission
    }, [mission])

    useEffect(() => {
        if (app.state.mission) {
            const stateMission = missionHash[app.state.mission]

            if (!stateMission || stateMission?.cached || stateMission?.loadedFromOrg || !stateMission.fullyLoaded) {
                loadMission(app.state.mission)
            } else {
                setMission(stateMission)
                setTimeout(() => {
                    loadMission(app.state.mission)
                }, 10)
            }
        } else if (missionRef.current) {
            setMission(null)
            missionRef.current = null
        }
    }, [app.state.mission])

    // Reloading the org data (socket back after a long time offline, accepting an org invite) empties
    // app.state.missions while this panel keeps showing its copy, so edits can't find the mission.
    // Fetch the open mission back into state. Not when the url has already dropped it: a deleted
    // or no longer accessible mission leaves state one render before the panel closes.
    const reloadingMissionRef = useRef(null)

    useEffect(() => {
        const missionId = app.state.mission

        if (
            !missionId ||
            missionRef.current?._id !== missionId ||
            missionHash[missionId] ||
            reloadingMissionRef.current === missionId ||
            getQ().mission !== missionId
        ) {
            return
        }

        reloadingMissionRef.current = missionId
        loadMission(missionId).finally(() => {
            reloadingMissionRef.current = null
        })
    }, [missionHash])

    useEffect(() => {
        const mc = app.state.missionChange

        if (!missionRef.current) {
            return
        }

        if (mc && mc?.missionId === missionRef.current?._id) {
            const stateMission = app.state.missions.find((mm) => mm._id === missionRef.current?._id)

            setMission(stateMission)
        }
    }, [app.state.missionChange.timestamp])

    useDebouncedEffect(
        () => {
            const stateMission = missionHash[missionRef.current?._id]

            // missing = mid reload (see above), keep showing the copy we have
            if (stateMission) {
                setMission(stateMission)
            }
        },
        [orgData],
        400
    )

    return (
        <>
            <FullScreen
                param="mission,mission-tab,make-week,make-phase,action,phase,mission-timeline,budget-bar,powerTab,make-week"
                style={{ zIndex: 6 }}
                open={app.state.mission}
            >

                {mission && (
                    <ErrorBoundary app={app} context={mission.projectType}>
                        {(mission.projectType === "simple" || mission.projectType === "kanban") && (
                            <SimplyX
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                        {mission.projectType === "power" && (
                            <Power
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                        {mission.projectType === "mx-gantt" && (
                            <MxGanttMission
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                    </ErrorBoundary>
                )}
            </FullScreen>
        </>
    )
}

const handleInviteOrgFlow = async ({ token, mergeConfirmation, app }) => {
    const invDetails = await apiOrg.getInviteByToken(token)

    await apiOrg
        .handleInvite(token, {
            mergeConfirmation: mergeConfirmation,
        })
        .then((res) => {
            if (mergeConfirmation) {
                toast.success("Great! Please check invites from your personal workspace.")
                app.loadLatestNotifications()
            }
        })
        .catch((err) => {
            if (err.code === "merge_confirm_required") {
                // Prompt the user to confirm an attempt to merge the two accounts
                // Otherwise they will need to log out and login with the account that corresponds to the invited email.
                // Use to get invite details.
                app.confirm({
                    comp: (
                        <>
                            <p>
                                Hello! Sorry to interrupt, but you followed an invite for:
                                <br /> <span className="dna-hl pink">{invDetails?.inviteeEmail}</span>
                            </p>
                            <p>
                                Would you like us to link this as a secondary account under{" "}
                                <span className="dna-hl mint">{app.state.person.email}</span>?{" "}
                            </p>
                            <p>It makes things easier so you can have one workspace but multiple accounts.</p>
                            <p>Plus, it's safe and convenient.</p>
                        </>
                    ),
                    onYes: () => {
                        handleInviteOrgFlow({ token, mergeConfirmation: true, app })
                    },
                    onNo: () => {
                        window.history.replaceState({}, "", window.location.pathname)
                        toast.warning(
                            "Ok no problem. Please sign out and sign in with  " +
                                invDetails?.inviteeEmail +
                                " to accept the invite.",
                            { autoClose: 6000 }
                        )
                    },
                    onCancel: () => {
                        window.history.replaceState({}, "", window.location.pathname)
                        toast.warning(
                            "Ok no problem. Please sign out and sign in with  " +
                                invDetails?.inviteeEmail +
                                " to accept the invite.",
                            { autoClose: 6000 }
                        )
                    },
                })
            } else if (err.code !== "invite/active-directory") {
                toast.error("Directory account issue: " + err.message)
            }
        })
}
const handleInviteMissionFlow = async ({ token, mergeConfirmation, app }) => {
    const invDetails = await apiMission.getInviteByToken(token)

    await apiMission
        .handleInvite(token, {
            mergeConfirmation: mergeConfirmation,
        })
        .then((res) => {
            if (mergeConfirmation) {
                app.loadLatestNotifications()
                toast.success("Great! Please check invites from your personal workspace.")
            }
        })
        .catch((err) => {
            if (err.code === "merge_confirm_required") {
                // Prompt the user to confirm an attempt to merge the two accounts
                // Otherwise they will need to log out and login with the account that corresponds to the invited email.
                // Use to get invite details.
                app.confirm({
                    comp: (
                        <>
                            <p>
                                Hello! Sorry to interrupt, but you followed an invite for:
                                <br /> <span className="dna-hl pink">{invDetails?.inviteeEmail}</span>
                            </p>
                            <p>
                                Would you like us to link this as a secondary account under{" "}
                                <span className="dna-hl mint">{app.state.person.email}</span>?{" "}
                            </p>
                            <p>It makes things easier so you can have one workspace but multiple accounts.</p>
                            <p>Plus, it's safe and convenient.</p>
                        </>
                    ),
                    onYes: () => {
                        handleInviteMissionFlow({ token, mergeConfirmation: true, app })
                    },
                    onNo: () => {
                        window.history.replaceState({}, "", window.location.pathname)
                        toast.warning(
                            "Ok no problem. Please sign out and sign in with  " +
                                invDetails?.inviteeEmail +
                                " to accept the invite.",
                            { autoClose: 6000 }
                        )
                    },
                    onCancel: () => {
                        window.history.replaceState({}, "", window.location.pathname)
                        toast.warning(
                            "Ok no problem. Please sign out and sign in with  " +
                                invDetails?.inviteeEmail +
                                " to accept the invite.",
                            { autoClose: 6000 }
                        )
                    },
                })
            } else if (err.code !== "invite/active-directory") {
                toast.error("Directory account issue:" + err.message)
            }
        })
}

const handleInvite = async ({ app }) => {
    const q = {
        ...getQ(),
        ...getHash(),
    }

    if (q.token && q.from === "orgInvite") {
        handleInviteOrgFlow({ token: q.token, app })
    } else if (q.token && q.from === "invite") {
        handleInviteMissionFlow({ token: q.token, app })
    }
}

const isOrgAdmin = (app) => {
    const orgs = app.state.orgs.filter((o) => {
        if (!o.isLicensedActive) {
            return false
        }
        const meInOrg = o.people?.find((p) => getRefId(p) === app.state.person._id)

        if (!meInOrg) {
            return false
        }

        if (
            meInOrg.permission === 2 ||
            meInOrg.canApproveLeaves ||
            meInOrg.canApproveCompanyTimesheets ||
            meInOrg.canManagePeople
        ) {
            return true
        }
        return false
    })

    return orgs.length > 0
}

const migratePanelState = (legacyPanelState) => {
    // If there's no byOrg or it's already an array, check if we need to fix inner objects
    if (!legacyPanelState?.byOrg || Array.isArray(legacyPanelState)) {
        return Array.isArray(legacyPanelState) ? legacyPanelState : []
    }

    // Object.entries gives us [orgId, data]
    return Object.entries(legacyPanelState.byOrg).map(([orgId, data], index) => {
        // Helper to transform [ "id1", "id2" ] into [ { id: "id1", sortIndex: 0 }, ... ]
        const addSortIndex = (list) => {
            if (!Array.isArray(list)) return []
            return list.map((item, i) => {
                // If it's already an object with an id, keep the id.
                // Otherwise, assume the item itself is the ID string.
                const id = typeof item === "object" && item !== null ? item.id || item._id : item

                return {
                    id: id,
                    // Use existing sortIndex if it exists, otherwise use current loop index
                    sortIndex: typeof item.sortIndex === "number" ? item.sortIndex : i,
                }
            })
        }

        return {
            orgId: orgId,
            ...data,
            // Explicitly migrate the problematic arrays
            recentMissions: addSortIndex(data.recentMissions),
            recentProposals: addSortIndex(data.recentProposals),
            recentTemplates: addSortIndex(data.recentTemplates),
            recentProcesses: addSortIndex(data.recentProcesses),
            // We keep the parent sortIndex for the orgs themselves too
            sortIndex: data.sortIndex ?? index,
        }
    })
}

App.displayName = "App"

export default App
